/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authLogoutRouteImport } from './routes/(auth)/logout'
import { Route as authPasswordChangeRouteImport } from './routes/(auth)/password-change'
import { Route as authVerifyOtpRouteImport } from './routes/(auth)/verify-otp'
import { Route as legalPrivacyPolicyRouteImport } from './routes/(legal)/privacy-policy'
import { Route as legalTermsOfServiceRouteImport } from './routes/(legal)/terms-of-service'
import { Route as AdminLayoutRouteImport } from './routes/admin/_layout'
import { Route as SupervisorLayoutRouteImport } from './routes/supervisor/_layout'
import { Route as UserLayoutRouteImport } from './routes/user/_layout'
import { Route as authResetPasswordTokenRouteImport } from './routes/(auth)/reset-password.$token'
import { Route as AdminLayoutIndexRouteImport } from './routes/admin/_layout/index'
import { Route as AdminLayoutAttendanceRouteImport } from './routes/admin/_layout/attendance'
import { Route as AdminLayoutAuditLogRouteImport } from './routes/admin/_layout/audit-log'
import { Route as AdminLayoutCalendarRouteImport } from './routes/admin/_layout/calendar'
import { Route as AdminLayoutCrmRouteImport } from './routes/admin/_layout/crm'
import { Route as AdminLayoutDocumentsRouteImport } from './routes/admin/_layout/documents'
import { Route as AdminLayoutExpenseRouteImport } from './routes/admin/_layout/expense'
import { Route as AdminLayoutInventoryRouteImport } from './routes/admin/_layout/inventory'
import { Route as AdminLayoutLeaveRouteImport } from './routes/admin/_layout/leave'
import { Route as AdminLayoutNotificationSettingsRouteImport } from './routes/admin/_layout/notification-settings'
import { Route as AdminLayoutNotificationsRouteImport } from './routes/admin/_layout/notifications'
import { Route as AdminLayoutPayrollRouteImport } from './routes/admin/_layout/payroll'
import { Route as AdminLayoutProfileManagementRouteImport } from './routes/admin/_layout/profile-management'
import { Route as AdminLayoutProjectsRouteImport } from './routes/admin/_layout/projects'
import { Route as AdminLayoutReportsRouteImport } from './routes/admin/_layout/reports'
import { Route as AdminLayoutTasksRouteImport } from './routes/admin/_layout/tasks'
import { Route as AdminLayoutUsersRouteImport } from './routes/admin/_layout/users'
import { Route as SupervisorLayoutIndexRouteImport } from './routes/supervisor/_layout/index'
import { Route as SupervisorLayoutApprovalsRouteImport } from './routes/supervisor/_layout/approvals'
import { Route as SupervisorLayoutNotificationsRouteImport } from './routes/supervisor/_layout/notifications'
import { Route as SupervisorLayoutOvertimeApprovalsRouteImport } from './routes/supervisor/_layout/overtime-approvals'
import { Route as SupervisorLayoutOvertimeRequestsRouteImport } from './routes/supervisor/_layout/overtime-requests'
import { Route as SupervisorLayoutRequestsRouteImport } from './routes/supervisor/_layout/requests'
import { Route as SupervisorLayoutTeamRouteImport } from './routes/supervisor/_layout/team'
import { Route as SupervisorLayoutTeamTimesheetRouteImport } from './routes/supervisor/_layout/team-timesheet'
import { Route as UserLayoutIndexRouteImport } from './routes/user/_layout/index'
import { Route as UserLayoutAttendanceRouteImport } from './routes/user/_layout/attendance'
import { Route as UserLayoutCalendarRouteImport } from './routes/user/_layout/calendar'
import { Route as UserLayoutChangePasswordRouteImport } from './routes/user/_layout/change-password'
import { Route as UserLayoutCrmRouteImport } from './routes/user/_layout/crm'
import { Route as UserLayoutExpenseRouteImport } from './routes/user/_layout/expense'
import { Route as UserLayoutLeaveRouteImport } from './routes/user/_layout/leave'
import { Route as UserLayoutMyActivityRouteImport } from './routes/user/_layout/my-activity'
import { Route as UserLayoutMyProjectsRouteImport } from './routes/user/_layout/my-projects'
import { Route as UserLayoutMyTasksRouteImport } from './routes/user/_layout/my-tasks'
import { Route as UserLayoutNotificationsRouteImport } from './routes/user/_layout/notifications'
import { Route as UserLayoutOvertimeRouteImport } from './routes/user/_layout/overtime'
import { Route as UserLayoutProfileManagementRouteImport } from './routes/user/_layout/profile-management'
import { Route as UserLayoutTeamLeaveRouteImport } from './routes/user/_layout/team-leave'
import { Route as AdminLayoutAttendanceIndexRouteImport } from './routes/admin/_layout/attendance/index'
import { Route as AdminLayoutAttendanceAdjustmentsRouteImport } from './routes/admin/_layout/attendance/adjustments'
import { Route as AdminLayoutAttendanceAssignmentsRouteImport } from './routes/admin/_layout/attendance/assignments'
import { Route as AdminLayoutAttendanceShiftPolicyRouteImport } from './routes/admin/_layout/attendance/shift-policy'
import { Route as AdminLayoutAttendanceShiftsRouteImport } from './routes/admin/_layout/attendance/shifts'
import { Route as AdminLayoutAttendanceTimesheetsRouteImport } from './routes/admin/_layout/attendance/timesheets'
import { Route as AdminLayoutCrmIndexRouteImport } from './routes/admin/_layout/crm/index'
import { Route as AdminLayoutCrmAccountsRouteImport } from './routes/admin/_layout/crm/accounts'
import { Route as AdminLayoutCrmCalendarRouteImport } from './routes/admin/_layout/crm/calendar'
import { Route as AdminLayoutCrmCallsRouteImport } from './routes/admin/_layout/crm/calls'
import { Route as AdminLayoutCrmCasesRouteImport } from './routes/admin/_layout/crm/cases'
import { Route as AdminLayoutCrmContactsRouteImport } from './routes/admin/_layout/crm/contacts'
import { Route as AdminLayoutCrmEmailsRouteImport } from './routes/admin/_layout/crm/emails'
import { Route as AdminLayoutCrmLeadsRouteImport } from './routes/admin/_layout/crm/leads'
import { Route as AdminLayoutCrmMeetingsRouteImport } from './routes/admin/_layout/crm/meetings'
import { Route as AdminLayoutCrmOpportunitiesRouteImport } from './routes/admin/_layout/crm/opportunities'
import { Route as AdminLayoutCrmReportsRouteImport } from './routes/admin/_layout/crm/reports'
import { Route as AdminLayoutCrmTasksRouteImport } from './routes/admin/_layout/crm/tasks'
import { Route as AdminLayoutCrmTeamsRouteImport } from './routes/admin/_layout/crm/teams'
import { Route as AdminLayoutDocumentsIndexRouteImport } from './routes/admin/_layout/documents/index'
import { Route as AdminLayoutDocumentsCompanyRouteImport } from './routes/admin/_layout/documents/company'
import { Route as AdminLayoutDocumentsEmployeeRouteImport } from './routes/admin/_layout/documents/employee'
import { Route as AdminLayoutExpenseIndexRouteImport } from './routes/admin/_layout/expense/index'
import { Route as AdminLayoutExpenseCategoriesRouteImport } from './routes/admin/_layout/expense/categories'
import { Route as AdminLayoutExpenseReportsRouteImport } from './routes/admin/_layout/expense/reports'
import { Route as AdminLayoutExpenseSettingsRouteImport } from './routes/admin/_layout/expense/settings'
import { Route as AdminLayoutInventoryIndexRouteImport } from './routes/admin/_layout/inventory/index'
import { Route as AdminLayoutInventoryAdjustmentsRouteImport } from './routes/admin/_layout/inventory/adjustments'
import { Route as AdminLayoutInventoryAssetIncidentsRouteImport } from './routes/admin/_layout/inventory/asset-incidents'
import { Route as AdminLayoutInventoryAssetItemsRouteImport } from './routes/admin/_layout/inventory/asset-items'
import { Route as AdminLayoutInventoryAssetSafetyInspectionsRouteImport } from './routes/admin/_layout/inventory/asset-safety-inspections'
import { Route as AdminLayoutInventoryBillsRouteImport } from './routes/admin/_layout/inventory/bills'
import { Route as AdminLayoutInventoryCategoriesRouteImport } from './routes/admin/_layout/inventory/categories'
import { Route as AdminLayoutInventoryChallansRouteImport } from './routes/admin/_layout/inventory/challans'
import { Route as AdminLayoutInventoryCollectionsRouteImport } from './routes/admin/_layout/inventory/collections'
import { Route as AdminLayoutInventoryCustomerReturnsRouteImport } from './routes/admin/_layout/inventory/customer-returns'
import { Route as AdminLayoutInventoryDamagesRouteImport } from './routes/admin/_layout/inventory/damages'
import { Route as AdminLayoutInventoryDeliveryOrdersRouteImport } from './routes/admin/_layout/inventory/delivery-orders'
import { Route as AdminLayoutInventoryDeploymentManifestsRouteImport } from './routes/admin/_layout/inventory/deployment-manifests'
import { Route as AdminLayoutInventoryInboundRentalAgreementsRouteImport } from './routes/admin/_layout/inventory/inbound-rental-agreements'
import { Route as AdminLayoutInventoryInspectionChecklistsRouteImport } from './routes/admin/_layout/inventory/inspection-checklists'
import { Route as AdminLayoutInventoryInspectionFrequenciesRouteImport } from './routes/admin/_layout/inventory/inspection-frequencies'
import { Route as AdminLayoutInventoryInspectionsRouteImport } from './routes/admin/_layout/inventory/inspections'
import { Route as AdminLayoutInventoryInvoicesRouteImport } from './routes/admin/_layout/inventory/invoices'
import { Route as AdminLayoutInventoryItemPricesRouteImport } from './routes/admin/_layout/inventory/item-prices'
import { Route as AdminLayoutInventoryItemsRouteImport } from './routes/admin/_layout/inventory/items'
import { Route as AdminLayoutInventoryLabelsRouteImport } from './routes/admin/_layout/inventory/labels'
import { Route as AdminLayoutInventoryPriceBooksRouteImport } from './routes/admin/_layout/inventory/price-books'
import { Route as AdminLayoutInventoryPurchaseOrdersRouteImport } from './routes/admin/_layout/inventory/purchase-orders'
import { Route as AdminLayoutInventoryQuotesRouteImport } from './routes/admin/_layout/inventory/quotes'
import { Route as AdminLayoutInventoryRentalContractsRouteImport } from './routes/admin/_layout/inventory/rental-contracts'
import { Route as AdminLayoutInventoryReportsRouteImport } from './routes/admin/_layout/inventory/reports'
import { Route as AdminLayoutInventoryRequisitionsRouteImport } from './routes/admin/_layout/inventory/requisitions'
import { Route as AdminLayoutInventoryReturnsRouteImport } from './routes/admin/_layout/inventory/returns'
import { Route as AdminLayoutInventorySalesOrdersRouteImport } from './routes/admin/_layout/inventory/sales-orders'
import { Route as AdminLayoutInventorySettingsRouteImport } from './routes/admin/_layout/inventory/settings'
import { Route as AdminLayoutInventoryStockLevelsRouteImport } from './routes/admin/_layout/inventory/stock-levels'
import { Route as AdminLayoutInventorySupplierPricesRouteImport } from './routes/admin/_layout/inventory/supplier-prices'
import { Route as AdminLayoutInventoryTransactionsRouteImport } from './routes/admin/_layout/inventory/transactions'
import { Route as AdminLayoutInventoryTransfersRouteImport } from './routes/admin/_layout/inventory/transfers'
import { Route as AdminLayoutInventoryUnitConversionsRouteImport } from './routes/admin/_layout/inventory/unit-conversions'
import { Route as AdminLayoutInventoryUnitsRouteImport } from './routes/admin/_layout/inventory/units'
import { Route as AdminLayoutInventoryVendorsRouteImport } from './routes/admin/_layout/inventory/vendors'
import { Route as AdminLayoutInventoryWarehousesRouteImport } from './routes/admin/_layout/inventory/warehouses'
import { Route as AdminLayoutLeaveIndexRouteImport } from './routes/admin/_layout/leave/index'
import { Route as AdminLayoutLeaveAccrualLogsRouteImport } from './routes/admin/_layout/leave/accrual-logs'
import { Route as AdminLayoutLeaveAccrualRulesRouteImport } from './routes/admin/_layout/leave/accrual-rules'
import { Route as AdminLayoutLeaveBalancesRouteImport } from './routes/admin/_layout/leave/balances'
import { Route as AdminLayoutLeavePolicyRouteImport } from './routes/admin/_layout/leave/policy'
import { Route as AdminLayoutLeaveRequestsRouteImport } from './routes/admin/_layout/leave/requests'
import { Route as AdminLayoutLeaveTypesRouteImport } from './routes/admin/_layout/leave/types'
import { Route as AdminLayoutOrganizationBranchesRouteImport } from './routes/admin/_layout/organization/branches'
import { Route as AdminLayoutOrganizationDepartmentsRouteImport } from './routes/admin/_layout/organization/departments'
import { Route as AdminLayoutOrganizationDeviceEmployeesRouteImport } from './routes/admin/_layout/organization/device-employees'
import { Route as AdminLayoutOrganizationDevicesRouteImport } from './routes/admin/_layout/organization/devices'
import { Route as AdminLayoutOrganizationFiscalYearsRouteImport } from './routes/admin/_layout/organization/fiscal-years'
import { Route as AdminLayoutOrganizationRolesRouteImport } from './routes/admin/_layout/organization/roles'
import { Route as AdminLayoutOvertimeMonitoringRouteImport } from './routes/admin/_layout/overtime/monitoring'
import { Route as AdminLayoutPayrollIndexRouteImport } from './routes/admin/_layout/payroll/index'
import { Route as AdminLayoutPayrollAdvancesRouteImport } from './routes/admin/_layout/payroll/advances'
import { Route as AdminLayoutPayrollPayslipsRouteImport } from './routes/admin/_layout/payroll/payslips'
import { Route as AdminLayoutPayrollSalariesRouteImport } from './routes/admin/_layout/payroll/salaries'
import { Route as AdminLayoutPayrollSettingsRouteImport } from './routes/admin/_layout/payroll/settings'
import { Route as AdminLayoutPayrollTaxBracketsRouteImport } from './routes/admin/_layout/payroll/tax-brackets'
import { Route as AdminLayoutProjectsIdRouteImport } from './routes/admin/_layout/projects_.$id'
import { Route as AdminLayoutReportsUserIdRouteImport } from './routes/admin/_layout/reports_.$userId'
import { Route as AdminLayoutTasksIdRouteImport } from './routes/admin/_layout/tasks_.$id'
import { Route as AdminLayoutUsersIdRouteImport } from './routes/admin/_layout/users_.$id'
import { Route as SupervisorLayoutApprovalsIdRouteImport } from './routes/supervisor/_layout/approvals_.$id'
import { Route as SupervisorLayoutOvertimeApprovalsIdRouteImport } from './routes/supervisor/_layout/overtime-approvals_.$id'
import { Route as SupervisorLayoutOvertimeRequestsIdRouteImport } from './routes/supervisor/_layout/overtime-requests_.$id'
import { Route as SupervisorLayoutRequestsIdRouteImport } from './routes/supervisor/_layout/requests_.$id'
import { Route as SupervisorLayoutTeamIdRouteImport } from './routes/supervisor/_layout/team_.$id'
import { Route as UserLayoutAttendanceIndexRouteImport } from './routes/user/_layout/attendance/index'
import { Route as UserLayoutAttendanceAdjustmentsRouteImport } from './routes/user/_layout/attendance/adjustments'
import { Route as UserLayoutAttendanceShiftsRouteImport } from './routes/user/_layout/attendance/shifts'
import { Route as UserLayoutAttendanceTimesheetRouteImport } from './routes/user/_layout/attendance/timesheet'
import { Route as UserLayoutCrmAccountsRouteImport } from './routes/user/_layout/crm/accounts'
import { Route as UserLayoutCrmCalendarRouteImport } from './routes/user/_layout/crm/calendar'
import { Route as UserLayoutCrmCallsRouteImport } from './routes/user/_layout/crm/calls'
import { Route as UserLayoutCrmCasesRouteImport } from './routes/user/_layout/crm/cases'
import { Route as UserLayoutCrmContactsRouteImport } from './routes/user/_layout/crm/contacts'
import { Route as UserLayoutCrmEmailsRouteImport } from './routes/user/_layout/crm/emails'
import { Route as UserLayoutCrmLeadsRouteImport } from './routes/user/_layout/crm/leads'
import { Route as UserLayoutCrmMeetingsRouteImport } from './routes/user/_layout/crm/meetings'
import { Route as UserLayoutCrmNoAccessRouteImport } from './routes/user/_layout/crm/no-access'
import { Route as UserLayoutCrmOpportunitiesRouteImport } from './routes/user/_layout/crm/opportunities'
import { Route as UserLayoutCrmReportsRouteImport } from './routes/user/_layout/crm/reports'
import { Route as UserLayoutCrmTasksRouteImport } from './routes/user/_layout/crm/tasks'
import { Route as UserLayoutCrmTeamsRouteImport } from './routes/user/_layout/crm/teams'
import { Route as UserLayoutExpenseIdRouteImport } from './routes/user/_layout/expense_.$id'
import { Route as UserLayoutInventoryDeploymentManifestsRouteImport } from './routes/user/_layout/inventory/deployment-manifests'
import { Route as UserLayoutInventoryRequisitionsRouteImport } from './routes/user/_layout/inventory/requisitions'
import { Route as UserLayoutLeaveIdRouteImport } from './routes/user/_layout/leave_.$id'
import { Route as UserLayoutMyProjectsIdRouteImport } from './routes/user/_layout/my-projects_.$id'
import { Route as UserLayoutMyTasksIdRouteImport } from './routes/user/_layout/my-tasks_.$id'
import { Route as UserLayoutOrganizationDocumentsRouteImport } from './routes/user/_layout/organization/documents'
import { Route as UserLayoutOvertimeIdRouteImport } from './routes/user/_layout/overtime_.$id'
import { Route as AdminLayoutAttendanceTimesheetsUserIdRouteImport } from './routes/admin/_layout/attendance/timesheets_.$userId'
import { Route as AdminLayoutCrmAccountsIdRouteImport } from './routes/admin/_layout/crm/accounts_.$id'
import { Route as AdminLayoutCrmCasesIdRouteImport } from './routes/admin/_layout/crm/cases_.$id'
import { Route as AdminLayoutCrmContactsIdRouteImport } from './routes/admin/_layout/crm/contacts_.$id'
import { Route as AdminLayoutCrmLeadsIdRouteImport } from './routes/admin/_layout/crm/leads_.$id'
import { Route as AdminLayoutCrmOpportunitiesIdRouteImport } from './routes/admin/_layout/crm/opportunities_.$id'
import { Route as AdminLayoutCrmTasksIdRouteImport } from './routes/admin/_layout/crm/tasks_.$id'
import { Route as AdminLayoutExpenseReportsIdRouteImport } from './routes/admin/_layout/expense/reports_.$id'
import { Route as AdminLayoutInventoryAdjustmentsIdRouteImport } from './routes/admin/_layout/inventory/adjustments_.$id'
import { Route as AdminLayoutInventoryAssetItemsIdRouteImport } from './routes/admin/_layout/inventory/asset-items_.$id'
import { Route as AdminLayoutInventoryBillsIdRouteImport } from './routes/admin/_layout/inventory/bills_.$id'
import { Route as AdminLayoutInventoryChallansIdRouteImport } from './routes/admin/_layout/inventory/challans_.$id'
import { Route as AdminLayoutInventoryDamagesIdRouteImport } from './routes/admin/_layout/inventory/damages_.$id'
import { Route as AdminLayoutInventoryDeliveryOrdersIdRouteImport } from './routes/admin/_layout/inventory/delivery-orders_.$id'
import { Route as AdminLayoutInventoryDeploymentManifestsIdRouteImport } from './routes/admin/_layout/inventory/deployment-manifests_.$id'
import { Route as AdminLayoutInventoryInboundRentalAgreementsIdRouteImport } from './routes/admin/_layout/inventory/inbound-rental-agreements_.$id'
import { Route as AdminLayoutInventoryInspectionChecklistsIdRouteImport } from './routes/admin/_layout/inventory/inspection-checklists_.$id'
import { Route as AdminLayoutInventoryInspectionsIdRouteImport } from './routes/admin/_layout/inventory/inspections_.$id'
import { Route as AdminLayoutInventoryInvoicesIdRouteImport } from './routes/admin/_layout/inventory/invoices_.$id'
import { Route as AdminLayoutInventoryItemsIdRouteImport } from './routes/admin/_layout/inventory/items_.$id'
import { Route as AdminLayoutInventoryPriceBooksIdRouteImport } from './routes/admin/_layout/inventory/price-books_.$id'
import { Route as AdminLayoutInventoryPurchaseOrdersIdRouteImport } from './routes/admin/_layout/inventory/purchase-orders_.$id'
import { Route as AdminLayoutInventoryQuotesIdRouteImport } from './routes/admin/_layout/inventory/quotes_.$id'
import { Route as AdminLayoutInventoryRentalContractsIdRouteImport } from './routes/admin/_layout/inventory/rental-contracts_.$id'
import { Route as AdminLayoutInventoryRequisitionsIdRouteImport } from './routes/admin/_layout/inventory/requisitions_.$id'
import { Route as AdminLayoutInventoryReturnsIdRouteImport } from './routes/admin/_layout/inventory/returns_.$id'
import { Route as AdminLayoutInventorySalesOrdersIdRouteImport } from './routes/admin/_layout/inventory/sales-orders_.$id'
import { Route as AdminLayoutInventoryTransfersIdRouteImport } from './routes/admin/_layout/inventory/transfers_.$id'
import { Route as AdminLayoutInventoryVendorsIdRouteImport } from './routes/admin/_layout/inventory/vendors_.$id'
import { Route as AdminLayoutInventoryWarehousesIdRouteImport } from './routes/admin/_layout/inventory/warehouses_.$id'
import { Route as AdminLayoutLeaveBalancesUserIdRouteImport } from './routes/admin/_layout/leave/balances_.$userId'
import { Route as AdminLayoutLeaveRequestsUserIdRouteImport } from './routes/admin/_layout/leave/requests_.$userId'
import { Route as AdminLayoutOvertimeMonitoringIdRouteImport } from './routes/admin/_layout/overtime/monitoring_.$id'
import { Route as AdminLayoutPayrollAdvancesUserIdRouteImport } from './routes/admin/_layout/payroll/advances_.$userId'
import { Route as AdminLayoutPayrollPayslipsUserIdRouteImport } from './routes/admin/_layout/payroll/payslips_.$userId'
import { Route as UserLayoutCrmAccountsIdRouteImport } from './routes/user/_layout/crm/accounts_.$id'
import { Route as UserLayoutCrmCasesIdRouteImport } from './routes/user/_layout/crm/cases_.$id'
import { Route as UserLayoutCrmContactsIdRouteImport } from './routes/user/_layout/crm/contacts_.$id'
import { Route as UserLayoutCrmLeadsIdRouteImport } from './routes/user/_layout/crm/leads_.$id'
import { Route as UserLayoutCrmOpportunitiesIdRouteImport } from './routes/user/_layout/crm/opportunities_.$id'
import { Route as UserLayoutCrmTasksIdRouteImport } from './routes/user/_layout/crm/tasks_.$id'
import { Route as UserLayoutInventoryRequisitionsIdRouteImport } from './routes/user/_layout/inventory/requisitions_.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/(auth)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const authPasswordChangeRoute = authPasswordChangeRouteImport.update({
  id: '/(auth)/password-change',
  path: '/password-change',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyOtpRoute = authVerifyOtpRouteImport.update({
  id: '/(auth)/verify-otp',
  path: '/verify-otp',
  getParentRoute: () => rootRouteImport,
} as any)
const legalPrivacyPolicyRoute = legalPrivacyPolicyRouteImport.update({
  id: '/(legal)/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const legalTermsOfServiceRoute = legalTermsOfServiceRouteImport.update({
  id: '/(legal)/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLayoutRoute = AdminLayoutRouteImport.update({
  id: '/admin/_layout',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SupervisorLayoutRoute = SupervisorLayoutRouteImport.update({
  id: '/supervisor/_layout',
  path: '/supervisor',
  getParentRoute: () => rootRouteImport,
} as any)
const UserLayoutRoute = UserLayoutRouteImport.update({
  id: '/user/_layout',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordTokenRoute = authResetPasswordTokenRouteImport.update({
  id: '/(auth)/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLayoutIndexRoute = AdminLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAttendanceRoute = AdminLayoutAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAuditLogRoute = AdminLayoutAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutCalendarRoute = AdminLayoutCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutCrmRoute = AdminLayoutCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutDocumentsRoute = AdminLayoutDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutExpenseRoute = AdminLayoutExpenseRouteImport.update({
  id: '/expense',
  path: '/expense',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutInventoryRoute = AdminLayoutInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutLeaveRoute = AdminLayoutLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutNotificationSettingsRoute =
  AdminLayoutNotificationSettingsRouteImport.update({
    id: '/notification-settings',
    path: '/notification-settings',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutNotificationsRoute =
  AdminLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutPayrollRoute = AdminLayoutPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutProfileManagementRoute =
  AdminLayoutProfileManagementRouteImport.update({
    id: '/profile-management',
    path: '/profile-management',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutProjectsRoute = AdminLayoutProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutReportsRoute = AdminLayoutReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutTasksRoute = AdminLayoutTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutUsersRoute = AdminLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const SupervisorLayoutIndexRoute = SupervisorLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupervisorLayoutRoute,
} as any)
const SupervisorLayoutApprovalsRoute =
  SupervisorLayoutApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutNotificationsRoute =
  SupervisorLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutOvertimeApprovalsRoute =
  SupervisorLayoutOvertimeApprovalsRouteImport.update({
    id: '/overtime-approvals',
    path: '/overtime-approvals',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutOvertimeRequestsRoute =
  SupervisorLayoutOvertimeRequestsRouteImport.update({
    id: '/overtime-requests',
    path: '/overtime-requests',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutRequestsRoute =
  SupervisorLayoutRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutTeamRoute = SupervisorLayoutTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => SupervisorLayoutRoute,
} as any)
const SupervisorLayoutTeamTimesheetRoute =
  SupervisorLayoutTeamTimesheetRouteImport.update({
    id: '/team-timesheet',
    path: '/team-timesheet',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const UserLayoutIndexRoute = UserLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutAttendanceRoute = UserLayoutAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutCalendarRoute = UserLayoutCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutChangePasswordRoute =
  UserLayoutChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => UserLayoutRoute,
  } as any)
const UserLayoutCrmRoute = UserLayoutCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutExpenseRoute = UserLayoutExpenseRouteImport.update({
  id: '/expense',
  path: '/expense',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutLeaveRoute = UserLayoutLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutMyActivityRoute = UserLayoutMyActivityRouteImport.update({
  id: '/my-activity',
  path: '/my-activity',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutMyProjectsRoute = UserLayoutMyProjectsRouteImport.update({
  id: '/my-projects',
  path: '/my-projects',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutMyTasksRoute = UserLayoutMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutNotificationsRoute = UserLayoutNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutOvertimeRoute = UserLayoutOvertimeRouteImport.update({
  id: '/overtime',
  path: '/overtime',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutProfileManagementRoute =
  UserLayoutProfileManagementRouteImport.update({
    id: '/profile-management',
    path: '/profile-management',
    getParentRoute: () => UserLayoutRoute,
  } as any)
const UserLayoutTeamLeaveRoute = UserLayoutTeamLeaveRouteImport.update({
  id: '/team-leave',
  path: '/team-leave',
  getParentRoute: () => UserLayoutRoute,
} as any)
const AdminLayoutAttendanceIndexRoute =
  AdminLayoutAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutAttendanceAdjustmentsRoute =
  AdminLayoutAttendanceAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutAttendanceAssignmentsRoute =
  AdminLayoutAttendanceAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutAttendanceShiftPolicyRoute =
  AdminLayoutAttendanceShiftPolicyRouteImport.update({
    id: '/shift-policy',
    path: '/shift-policy',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutAttendanceShiftsRoute =
  AdminLayoutAttendanceShiftsRouteImport.update({
    id: '/shifts',
    path: '/shifts',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutAttendanceTimesheetsRoute =
  AdminLayoutAttendanceTimesheetsRouteImport.update({
    id: '/timesheets',
    path: '/timesheets',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutCrmIndexRoute = AdminLayoutCrmIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmAccountsRoute = AdminLayoutCrmAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmCalendarRoute = AdminLayoutCrmCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmCallsRoute = AdminLayoutCrmCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmCasesRoute = AdminLayoutCrmCasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmContactsRoute = AdminLayoutCrmContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmEmailsRoute = AdminLayoutCrmEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmLeadsRoute = AdminLayoutCrmLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmMeetingsRoute = AdminLayoutCrmMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmOpportunitiesRoute =
  AdminLayoutCrmOpportunitiesRouteImport.update({
    id: '/opportunities',
    path: '/opportunities',
    getParentRoute: () => AdminLayoutCrmRoute,
  } as any)
const AdminLayoutCrmReportsRoute = AdminLayoutCrmReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmTasksRoute = AdminLayoutCrmTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmTeamsRoute = AdminLayoutCrmTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutDocumentsIndexRoute =
  AdminLayoutDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutDocumentsRoute,
  } as any)
const AdminLayoutDocumentsCompanyRoute =
  AdminLayoutDocumentsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AdminLayoutDocumentsRoute,
  } as any)
const AdminLayoutDocumentsEmployeeRoute =
  AdminLayoutDocumentsEmployeeRouteImport.update({
    id: '/employee',
    path: '/employee',
    getParentRoute: () => AdminLayoutDocumentsRoute,
  } as any)
const AdminLayoutExpenseIndexRoute = AdminLayoutExpenseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutExpenseRoute,
} as any)
const AdminLayoutExpenseCategoriesRoute =
  AdminLayoutExpenseCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AdminLayoutExpenseRoute,
  } as any)
const AdminLayoutExpenseReportsRoute =
  AdminLayoutExpenseReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AdminLayoutExpenseRoute,
  } as any)
const AdminLayoutExpenseSettingsRoute =
  AdminLayoutExpenseSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminLayoutExpenseRoute,
  } as any)
const AdminLayoutInventoryIndexRoute =
  AdminLayoutInventoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryAdjustmentsRoute =
  AdminLayoutInventoryAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryAssetIncidentsRoute =
  AdminLayoutInventoryAssetIncidentsRouteImport.update({
    id: '/asset-incidents',
    path: '/asset-incidents',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryAssetItemsRoute =
  AdminLayoutInventoryAssetItemsRouteImport.update({
    id: '/asset-items',
    path: '/asset-items',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryAssetSafetyInspectionsRoute =
  AdminLayoutInventoryAssetSafetyInspectionsRouteImport.update({
    id: '/asset-safety-inspections',
    path: '/asset-safety-inspections',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryBillsRoute =
  AdminLayoutInventoryBillsRouteImport.update({
    id: '/bills',
    path: '/bills',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryCategoriesRoute =
  AdminLayoutInventoryCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryChallansRoute =
  AdminLayoutInventoryChallansRouteImport.update({
    id: '/challans',
    path: '/challans',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryCollectionsRoute =
  AdminLayoutInventoryCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryCustomerReturnsRoute =
  AdminLayoutInventoryCustomerReturnsRouteImport.update({
    id: '/customer-returns',
    path: '/customer-returns',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDamagesRoute =
  AdminLayoutInventoryDamagesRouteImport.update({
    id: '/damages',
    path: '/damages',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDeliveryOrdersRoute =
  AdminLayoutInventoryDeliveryOrdersRouteImport.update({
    id: '/delivery-orders',
    path: '/delivery-orders',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDeploymentManifestsRoute =
  AdminLayoutInventoryDeploymentManifestsRouteImport.update({
    id: '/deployment-manifests',
    path: '/deployment-manifests',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInboundRentalAgreementsRoute =
  AdminLayoutInventoryInboundRentalAgreementsRouteImport.update({
    id: '/inbound-rental-agreements',
    path: '/inbound-rental-agreements',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInspectionChecklistsRoute =
  AdminLayoutInventoryInspectionChecklistsRouteImport.update({
    id: '/inspection-checklists',
    path: '/inspection-checklists',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInspectionFrequenciesRoute =
  AdminLayoutInventoryInspectionFrequenciesRouteImport.update({
    id: '/inspection-frequencies',
    path: '/inspection-frequencies',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInspectionsRoute =
  AdminLayoutInventoryInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInvoicesRoute =
  AdminLayoutInventoryInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryItemPricesRoute =
  AdminLayoutInventoryItemPricesRouteImport.update({
    id: '/item-prices',
    path: '/item-prices',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryItemsRoute =
  AdminLayoutInventoryItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryLabelsRoute =
  AdminLayoutInventoryLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryPriceBooksRoute =
  AdminLayoutInventoryPriceBooksRouteImport.update({
    id: '/price-books',
    path: '/price-books',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryPurchaseOrdersRoute =
  AdminLayoutInventoryPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryQuotesRoute =
  AdminLayoutInventoryQuotesRouteImport.update({
    id: '/quotes',
    path: '/quotes',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryRentalContractsRoute =
  AdminLayoutInventoryRentalContractsRouteImport.update({
    id: '/rental-contracts',
    path: '/rental-contracts',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryReportsRoute =
  AdminLayoutInventoryReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryRequisitionsRoute =
  AdminLayoutInventoryRequisitionsRouteImport.update({
    id: '/requisitions',
    path: '/requisitions',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryReturnsRoute =
  AdminLayoutInventoryReturnsRouteImport.update({
    id: '/returns',
    path: '/returns',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventorySalesOrdersRoute =
  AdminLayoutInventorySalesOrdersRouteImport.update({
    id: '/sales-orders',
    path: '/sales-orders',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventorySettingsRoute =
  AdminLayoutInventorySettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryStockLevelsRoute =
  AdminLayoutInventoryStockLevelsRouteImport.update({
    id: '/stock-levels',
    path: '/stock-levels',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventorySupplierPricesRoute =
  AdminLayoutInventorySupplierPricesRouteImport.update({
    id: '/supplier-prices',
    path: '/supplier-prices',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryTransactionsRoute =
  AdminLayoutInventoryTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryTransfersRoute =
  AdminLayoutInventoryTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryUnitConversionsRoute =
  AdminLayoutInventoryUnitConversionsRouteImport.update({
    id: '/unit-conversions',
    path: '/unit-conversions',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryUnitsRoute =
  AdminLayoutInventoryUnitsRouteImport.update({
    id: '/units',
    path: '/units',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryVendorsRoute =
  AdminLayoutInventoryVendorsRouteImport.update({
    id: '/vendors',
    path: '/vendors',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryWarehousesRoute =
  AdminLayoutInventoryWarehousesRouteImport.update({
    id: '/warehouses',
    path: '/warehouses',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutLeaveIndexRoute = AdminLayoutLeaveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutLeaveRoute,
} as any)
const AdminLayoutLeaveAccrualLogsRoute =
  AdminLayoutLeaveAccrualLogsRouteImport.update({
    id: '/accrual-logs',
    path: '/accrual-logs',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutLeaveAccrualRulesRoute =
  AdminLayoutLeaveAccrualRulesRouteImport.update({
    id: '/accrual-rules',
    path: '/accrual-rules',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutLeaveBalancesRoute =
  AdminLayoutLeaveBalancesRouteImport.update({
    id: '/balances',
    path: '/balances',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutLeavePolicyRoute = AdminLayoutLeavePolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => AdminLayoutLeaveRoute,
} as any)
const AdminLayoutLeaveRequestsRoute =
  AdminLayoutLeaveRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutLeaveTypesRoute = AdminLayoutLeaveTypesRouteImport.update({
  id: '/types',
  path: '/types',
  getParentRoute: () => AdminLayoutLeaveRoute,
} as any)
const AdminLayoutOrganizationBranchesRoute =
  AdminLayoutOrganizationBranchesRouteImport.update({
    id: '/organization/branches',
    path: '/organization/branches',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOrganizationDepartmentsRoute =
  AdminLayoutOrganizationDepartmentsRouteImport.update({
    id: '/organization/departments',
    path: '/organization/departments',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOrganizationDeviceEmployeesRoute =
  AdminLayoutOrganizationDeviceEmployeesRouteImport.update({
    id: '/organization/device-employees',
    path: '/organization/device-employees',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOrganizationDevicesRoute =
  AdminLayoutOrganizationDevicesRouteImport.update({
    id: '/organization/devices',
    path: '/organization/devices',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOrganizationFiscalYearsRoute =
  AdminLayoutOrganizationFiscalYearsRouteImport.update({
    id: '/organization/fiscal-years',
    path: '/organization/fiscal-years',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOrganizationRolesRoute =
  AdminLayoutOrganizationRolesRouteImport.update({
    id: '/organization/roles',
    path: '/organization/roles',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutOvertimeMonitoringRoute =
  AdminLayoutOvertimeMonitoringRouteImport.update({
    id: '/overtime/monitoring',
    path: '/overtime/monitoring',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutPayrollIndexRoute = AdminLayoutPayrollIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutPayrollRoute,
} as any)
const AdminLayoutPayrollAdvancesRoute =
  AdminLayoutPayrollAdvancesRouteImport.update({
    id: '/advances',
    path: '/advances',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutPayrollPayslipsRoute =
  AdminLayoutPayrollPayslipsRouteImport.update({
    id: '/payslips',
    path: '/payslips',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutPayrollSalariesRoute =
  AdminLayoutPayrollSalariesRouteImport.update({
    id: '/salaries',
    path: '/salaries',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutPayrollSettingsRoute =
  AdminLayoutPayrollSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutPayrollTaxBracketsRoute =
  AdminLayoutPayrollTaxBracketsRouteImport.update({
    id: '/tax-brackets',
    path: '/tax-brackets',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutProjectsIdRoute = AdminLayoutProjectsIdRouteImport.update({
  id: '/projects_/$id',
  path: '/projects/$id',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutReportsUserIdRoute =
  AdminLayoutReportsUserIdRouteImport.update({
    id: '/reports_/$userId',
    path: '/reports/$userId',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutTasksIdRoute = AdminLayoutTasksIdRouteImport.update({
  id: '/tasks_/$id',
  path: '/tasks/$id',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutUsersIdRoute = AdminLayoutUsersIdRouteImport.update({
  id: '/users_/$id',
  path: '/users/$id',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const SupervisorLayoutApprovalsIdRoute =
  SupervisorLayoutApprovalsIdRouteImport.update({
    id: '/approvals_/$id',
    path: '/approvals/$id',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutOvertimeApprovalsIdRoute =
  SupervisorLayoutOvertimeApprovalsIdRouteImport.update({
    id: '/overtime-approvals_/$id',
    path: '/overtime-approvals/$id',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutOvertimeRequestsIdRoute =
  SupervisorLayoutOvertimeRequestsIdRouteImport.update({
    id: '/overtime-requests_/$id',
    path: '/overtime-requests/$id',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutRequestsIdRoute =
  SupervisorLayoutRequestsIdRouteImport.update({
    id: '/requests_/$id',
    path: '/requests/$id',
    getParentRoute: () => SupervisorLayoutRoute,
  } as any)
const SupervisorLayoutTeamIdRoute = SupervisorLayoutTeamIdRouteImport.update({
  id: '/team_/$id',
  path: '/team/$id',
  getParentRoute: () => SupervisorLayoutRoute,
} as any)
const UserLayoutAttendanceIndexRoute =
  UserLayoutAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => UserLayoutAttendanceRoute,
  } as any)
const UserLayoutAttendanceAdjustmentsRoute =
  UserLayoutAttendanceAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => UserLayoutAttendanceRoute,
  } as any)
const UserLayoutAttendanceShiftsRoute =
  UserLayoutAttendanceShiftsRouteImport.update({
    id: '/shifts',
    path: '/shifts',
    getParentRoute: () => UserLayoutAttendanceRoute,
  } as any)
const UserLayoutAttendanceTimesheetRoute =
  UserLayoutAttendanceTimesheetRouteImport.update({
    id: '/timesheet',
    path: '/timesheet',
    getParentRoute: () => UserLayoutAttendanceRoute,
  } as any)
const UserLayoutCrmAccountsRoute = UserLayoutCrmAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmCalendarRoute = UserLayoutCrmCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmCallsRoute = UserLayoutCrmCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmCasesRoute = UserLayoutCrmCasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmContactsRoute = UserLayoutCrmContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmEmailsRoute = UserLayoutCrmEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmLeadsRoute = UserLayoutCrmLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmMeetingsRoute = UserLayoutCrmMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmNoAccessRoute = UserLayoutCrmNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmOpportunitiesRoute =
  UserLayoutCrmOpportunitiesRouteImport.update({
    id: '/opportunities',
    path: '/opportunities',
    getParentRoute: () => UserLayoutCrmRoute,
  } as any)
const UserLayoutCrmReportsRoute = UserLayoutCrmReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmTasksRoute = UserLayoutCrmTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmTeamsRoute = UserLayoutCrmTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutExpenseIdRoute = UserLayoutExpenseIdRouteImport.update({
  id: '/expense_/$id',
  path: '/expense/$id',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutInventoryDeploymentManifestsRoute =
  UserLayoutInventoryDeploymentManifestsRouteImport.update({
    id: '/inventory/deployment-manifests',
    path: '/inventory/deployment-manifests',
    getParentRoute: () => UserLayoutRoute,
  } as any)
const UserLayoutInventoryRequisitionsRoute =
  UserLayoutInventoryRequisitionsRouteImport.update({
    id: '/inventory/requisitions',
    path: '/inventory/requisitions',
    getParentRoute: () => UserLayoutRoute,
  } as any)
const UserLayoutLeaveIdRoute = UserLayoutLeaveIdRouteImport.update({
  id: '/leave_/$id',
  path: '/leave/$id',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutMyProjectsIdRoute = UserLayoutMyProjectsIdRouteImport.update({
  id: '/my-projects_/$id',
  path: '/my-projects/$id',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutMyTasksIdRoute = UserLayoutMyTasksIdRouteImport.update({
  id: '/my-tasks_/$id',
  path: '/my-tasks/$id',
  getParentRoute: () => UserLayoutRoute,
} as any)
const UserLayoutOrganizationDocumentsRoute =
  UserLayoutOrganizationDocumentsRouteImport.update({
    id: '/organization/documents',
    path: '/organization/documents',
    getParentRoute: () => UserLayoutRoute,
  } as any)
const UserLayoutOvertimeIdRoute = UserLayoutOvertimeIdRouteImport.update({
  id: '/overtime_/$id',
  path: '/overtime/$id',
  getParentRoute: () => UserLayoutRoute,
} as any)
const AdminLayoutAttendanceTimesheetsUserIdRoute =
  AdminLayoutAttendanceTimesheetsUserIdRouteImport.update({
    id: '/timesheets_/$userId',
    path: '/timesheets/$userId',
    getParentRoute: () => AdminLayoutAttendanceRoute,
  } as any)
const AdminLayoutCrmAccountsIdRoute =
  AdminLayoutCrmAccountsIdRouteImport.update({
    id: '/accounts_/$id',
    path: '/accounts/$id',
    getParentRoute: () => AdminLayoutCrmRoute,
  } as any)
const AdminLayoutCrmCasesIdRoute = AdminLayoutCrmCasesIdRouteImport.update({
  id: '/cases_/$id',
  path: '/cases/$id',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmContactsIdRoute =
  AdminLayoutCrmContactsIdRouteImport.update({
    id: '/contacts_/$id',
    path: '/contacts/$id',
    getParentRoute: () => AdminLayoutCrmRoute,
  } as any)
const AdminLayoutCrmLeadsIdRoute = AdminLayoutCrmLeadsIdRouteImport.update({
  id: '/leads_/$id',
  path: '/leads/$id',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutCrmOpportunitiesIdRoute =
  AdminLayoutCrmOpportunitiesIdRouteImport.update({
    id: '/opportunities_/$id',
    path: '/opportunities/$id',
    getParentRoute: () => AdminLayoutCrmRoute,
  } as any)
const AdminLayoutCrmTasksIdRoute = AdminLayoutCrmTasksIdRouteImport.update({
  id: '/tasks_/$id',
  path: '/tasks/$id',
  getParentRoute: () => AdminLayoutCrmRoute,
} as any)
const AdminLayoutExpenseReportsIdRoute =
  AdminLayoutExpenseReportsIdRouteImport.update({
    id: '/reports_/$id',
    path: '/reports/$id',
    getParentRoute: () => AdminLayoutExpenseRoute,
  } as any)
const AdminLayoutInventoryAdjustmentsIdRoute =
  AdminLayoutInventoryAdjustmentsIdRouteImport.update({
    id: '/adjustments_/$id',
    path: '/adjustments/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryAssetItemsIdRoute =
  AdminLayoutInventoryAssetItemsIdRouteImport.update({
    id: '/asset-items_/$id',
    path: '/asset-items/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryBillsIdRoute =
  AdminLayoutInventoryBillsIdRouteImport.update({
    id: '/bills_/$id',
    path: '/bills/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryChallansIdRoute =
  AdminLayoutInventoryChallansIdRouteImport.update({
    id: '/challans_/$id',
    path: '/challans/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDamagesIdRoute =
  AdminLayoutInventoryDamagesIdRouteImport.update({
    id: '/damages_/$id',
    path: '/damages/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDeliveryOrdersIdRoute =
  AdminLayoutInventoryDeliveryOrdersIdRouteImport.update({
    id: '/delivery-orders_/$id',
    path: '/delivery-orders/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryDeploymentManifestsIdRoute =
  AdminLayoutInventoryDeploymentManifestsIdRouteImport.update({
    id: '/deployment-manifests_/$id',
    path: '/deployment-manifests/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInboundRentalAgreementsIdRoute =
  AdminLayoutInventoryInboundRentalAgreementsIdRouteImport.update({
    id: '/inbound-rental-agreements_/$id',
    path: '/inbound-rental-agreements/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInspectionChecklistsIdRoute =
  AdminLayoutInventoryInspectionChecklistsIdRouteImport.update({
    id: '/inspection-checklists_/$id',
    path: '/inspection-checklists/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInspectionsIdRoute =
  AdminLayoutInventoryInspectionsIdRouteImport.update({
    id: '/inspections_/$id',
    path: '/inspections/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryInvoicesIdRoute =
  AdminLayoutInventoryInvoicesIdRouteImport.update({
    id: '/invoices_/$id',
    path: '/invoices/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryItemsIdRoute =
  AdminLayoutInventoryItemsIdRouteImport.update({
    id: '/items_/$id',
    path: '/items/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryPriceBooksIdRoute =
  AdminLayoutInventoryPriceBooksIdRouteImport.update({
    id: '/price-books_/$id',
    path: '/price-books/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryPurchaseOrdersIdRoute =
  AdminLayoutInventoryPurchaseOrdersIdRouteImport.update({
    id: '/purchase-orders_/$id',
    path: '/purchase-orders/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryQuotesIdRoute =
  AdminLayoutInventoryQuotesIdRouteImport.update({
    id: '/quotes_/$id',
    path: '/quotes/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryRentalContractsIdRoute =
  AdminLayoutInventoryRentalContractsIdRouteImport.update({
    id: '/rental-contracts_/$id',
    path: '/rental-contracts/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryRequisitionsIdRoute =
  AdminLayoutInventoryRequisitionsIdRouteImport.update({
    id: '/requisitions_/$id',
    path: '/requisitions/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryReturnsIdRoute =
  AdminLayoutInventoryReturnsIdRouteImport.update({
    id: '/returns_/$id',
    path: '/returns/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventorySalesOrdersIdRoute =
  AdminLayoutInventorySalesOrdersIdRouteImport.update({
    id: '/sales-orders_/$id',
    path: '/sales-orders/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryTransfersIdRoute =
  AdminLayoutInventoryTransfersIdRouteImport.update({
    id: '/transfers_/$id',
    path: '/transfers/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryVendorsIdRoute =
  AdminLayoutInventoryVendorsIdRouteImport.update({
    id: '/vendors_/$id',
    path: '/vendors/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutInventoryWarehousesIdRoute =
  AdminLayoutInventoryWarehousesIdRouteImport.update({
    id: '/warehouses_/$id',
    path: '/warehouses/$id',
    getParentRoute: () => AdminLayoutInventoryRoute,
  } as any)
const AdminLayoutLeaveBalancesUserIdRoute =
  AdminLayoutLeaveBalancesUserIdRouteImport.update({
    id: '/balances_/$userId',
    path: '/balances/$userId',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutLeaveRequestsUserIdRoute =
  AdminLayoutLeaveRequestsUserIdRouteImport.update({
    id: '/requests_/$userId',
    path: '/requests/$userId',
    getParentRoute: () => AdminLayoutLeaveRoute,
  } as any)
const AdminLayoutOvertimeMonitoringIdRoute =
  AdminLayoutOvertimeMonitoringIdRouteImport.update({
    id: '/overtime/monitoring_/$id',
    path: '/overtime/monitoring/$id',
    getParentRoute: () => AdminLayoutRoute,
  } as any)
const AdminLayoutPayrollAdvancesUserIdRoute =
  AdminLayoutPayrollAdvancesUserIdRouteImport.update({
    id: '/advances_/$userId',
    path: '/advances/$userId',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const AdminLayoutPayrollPayslipsUserIdRoute =
  AdminLayoutPayrollPayslipsUserIdRouteImport.update({
    id: '/payslips_/$userId',
    path: '/payslips/$userId',
    getParentRoute: () => AdminLayoutPayrollRoute,
  } as any)
const UserLayoutCrmAccountsIdRoute = UserLayoutCrmAccountsIdRouteImport.update({
  id: '/accounts_/$id',
  path: '/accounts/$id',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmCasesIdRoute = UserLayoutCrmCasesIdRouteImport.update({
  id: '/cases_/$id',
  path: '/cases/$id',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmContactsIdRoute = UserLayoutCrmContactsIdRouteImport.update({
  id: '/contacts_/$id',
  path: '/contacts/$id',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmLeadsIdRoute = UserLayoutCrmLeadsIdRouteImport.update({
  id: '/leads_/$id',
  path: '/leads/$id',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutCrmOpportunitiesIdRoute =
  UserLayoutCrmOpportunitiesIdRouteImport.update({
    id: '/opportunities_/$id',
    path: '/opportunities/$id',
    getParentRoute: () => UserLayoutCrmRoute,
  } as any)
const UserLayoutCrmTasksIdRoute = UserLayoutCrmTasksIdRouteImport.update({
  id: '/tasks_/$id',
  path: '/tasks/$id',
  getParentRoute: () => UserLayoutCrmRoute,
} as any)
const UserLayoutInventoryRequisitionsIdRoute =
  UserLayoutInventoryRequisitionsIdRouteImport.update({
    id: '/inventory/requisitions_/$id',
    path: '/inventory/requisitions/$id',
    getParentRoute: () => UserLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/password-change': typeof authPasswordChangeRoute
  '/verify-otp': typeof authVerifyOtpRoute
  '/privacy-policy': typeof legalPrivacyPolicyRoute
  '/terms-of-service': typeof legalTermsOfServiceRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/supervisor': typeof SupervisorLayoutRouteWithChildren
  '/user': typeof UserLayoutRouteWithChildren
  '/reset-password/$token': typeof authResetPasswordTokenRoute
  '/admin/attendance': typeof AdminLayoutAttendanceRouteWithChildren
  '/admin/audit-log': typeof AdminLayoutAuditLogRoute
  '/admin/calendar': typeof AdminLayoutCalendarRoute
  '/admin/crm': typeof AdminLayoutCrmRouteWithChildren
  '/admin/documents': typeof AdminLayoutDocumentsRouteWithChildren
  '/admin/expense': typeof AdminLayoutExpenseRouteWithChildren
  '/admin/inventory': typeof AdminLayoutInventoryRouteWithChildren
  '/admin/leave': typeof AdminLayoutLeaveRouteWithChildren
  '/admin/notification-settings': typeof AdminLayoutNotificationSettingsRoute
  '/admin/notifications': typeof AdminLayoutNotificationsRoute
  '/admin/payroll': typeof AdminLayoutPayrollRouteWithChildren
  '/admin/profile-management': typeof AdminLayoutProfileManagementRoute
  '/admin/projects': typeof AdminLayoutProjectsRoute
  '/admin/reports': typeof AdminLayoutReportsRoute
  '/admin/tasks': typeof AdminLayoutTasksRoute
  '/admin/users': typeof AdminLayoutUsersRoute
  '/supervisor/approvals': typeof SupervisorLayoutApprovalsRoute
  '/supervisor/notifications': typeof SupervisorLayoutNotificationsRoute
  '/supervisor/overtime-approvals': typeof SupervisorLayoutOvertimeApprovalsRoute
  '/supervisor/overtime-requests': typeof SupervisorLayoutOvertimeRequestsRoute
  '/supervisor/requests': typeof SupervisorLayoutRequestsRoute
  '/supervisor/team': typeof SupervisorLayoutTeamRoute
  '/supervisor/team-timesheet': typeof SupervisorLayoutTeamTimesheetRoute
  '/user/attendance': typeof UserLayoutAttendanceRouteWithChildren
  '/user/calendar': typeof UserLayoutCalendarRoute
  '/user/change-password': typeof UserLayoutChangePasswordRoute
  '/user/crm': typeof UserLayoutCrmRouteWithChildren
  '/user/expense': typeof UserLayoutExpenseRoute
  '/user/leave': typeof UserLayoutLeaveRoute
  '/user/my-activity': typeof UserLayoutMyActivityRoute
  '/user/my-projects': typeof UserLayoutMyProjectsRoute
  '/user/my-tasks': typeof UserLayoutMyTasksRoute
  '/user/notifications': typeof UserLayoutNotificationsRoute
  '/user/overtime': typeof UserLayoutOvertimeRoute
  '/user/profile-management': typeof UserLayoutProfileManagementRoute
  '/user/team-leave': typeof UserLayoutTeamLeaveRoute
  '/admin/': typeof AdminLayoutIndexRoute
  '/supervisor/': typeof SupervisorLayoutIndexRoute
  '/user/': typeof UserLayoutIndexRoute
  '/admin/attendance/adjustments': typeof AdminLayoutAttendanceAdjustmentsRoute
  '/admin/attendance/assignments': typeof AdminLayoutAttendanceAssignmentsRoute
  '/admin/attendance/shift-policy': typeof AdminLayoutAttendanceShiftPolicyRoute
  '/admin/attendance/shifts': typeof AdminLayoutAttendanceShiftsRoute
  '/admin/attendance/timesheets': typeof AdminLayoutAttendanceTimesheetsRoute
  '/admin/crm/accounts': typeof AdminLayoutCrmAccountsRoute
  '/admin/crm/calendar': typeof AdminLayoutCrmCalendarRoute
  '/admin/crm/calls': typeof AdminLayoutCrmCallsRoute
  '/admin/crm/cases': typeof AdminLayoutCrmCasesRoute
  '/admin/crm/contacts': typeof AdminLayoutCrmContactsRoute
  '/admin/crm/emails': typeof AdminLayoutCrmEmailsRoute
  '/admin/crm/leads': typeof AdminLayoutCrmLeadsRoute
  '/admin/crm/meetings': typeof AdminLayoutCrmMeetingsRoute
  '/admin/crm/opportunities': typeof AdminLayoutCrmOpportunitiesRoute
  '/admin/crm/reports': typeof AdminLayoutCrmReportsRoute
  '/admin/crm/tasks': typeof AdminLayoutCrmTasksRoute
  '/admin/crm/teams': typeof AdminLayoutCrmTeamsRoute
  '/admin/documents/company': typeof AdminLayoutDocumentsCompanyRoute
  '/admin/documents/employee': typeof AdminLayoutDocumentsEmployeeRoute
  '/admin/expense/categories': typeof AdminLayoutExpenseCategoriesRoute
  '/admin/expense/reports': typeof AdminLayoutExpenseReportsRoute
  '/admin/expense/settings': typeof AdminLayoutExpenseSettingsRoute
  '/admin/inventory/adjustments': typeof AdminLayoutInventoryAdjustmentsRoute
  '/admin/inventory/asset-incidents': typeof AdminLayoutInventoryAssetIncidentsRoute
  '/admin/inventory/asset-items': typeof AdminLayoutInventoryAssetItemsRoute
  '/admin/inventory/asset-safety-inspections': typeof AdminLayoutInventoryAssetSafetyInspectionsRoute
  '/admin/inventory/bills': typeof AdminLayoutInventoryBillsRoute
  '/admin/inventory/categories': typeof AdminLayoutInventoryCategoriesRoute
  '/admin/inventory/challans': typeof AdminLayoutInventoryChallansRoute
  '/admin/inventory/collections': typeof AdminLayoutInventoryCollectionsRoute
  '/admin/inventory/customer-returns': typeof AdminLayoutInventoryCustomerReturnsRoute
  '/admin/inventory/damages': typeof AdminLayoutInventoryDamagesRoute
  '/admin/inventory/delivery-orders': typeof AdminLayoutInventoryDeliveryOrdersRoute
  '/admin/inventory/deployment-manifests': typeof AdminLayoutInventoryDeploymentManifestsRoute
  '/admin/inventory/inbound-rental-agreements': typeof AdminLayoutInventoryInboundRentalAgreementsRoute
  '/admin/inventory/inspection-checklists': typeof AdminLayoutInventoryInspectionChecklistsRoute
  '/admin/inventory/inspection-frequencies': typeof AdminLayoutInventoryInspectionFrequenciesRoute
  '/admin/inventory/inspections': typeof AdminLayoutInventoryInspectionsRoute
  '/admin/inventory/invoices': typeof AdminLayoutInventoryInvoicesRoute
  '/admin/inventory/item-prices': typeof AdminLayoutInventoryItemPricesRoute
  '/admin/inventory/items': typeof AdminLayoutInventoryItemsRoute
  '/admin/inventory/labels': typeof AdminLayoutInventoryLabelsRoute
  '/admin/inventory/price-books': typeof AdminLayoutInventoryPriceBooksRoute
  '/admin/inventory/purchase-orders': typeof AdminLayoutInventoryPurchaseOrdersRoute
  '/admin/inventory/quotes': typeof AdminLayoutInventoryQuotesRoute
  '/admin/inventory/rental-contracts': typeof AdminLayoutInventoryRentalContractsRoute
  '/admin/inventory/reports': typeof AdminLayoutInventoryReportsRoute
  '/admin/inventory/requisitions': typeof AdminLayoutInventoryRequisitionsRoute
  '/admin/inventory/returns': typeof AdminLayoutInventoryReturnsRoute
  '/admin/inventory/sales-orders': typeof AdminLayoutInventorySalesOrdersRoute
  '/admin/inventory/settings': typeof AdminLayoutInventorySettingsRoute
  '/admin/inventory/stock-levels': typeof AdminLayoutInventoryStockLevelsRoute
  '/admin/inventory/supplier-prices': typeof AdminLayoutInventorySupplierPricesRoute
  '/admin/inventory/transactions': typeof AdminLayoutInventoryTransactionsRoute
  '/admin/inventory/transfers': typeof AdminLayoutInventoryTransfersRoute
  '/admin/inventory/unit-conversions': typeof AdminLayoutInventoryUnitConversionsRoute
  '/admin/inventory/units': typeof AdminLayoutInventoryUnitsRoute
  '/admin/inventory/vendors': typeof AdminLayoutInventoryVendorsRoute
  '/admin/inventory/warehouses': typeof AdminLayoutInventoryWarehousesRoute
  '/admin/leave/accrual-logs': typeof AdminLayoutLeaveAccrualLogsRoute
  '/admin/leave/accrual-rules': typeof AdminLayoutLeaveAccrualRulesRoute
  '/admin/leave/balances': typeof AdminLayoutLeaveBalancesRoute
  '/admin/leave/policy': typeof AdminLayoutLeavePolicyRoute
  '/admin/leave/requests': typeof AdminLayoutLeaveRequestsRoute
  '/admin/leave/types': typeof AdminLayoutLeaveTypesRoute
  '/admin/organization/branches': typeof AdminLayoutOrganizationBranchesRoute
  '/admin/organization/departments': typeof AdminLayoutOrganizationDepartmentsRoute
  '/admin/organization/device-employees': typeof AdminLayoutOrganizationDeviceEmployeesRoute
  '/admin/organization/devices': typeof AdminLayoutOrganizationDevicesRoute
  '/admin/organization/fiscal-years': typeof AdminLayoutOrganizationFiscalYearsRoute
  '/admin/organization/roles': typeof AdminLayoutOrganizationRolesRoute
  '/admin/overtime/monitoring': typeof AdminLayoutOvertimeMonitoringRoute
  '/admin/payroll/advances': typeof AdminLayoutPayrollAdvancesRoute
  '/admin/payroll/payslips': typeof AdminLayoutPayrollPayslipsRoute
  '/admin/payroll/salaries': typeof AdminLayoutPayrollSalariesRoute
  '/admin/payroll/settings': typeof AdminLayoutPayrollSettingsRoute
  '/admin/payroll/tax-brackets': typeof AdminLayoutPayrollTaxBracketsRoute
  '/admin/projects/$id': typeof AdminLayoutProjectsIdRoute
  '/admin/reports/$userId': typeof AdminLayoutReportsUserIdRoute
  '/admin/tasks/$id': typeof AdminLayoutTasksIdRoute
  '/admin/users/$id': typeof AdminLayoutUsersIdRoute
  '/supervisor/approvals/$id': typeof SupervisorLayoutApprovalsIdRoute
  '/supervisor/overtime-approvals/$id': typeof SupervisorLayoutOvertimeApprovalsIdRoute
  '/supervisor/overtime-requests/$id': typeof SupervisorLayoutOvertimeRequestsIdRoute
  '/supervisor/requests/$id': typeof SupervisorLayoutRequestsIdRoute
  '/supervisor/team/$id': typeof SupervisorLayoutTeamIdRoute
  '/user/attendance/adjustments': typeof UserLayoutAttendanceAdjustmentsRoute
  '/user/attendance/shifts': typeof UserLayoutAttendanceShiftsRoute
  '/user/attendance/timesheet': typeof UserLayoutAttendanceTimesheetRoute
  '/user/crm/accounts': typeof UserLayoutCrmAccountsRoute
  '/user/crm/calendar': typeof UserLayoutCrmCalendarRoute
  '/user/crm/calls': typeof UserLayoutCrmCallsRoute
  '/user/crm/cases': typeof UserLayoutCrmCasesRoute
  '/user/crm/contacts': typeof UserLayoutCrmContactsRoute
  '/user/crm/emails': typeof UserLayoutCrmEmailsRoute
  '/user/crm/leads': typeof UserLayoutCrmLeadsRoute
  '/user/crm/meetings': typeof UserLayoutCrmMeetingsRoute
  '/user/crm/no-access': typeof UserLayoutCrmNoAccessRoute
  '/user/crm/opportunities': typeof UserLayoutCrmOpportunitiesRoute
  '/user/crm/reports': typeof UserLayoutCrmReportsRoute
  '/user/crm/tasks': typeof UserLayoutCrmTasksRoute
  '/user/crm/teams': typeof UserLayoutCrmTeamsRoute
  '/user/expense/$id': typeof UserLayoutExpenseIdRoute
  '/user/inventory/deployment-manifests': typeof UserLayoutInventoryDeploymentManifestsRoute
  '/user/inventory/requisitions': typeof UserLayoutInventoryRequisitionsRoute
  '/user/leave/$id': typeof UserLayoutLeaveIdRoute
  '/user/my-projects/$id': typeof UserLayoutMyProjectsIdRoute
  '/user/my-tasks/$id': typeof UserLayoutMyTasksIdRoute
  '/user/organization/documents': typeof UserLayoutOrganizationDocumentsRoute
  '/user/overtime/$id': typeof UserLayoutOvertimeIdRoute
  '/admin/attendance/': typeof AdminLayoutAttendanceIndexRoute
  '/admin/crm/': typeof AdminLayoutCrmIndexRoute
  '/admin/documents/': typeof AdminLayoutDocumentsIndexRoute
  '/admin/expense/': typeof AdminLayoutExpenseIndexRoute
  '/admin/inventory/': typeof AdminLayoutInventoryIndexRoute
  '/admin/leave/': typeof AdminLayoutLeaveIndexRoute
  '/admin/payroll/': typeof AdminLayoutPayrollIndexRoute
  '/user/attendance/': typeof UserLayoutAttendanceIndexRoute
  '/admin/attendance/timesheets/$userId': typeof AdminLayoutAttendanceTimesheetsUserIdRoute
  '/admin/crm/accounts/$id': typeof AdminLayoutCrmAccountsIdRoute
  '/admin/crm/cases/$id': typeof AdminLayoutCrmCasesIdRoute
  '/admin/crm/contacts/$id': typeof AdminLayoutCrmContactsIdRoute
  '/admin/crm/leads/$id': typeof AdminLayoutCrmLeadsIdRoute
  '/admin/crm/opportunities/$id': typeof AdminLayoutCrmOpportunitiesIdRoute
  '/admin/crm/tasks/$id': typeof AdminLayoutCrmTasksIdRoute
  '/admin/expense/reports/$id': typeof AdminLayoutExpenseReportsIdRoute
  '/admin/inventory/adjustments/$id': typeof AdminLayoutInventoryAdjustmentsIdRoute
  '/admin/inventory/asset-items/$id': typeof AdminLayoutInventoryAssetItemsIdRoute
  '/admin/inventory/bills/$id': typeof AdminLayoutInventoryBillsIdRoute
  '/admin/inventory/challans/$id': typeof AdminLayoutInventoryChallansIdRoute
  '/admin/inventory/damages/$id': typeof AdminLayoutInventoryDamagesIdRoute
  '/admin/inventory/delivery-orders/$id': typeof AdminLayoutInventoryDeliveryOrdersIdRoute
  '/admin/inventory/deployment-manifests/$id': typeof AdminLayoutInventoryDeploymentManifestsIdRoute
  '/admin/inventory/inbound-rental-agreements/$id': typeof AdminLayoutInventoryInboundRentalAgreementsIdRoute
  '/admin/inventory/inspection-checklists/$id': typeof AdminLayoutInventoryInspectionChecklistsIdRoute
  '/admin/inventory/inspections/$id': typeof AdminLayoutInventoryInspectionsIdRoute
  '/admin/inventory/invoices/$id': typeof AdminLayoutInventoryInvoicesIdRoute
  '/admin/inventory/items/$id': typeof AdminLayoutInventoryItemsIdRoute
  '/admin/inventory/price-books/$id': typeof AdminLayoutInventoryPriceBooksIdRoute
  '/admin/inventory/purchase-orders/$id': typeof AdminLayoutInventoryPurchaseOrdersIdRoute
  '/admin/inventory/quotes/$id': typeof AdminLayoutInventoryQuotesIdRoute
  '/admin/inventory/rental-contracts/$id': typeof AdminLayoutInventoryRentalContractsIdRoute
  '/admin/inventory/requisitions/$id': typeof AdminLayoutInventoryRequisitionsIdRoute
  '/admin/inventory/returns/$id': typeof AdminLayoutInventoryReturnsIdRoute
  '/admin/inventory/sales-orders/$id': typeof AdminLayoutInventorySalesOrdersIdRoute
  '/admin/inventory/transfers/$id': typeof AdminLayoutInventoryTransfersIdRoute
  '/admin/inventory/vendors/$id': typeof AdminLayoutInventoryVendorsIdRoute
  '/admin/inventory/warehouses/$id': typeof AdminLayoutInventoryWarehousesIdRoute
  '/admin/leave/balances/$userId': typeof AdminLayoutLeaveBalancesUserIdRoute
  '/admin/leave/requests/$userId': typeof AdminLayoutLeaveRequestsUserIdRoute
  '/admin/overtime/monitoring/$id': typeof AdminLayoutOvertimeMonitoringIdRoute
  '/admin/payroll/advances/$userId': typeof AdminLayoutPayrollAdvancesUserIdRoute
  '/admin/payroll/payslips/$userId': typeof AdminLayoutPayrollPayslipsUserIdRoute
  '/user/crm/accounts/$id': typeof UserLayoutCrmAccountsIdRoute
  '/user/crm/cases/$id': typeof UserLayoutCrmCasesIdRoute
  '/user/crm/contacts/$id': typeof UserLayoutCrmContactsIdRoute
  '/user/crm/leads/$id': typeof UserLayoutCrmLeadsIdRoute
  '/user/crm/opportunities/$id': typeof UserLayoutCrmOpportunitiesIdRoute
  '/user/crm/tasks/$id': typeof UserLayoutCrmTasksIdRoute
  '/user/inventory/requisitions/$id': typeof UserLayoutInventoryRequisitionsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/password-change': typeof authPasswordChangeRoute
  '/verify-otp': typeof authVerifyOtpRoute
  '/privacy-policy': typeof legalPrivacyPolicyRoute
  '/terms-of-service': typeof legalTermsOfServiceRoute
  '/reset-password/$token': typeof authResetPasswordTokenRoute
  '/admin/audit-log': typeof AdminLayoutAuditLogRoute
  '/admin/calendar': typeof AdminLayoutCalendarRoute
  '/admin/notification-settings': typeof AdminLayoutNotificationSettingsRoute
  '/admin/notifications': typeof AdminLayoutNotificationsRoute
  '/admin/profile-management': typeof AdminLayoutProfileManagementRoute
  '/admin/projects': typeof AdminLayoutProjectsRoute
  '/admin/reports': typeof AdminLayoutReportsRoute
  '/admin/tasks': typeof AdminLayoutTasksRoute
  '/admin/users': typeof AdminLayoutUsersRoute
  '/supervisor/approvals': typeof SupervisorLayoutApprovalsRoute
  '/supervisor/notifications': typeof SupervisorLayoutNotificationsRoute
  '/supervisor/overtime-approvals': typeof SupervisorLayoutOvertimeApprovalsRoute
  '/supervisor/overtime-requests': typeof SupervisorLayoutOvertimeRequestsRoute
  '/supervisor/requests': typeof SupervisorLayoutRequestsRoute
  '/supervisor/team': typeof SupervisorLayoutTeamRoute
  '/supervisor/team-timesheet': typeof SupervisorLayoutTeamTimesheetRoute
  '/user/calendar': typeof UserLayoutCalendarRoute
  '/user/change-password': typeof UserLayoutChangePasswordRoute
  '/user/crm': typeof UserLayoutCrmRouteWithChildren
  '/user/expense': typeof UserLayoutExpenseRoute
  '/user/leave': typeof UserLayoutLeaveRoute
  '/user/my-activity': typeof UserLayoutMyActivityRoute
  '/user/my-projects': typeof UserLayoutMyProjectsRoute
  '/user/my-tasks': typeof UserLayoutMyTasksRoute
  '/user/notifications': typeof UserLayoutNotificationsRoute
  '/user/overtime': typeof UserLayoutOvertimeRoute
  '/user/profile-management': typeof UserLayoutProfileManagementRoute
  '/user/team-leave': typeof UserLayoutTeamLeaveRoute
  '/admin': typeof AdminLayoutIndexRoute
  '/supervisor': typeof SupervisorLayoutIndexRoute
  '/user': typeof UserLayoutIndexRoute
  '/admin/attendance/adjustments': typeof AdminLayoutAttendanceAdjustmentsRoute
  '/admin/attendance/assignments': typeof AdminLayoutAttendanceAssignmentsRoute
  '/admin/attendance/shift-policy': typeof AdminLayoutAttendanceShiftPolicyRoute
  '/admin/attendance/shifts': typeof AdminLayoutAttendanceShiftsRoute
  '/admin/attendance/timesheets': typeof AdminLayoutAttendanceTimesheetsRoute
  '/admin/crm/accounts': typeof AdminLayoutCrmAccountsRoute
  '/admin/crm/calendar': typeof AdminLayoutCrmCalendarRoute
  '/admin/crm/calls': typeof AdminLayoutCrmCallsRoute
  '/admin/crm/cases': typeof AdminLayoutCrmCasesRoute
  '/admin/crm/contacts': typeof AdminLayoutCrmContactsRoute
  '/admin/crm/emails': typeof AdminLayoutCrmEmailsRoute
  '/admin/crm/leads': typeof AdminLayoutCrmLeadsRoute
  '/admin/crm/meetings': typeof AdminLayoutCrmMeetingsRoute
  '/admin/crm/opportunities': typeof AdminLayoutCrmOpportunitiesRoute
  '/admin/crm/reports': typeof AdminLayoutCrmReportsRoute
  '/admin/crm/tasks': typeof AdminLayoutCrmTasksRoute
  '/admin/crm/teams': typeof AdminLayoutCrmTeamsRoute
  '/admin/documents/company': typeof AdminLayoutDocumentsCompanyRoute
  '/admin/documents/employee': typeof AdminLayoutDocumentsEmployeeRoute
  '/admin/expense/categories': typeof AdminLayoutExpenseCategoriesRoute
  '/admin/expense/reports': typeof AdminLayoutExpenseReportsRoute
  '/admin/expense/settings': typeof AdminLayoutExpenseSettingsRoute
  '/admin/inventory/adjustments': typeof AdminLayoutInventoryAdjustmentsRoute
  '/admin/inventory/asset-incidents': typeof AdminLayoutInventoryAssetIncidentsRoute
  '/admin/inventory/asset-items': typeof AdminLayoutInventoryAssetItemsRoute
  '/admin/inventory/asset-safety-inspections': typeof AdminLayoutInventoryAssetSafetyInspectionsRoute
  '/admin/inventory/bills': typeof AdminLayoutInventoryBillsRoute
  '/admin/inventory/categories': typeof AdminLayoutInventoryCategoriesRoute
  '/admin/inventory/challans': typeof AdminLayoutInventoryChallansRoute
  '/admin/inventory/collections': typeof AdminLayoutInventoryCollectionsRoute
  '/admin/inventory/customer-returns': typeof AdminLayoutInventoryCustomerReturnsRoute
  '/admin/inventory/damages': typeof AdminLayoutInventoryDamagesRoute
  '/admin/inventory/delivery-orders': typeof AdminLayoutInventoryDeliveryOrdersRoute
  '/admin/inventory/deployment-manifests': typeof AdminLayoutInventoryDeploymentManifestsRoute
  '/admin/inventory/inbound-rental-agreements': typeof AdminLayoutInventoryInboundRentalAgreementsRoute
  '/admin/inventory/inspection-checklists': typeof AdminLayoutInventoryInspectionChecklistsRoute
  '/admin/inventory/inspection-frequencies': typeof AdminLayoutInventoryInspectionFrequenciesRoute
  '/admin/inventory/inspections': typeof AdminLayoutInventoryInspectionsRoute
  '/admin/inventory/invoices': typeof AdminLayoutInventoryInvoicesRoute
  '/admin/inventory/item-prices': typeof AdminLayoutInventoryItemPricesRoute
  '/admin/inventory/items': typeof AdminLayoutInventoryItemsRoute
  '/admin/inventory/labels': typeof AdminLayoutInventoryLabelsRoute
  '/admin/inventory/price-books': typeof AdminLayoutInventoryPriceBooksRoute
  '/admin/inventory/purchase-orders': typeof AdminLayoutInventoryPurchaseOrdersRoute
  '/admin/inventory/quotes': typeof AdminLayoutInventoryQuotesRoute
  '/admin/inventory/rental-contracts': typeof AdminLayoutInventoryRentalContractsRoute
  '/admin/inventory/reports': typeof AdminLayoutInventoryReportsRoute
  '/admin/inventory/requisitions': typeof AdminLayoutInventoryRequisitionsRoute
  '/admin/inventory/returns': typeof AdminLayoutInventoryReturnsRoute
  '/admin/inventory/sales-orders': typeof AdminLayoutInventorySalesOrdersRoute
  '/admin/inventory/settings': typeof AdminLayoutInventorySettingsRoute
  '/admin/inventory/stock-levels': typeof AdminLayoutInventoryStockLevelsRoute
  '/admin/inventory/supplier-prices': typeof AdminLayoutInventorySupplierPricesRoute
  '/admin/inventory/transactions': typeof AdminLayoutInventoryTransactionsRoute
  '/admin/inventory/transfers': typeof AdminLayoutInventoryTransfersRoute
  '/admin/inventory/unit-conversions': typeof AdminLayoutInventoryUnitConversionsRoute
  '/admin/inventory/units': typeof AdminLayoutInventoryUnitsRoute
  '/admin/inventory/vendors': typeof AdminLayoutInventoryVendorsRoute
  '/admin/inventory/warehouses': typeof AdminLayoutInventoryWarehousesRoute
  '/admin/leave/accrual-logs': typeof AdminLayoutLeaveAccrualLogsRoute
  '/admin/leave/accrual-rules': typeof AdminLayoutLeaveAccrualRulesRoute
  '/admin/leave/balances': typeof AdminLayoutLeaveBalancesRoute
  '/admin/leave/policy': typeof AdminLayoutLeavePolicyRoute
  '/admin/leave/requests': typeof AdminLayoutLeaveRequestsRoute
  '/admin/leave/types': typeof AdminLayoutLeaveTypesRoute
  '/admin/organization/branches': typeof AdminLayoutOrganizationBranchesRoute
  '/admin/organization/departments': typeof AdminLayoutOrganizationDepartmentsRoute
  '/admin/organization/device-employees': typeof AdminLayoutOrganizationDeviceEmployeesRoute
  '/admin/organization/devices': typeof AdminLayoutOrganizationDevicesRoute
  '/admin/organization/fiscal-years': typeof AdminLayoutOrganizationFiscalYearsRoute
  '/admin/organization/roles': typeof AdminLayoutOrganizationRolesRoute
  '/admin/overtime/monitoring': typeof AdminLayoutOvertimeMonitoringRoute
  '/admin/payroll/advances': typeof AdminLayoutPayrollAdvancesRoute
  '/admin/payroll/payslips': typeof AdminLayoutPayrollPayslipsRoute
  '/admin/payroll/salaries': typeof AdminLayoutPayrollSalariesRoute
  '/admin/payroll/settings': typeof AdminLayoutPayrollSettingsRoute
  '/admin/payroll/tax-brackets': typeof AdminLayoutPayrollTaxBracketsRoute
  '/admin/projects/$id': typeof AdminLayoutProjectsIdRoute
  '/admin/reports/$userId': typeof AdminLayoutReportsUserIdRoute
  '/admin/tasks/$id': typeof AdminLayoutTasksIdRoute
  '/admin/users/$id': typeof AdminLayoutUsersIdRoute
  '/supervisor/approvals/$id': typeof SupervisorLayoutApprovalsIdRoute
  '/supervisor/overtime-approvals/$id': typeof SupervisorLayoutOvertimeApprovalsIdRoute
  '/supervisor/overtime-requests/$id': typeof SupervisorLayoutOvertimeRequestsIdRoute
  '/supervisor/requests/$id': typeof SupervisorLayoutRequestsIdRoute
  '/supervisor/team/$id': typeof SupervisorLayoutTeamIdRoute
  '/user/attendance/adjustments': typeof UserLayoutAttendanceAdjustmentsRoute
  '/user/attendance/shifts': typeof UserLayoutAttendanceShiftsRoute
  '/user/attendance/timesheet': typeof UserLayoutAttendanceTimesheetRoute
  '/user/crm/accounts': typeof UserLayoutCrmAccountsRoute
  '/user/crm/calendar': typeof UserLayoutCrmCalendarRoute
  '/user/crm/calls': typeof UserLayoutCrmCallsRoute
  '/user/crm/cases': typeof UserLayoutCrmCasesRoute
  '/user/crm/contacts': typeof UserLayoutCrmContactsRoute
  '/user/crm/emails': typeof UserLayoutCrmEmailsRoute
  '/user/crm/leads': typeof UserLayoutCrmLeadsRoute
  '/user/crm/meetings': typeof UserLayoutCrmMeetingsRoute
  '/user/crm/no-access': typeof UserLayoutCrmNoAccessRoute
  '/user/crm/opportunities': typeof UserLayoutCrmOpportunitiesRoute
  '/user/crm/reports': typeof UserLayoutCrmReportsRoute
  '/user/crm/tasks': typeof UserLayoutCrmTasksRoute
  '/user/crm/teams': typeof UserLayoutCrmTeamsRoute
  '/user/expense/$id': typeof UserLayoutExpenseIdRoute
  '/user/inventory/deployment-manifests': typeof UserLayoutInventoryDeploymentManifestsRoute
  '/user/inventory/requisitions': typeof UserLayoutInventoryRequisitionsRoute
  '/user/leave/$id': typeof UserLayoutLeaveIdRoute
  '/user/my-projects/$id': typeof UserLayoutMyProjectsIdRoute
  '/user/my-tasks/$id': typeof UserLayoutMyTasksIdRoute
  '/user/organization/documents': typeof UserLayoutOrganizationDocumentsRoute
  '/user/overtime/$id': typeof UserLayoutOvertimeIdRoute
  '/admin/attendance': typeof AdminLayoutAttendanceIndexRoute
  '/admin/crm': typeof AdminLayoutCrmIndexRoute
  '/admin/documents': typeof AdminLayoutDocumentsIndexRoute
  '/admin/expense': typeof AdminLayoutExpenseIndexRoute
  '/admin/inventory': typeof AdminLayoutInventoryIndexRoute
  '/admin/leave': typeof AdminLayoutLeaveIndexRoute
  '/admin/payroll': typeof AdminLayoutPayrollIndexRoute
  '/user/attendance': typeof UserLayoutAttendanceIndexRoute
  '/admin/attendance/timesheets/$userId': typeof AdminLayoutAttendanceTimesheetsUserIdRoute
  '/admin/crm/accounts/$id': typeof AdminLayoutCrmAccountsIdRoute
  '/admin/crm/cases/$id': typeof AdminLayoutCrmCasesIdRoute
  '/admin/crm/contacts/$id': typeof AdminLayoutCrmContactsIdRoute
  '/admin/crm/leads/$id': typeof AdminLayoutCrmLeadsIdRoute
  '/admin/crm/opportunities/$id': typeof AdminLayoutCrmOpportunitiesIdRoute
  '/admin/crm/tasks/$id': typeof AdminLayoutCrmTasksIdRoute
  '/admin/expense/reports/$id': typeof AdminLayoutExpenseReportsIdRoute
  '/admin/inventory/adjustments/$id': typeof AdminLayoutInventoryAdjustmentsIdRoute
  '/admin/inventory/asset-items/$id': typeof AdminLayoutInventoryAssetItemsIdRoute
  '/admin/inventory/bills/$id': typeof AdminLayoutInventoryBillsIdRoute
  '/admin/inventory/challans/$id': typeof AdminLayoutInventoryChallansIdRoute
  '/admin/inventory/damages/$id': typeof AdminLayoutInventoryDamagesIdRoute
  '/admin/inventory/delivery-orders/$id': typeof AdminLayoutInventoryDeliveryOrdersIdRoute
  '/admin/inventory/deployment-manifests/$id': typeof AdminLayoutInventoryDeploymentManifestsIdRoute
  '/admin/inventory/inbound-rental-agreements/$id': typeof AdminLayoutInventoryInboundRentalAgreementsIdRoute
  '/admin/inventory/inspection-checklists/$id': typeof AdminLayoutInventoryInspectionChecklistsIdRoute
  '/admin/inventory/inspections/$id': typeof AdminLayoutInventoryInspectionsIdRoute
  '/admin/inventory/invoices/$id': typeof AdminLayoutInventoryInvoicesIdRoute
  '/admin/inventory/items/$id': typeof AdminLayoutInventoryItemsIdRoute
  '/admin/inventory/price-books/$id': typeof AdminLayoutInventoryPriceBooksIdRoute
  '/admin/inventory/purchase-orders/$id': typeof AdminLayoutInventoryPurchaseOrdersIdRoute
  '/admin/inventory/quotes/$id': typeof AdminLayoutInventoryQuotesIdRoute
  '/admin/inventory/rental-contracts/$id': typeof AdminLayoutInventoryRentalContractsIdRoute
  '/admin/inventory/requisitions/$id': typeof AdminLayoutInventoryRequisitionsIdRoute
  '/admin/inventory/returns/$id': typeof AdminLayoutInventoryReturnsIdRoute
  '/admin/inventory/sales-orders/$id': typeof AdminLayoutInventorySalesOrdersIdRoute
  '/admin/inventory/transfers/$id': typeof AdminLayoutInventoryTransfersIdRoute
  '/admin/inventory/vendors/$id': typeof AdminLayoutInventoryVendorsIdRoute
  '/admin/inventory/warehouses/$id': typeof AdminLayoutInventoryWarehousesIdRoute
  '/admin/leave/balances/$userId': typeof AdminLayoutLeaveBalancesUserIdRoute
  '/admin/leave/requests/$userId': typeof AdminLayoutLeaveRequestsUserIdRoute
  '/admin/overtime/monitoring/$id': typeof AdminLayoutOvertimeMonitoringIdRoute
  '/admin/payroll/advances/$userId': typeof AdminLayoutPayrollAdvancesUserIdRoute
  '/admin/payroll/payslips/$userId': typeof AdminLayoutPayrollPayslipsUserIdRoute
  '/user/crm/accounts/$id': typeof UserLayoutCrmAccountsIdRoute
  '/user/crm/cases/$id': typeof UserLayoutCrmCasesIdRoute
  '/user/crm/contacts/$id': typeof UserLayoutCrmContactsIdRoute
  '/user/crm/leads/$id': typeof UserLayoutCrmLeadsIdRoute
  '/user/crm/opportunities/$id': typeof UserLayoutCrmOpportunitiesIdRoute
  '/user/crm/tasks/$id': typeof UserLayoutCrmTasksIdRoute
  '/user/inventory/requisitions/$id': typeof UserLayoutInventoryRequisitionsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/logout': typeof authLogoutRoute
  '/(auth)/password-change': typeof authPasswordChangeRoute
  '/(auth)/verify-otp': typeof authVerifyOtpRoute
  '/(legal)/privacy-policy': typeof legalPrivacyPolicyRoute
  '/(legal)/terms-of-service': typeof legalTermsOfServiceRoute
  '/admin/_layout': typeof AdminLayoutRouteWithChildren
  '/supervisor/_layout': typeof SupervisorLayoutRouteWithChildren
  '/user/_layout': typeof UserLayoutRouteWithChildren
  '/(auth)/reset-password/$token': typeof authResetPasswordTokenRoute
  '/admin/_layout/attendance': typeof AdminLayoutAttendanceRouteWithChildren
  '/admin/_layout/audit-log': typeof AdminLayoutAuditLogRoute
  '/admin/_layout/calendar': typeof AdminLayoutCalendarRoute
  '/admin/_layout/crm': typeof AdminLayoutCrmRouteWithChildren
  '/admin/_layout/documents': typeof AdminLayoutDocumentsRouteWithChildren
  '/admin/_layout/expense': typeof AdminLayoutExpenseRouteWithChildren
  '/admin/_layout/inventory': typeof AdminLayoutInventoryRouteWithChildren
  '/admin/_layout/leave': typeof AdminLayoutLeaveRouteWithChildren
  '/admin/_layout/notification-settings': typeof AdminLayoutNotificationSettingsRoute
  '/admin/_layout/notifications': typeof AdminLayoutNotificationsRoute
  '/admin/_layout/payroll': typeof AdminLayoutPayrollRouteWithChildren
  '/admin/_layout/profile-management': typeof AdminLayoutProfileManagementRoute
  '/admin/_layout/projects': typeof AdminLayoutProjectsRoute
  '/admin/_layout/reports': typeof AdminLayoutReportsRoute
  '/admin/_layout/tasks': typeof AdminLayoutTasksRoute
  '/admin/_layout/users': typeof AdminLayoutUsersRoute
  '/supervisor/_layout/approvals': typeof SupervisorLayoutApprovalsRoute
  '/supervisor/_layout/notifications': typeof SupervisorLayoutNotificationsRoute
  '/supervisor/_layout/overtime-approvals': typeof SupervisorLayoutOvertimeApprovalsRoute
  '/supervisor/_layout/overtime-requests': typeof SupervisorLayoutOvertimeRequestsRoute
  '/supervisor/_layout/requests': typeof SupervisorLayoutRequestsRoute
  '/supervisor/_layout/team': typeof SupervisorLayoutTeamRoute
  '/supervisor/_layout/team-timesheet': typeof SupervisorLayoutTeamTimesheetRoute
  '/user/_layout/attendance': typeof UserLayoutAttendanceRouteWithChildren
  '/user/_layout/calendar': typeof UserLayoutCalendarRoute
  '/user/_layout/change-password': typeof UserLayoutChangePasswordRoute
  '/user/_layout/crm': typeof UserLayoutCrmRouteWithChildren
  '/user/_layout/expense': typeof UserLayoutExpenseRoute
  '/user/_layout/leave': typeof UserLayoutLeaveRoute
  '/user/_layout/my-activity': typeof UserLayoutMyActivityRoute
  '/user/_layout/my-projects': typeof UserLayoutMyProjectsRoute
  '/user/_layout/my-tasks': typeof UserLayoutMyTasksRoute
  '/user/_layout/notifications': typeof UserLayoutNotificationsRoute
  '/user/_layout/overtime': typeof UserLayoutOvertimeRoute
  '/user/_layout/profile-management': typeof UserLayoutProfileManagementRoute
  '/user/_layout/team-leave': typeof UserLayoutTeamLeaveRoute
  '/admin/_layout/': typeof AdminLayoutIndexRoute
  '/supervisor/_layout/': typeof SupervisorLayoutIndexRoute
  '/user/_layout/': typeof UserLayoutIndexRoute
  '/admin/_layout/attendance/adjustments': typeof AdminLayoutAttendanceAdjustmentsRoute
  '/admin/_layout/attendance/assignments': typeof AdminLayoutAttendanceAssignmentsRoute
  '/admin/_layout/attendance/shift-policy': typeof AdminLayoutAttendanceShiftPolicyRoute
  '/admin/_layout/attendance/shifts': typeof AdminLayoutAttendanceShiftsRoute
  '/admin/_layout/attendance/timesheets': typeof AdminLayoutAttendanceTimesheetsRoute
  '/admin/_layout/crm/accounts': typeof AdminLayoutCrmAccountsRoute
  '/admin/_layout/crm/calendar': typeof AdminLayoutCrmCalendarRoute
  '/admin/_layout/crm/calls': typeof AdminLayoutCrmCallsRoute
  '/admin/_layout/crm/cases': typeof AdminLayoutCrmCasesRoute
  '/admin/_layout/crm/contacts': typeof AdminLayoutCrmContactsRoute
  '/admin/_layout/crm/emails': typeof AdminLayoutCrmEmailsRoute
  '/admin/_layout/crm/leads': typeof AdminLayoutCrmLeadsRoute
  '/admin/_layout/crm/meetings': typeof AdminLayoutCrmMeetingsRoute
  '/admin/_layout/crm/opportunities': typeof AdminLayoutCrmOpportunitiesRoute
  '/admin/_layout/crm/reports': typeof AdminLayoutCrmReportsRoute
  '/admin/_layout/crm/tasks': typeof AdminLayoutCrmTasksRoute
  '/admin/_layout/crm/teams': typeof AdminLayoutCrmTeamsRoute
  '/admin/_layout/documents/company': typeof AdminLayoutDocumentsCompanyRoute
  '/admin/_layout/documents/employee': typeof AdminLayoutDocumentsEmployeeRoute
  '/admin/_layout/expense/categories': typeof AdminLayoutExpenseCategoriesRoute
  '/admin/_layout/expense/reports': typeof AdminLayoutExpenseReportsRoute
  '/admin/_layout/expense/settings': typeof AdminLayoutExpenseSettingsRoute
  '/admin/_layout/inventory/adjustments': typeof AdminLayoutInventoryAdjustmentsRoute
  '/admin/_layout/inventory/asset-incidents': typeof AdminLayoutInventoryAssetIncidentsRoute
  '/admin/_layout/inventory/asset-items': typeof AdminLayoutInventoryAssetItemsRoute
  '/admin/_layout/inventory/asset-safety-inspections': typeof AdminLayoutInventoryAssetSafetyInspectionsRoute
  '/admin/_layout/inventory/bills': typeof AdminLayoutInventoryBillsRoute
  '/admin/_layout/inventory/categories': typeof AdminLayoutInventoryCategoriesRoute
  '/admin/_layout/inventory/challans': typeof AdminLayoutInventoryChallansRoute
  '/admin/_layout/inventory/collections': typeof AdminLayoutInventoryCollectionsRoute
  '/admin/_layout/inventory/customer-returns': typeof AdminLayoutInventoryCustomerReturnsRoute
  '/admin/_layout/inventory/damages': typeof AdminLayoutInventoryDamagesRoute
  '/admin/_layout/inventory/delivery-orders': typeof AdminLayoutInventoryDeliveryOrdersRoute
  '/admin/_layout/inventory/deployment-manifests': typeof AdminLayoutInventoryDeploymentManifestsRoute
  '/admin/_layout/inventory/inbound-rental-agreements': typeof AdminLayoutInventoryInboundRentalAgreementsRoute
  '/admin/_layout/inventory/inspection-checklists': typeof AdminLayoutInventoryInspectionChecklistsRoute
  '/admin/_layout/inventory/inspection-frequencies': typeof AdminLayoutInventoryInspectionFrequenciesRoute
  '/admin/_layout/inventory/inspections': typeof AdminLayoutInventoryInspectionsRoute
  '/admin/_layout/inventory/invoices': typeof AdminLayoutInventoryInvoicesRoute
  '/admin/_layout/inventory/item-prices': typeof AdminLayoutInventoryItemPricesRoute
  '/admin/_layout/inventory/items': typeof AdminLayoutInventoryItemsRoute
  '/admin/_layout/inventory/labels': typeof AdminLayoutInventoryLabelsRoute
  '/admin/_layout/inventory/price-books': typeof AdminLayoutInventoryPriceBooksRoute
  '/admin/_layout/inventory/purchase-orders': typeof AdminLayoutInventoryPurchaseOrdersRoute
  '/admin/_layout/inventory/quotes': typeof AdminLayoutInventoryQuotesRoute
  '/admin/_layout/inventory/rental-contracts': typeof AdminLayoutInventoryRentalContractsRoute
  '/admin/_layout/inventory/reports': typeof AdminLayoutInventoryReportsRoute
  '/admin/_layout/inventory/requisitions': typeof AdminLayoutInventoryRequisitionsRoute
  '/admin/_layout/inventory/returns': typeof AdminLayoutInventoryReturnsRoute
  '/admin/_layout/inventory/sales-orders': typeof AdminLayoutInventorySalesOrdersRoute
  '/admin/_layout/inventory/settings': typeof AdminLayoutInventorySettingsRoute
  '/admin/_layout/inventory/stock-levels': typeof AdminLayoutInventoryStockLevelsRoute
  '/admin/_layout/inventory/supplier-prices': typeof AdminLayoutInventorySupplierPricesRoute
  '/admin/_layout/inventory/transactions': typeof AdminLayoutInventoryTransactionsRoute
  '/admin/_layout/inventory/transfers': typeof AdminLayoutInventoryTransfersRoute
  '/admin/_layout/inventory/unit-conversions': typeof AdminLayoutInventoryUnitConversionsRoute
  '/admin/_layout/inventory/units': typeof AdminLayoutInventoryUnitsRoute
  '/admin/_layout/inventory/vendors': typeof AdminLayoutInventoryVendorsRoute
  '/admin/_layout/inventory/warehouses': typeof AdminLayoutInventoryWarehousesRoute
  '/admin/_layout/leave/accrual-logs': typeof AdminLayoutLeaveAccrualLogsRoute
  '/admin/_layout/leave/accrual-rules': typeof AdminLayoutLeaveAccrualRulesRoute
  '/admin/_layout/leave/balances': typeof AdminLayoutLeaveBalancesRoute
  '/admin/_layout/leave/policy': typeof AdminLayoutLeavePolicyRoute
  '/admin/_layout/leave/requests': typeof AdminLayoutLeaveRequestsRoute
  '/admin/_layout/leave/types': typeof AdminLayoutLeaveTypesRoute
  '/admin/_layout/organization/branches': typeof AdminLayoutOrganizationBranchesRoute
  '/admin/_layout/organization/departments': typeof AdminLayoutOrganizationDepartmentsRoute
  '/admin/_layout/organization/device-employees': typeof AdminLayoutOrganizationDeviceEmployeesRoute
  '/admin/_layout/organization/devices': typeof AdminLayoutOrganizationDevicesRoute
  '/admin/_layout/organization/fiscal-years': typeof AdminLayoutOrganizationFiscalYearsRoute
  '/admin/_layout/organization/roles': typeof AdminLayoutOrganizationRolesRoute
  '/admin/_layout/overtime/monitoring': typeof AdminLayoutOvertimeMonitoringRoute
  '/admin/_layout/payroll/advances': typeof AdminLayoutPayrollAdvancesRoute
  '/admin/_layout/payroll/payslips': typeof AdminLayoutPayrollPayslipsRoute
  '/admin/_layout/payroll/salaries': typeof AdminLayoutPayrollSalariesRoute
  '/admin/_layout/payroll/settings': typeof AdminLayoutPayrollSettingsRoute
  '/admin/_layout/payroll/tax-brackets': typeof AdminLayoutPayrollTaxBracketsRoute
  '/admin/_layout/projects_/$id': typeof AdminLayoutProjectsIdRoute
  '/admin/_layout/reports_/$userId': typeof AdminLayoutReportsUserIdRoute
  '/admin/_layout/tasks_/$id': typeof AdminLayoutTasksIdRoute
  '/admin/_layout/users_/$id': typeof AdminLayoutUsersIdRoute
  '/supervisor/_layout/approvals_/$id': typeof SupervisorLayoutApprovalsIdRoute
  '/supervisor/_layout/overtime-approvals_/$id': typeof SupervisorLayoutOvertimeApprovalsIdRoute
  '/supervisor/_layout/overtime-requests_/$id': typeof SupervisorLayoutOvertimeRequestsIdRoute
  '/supervisor/_layout/requests_/$id': typeof SupervisorLayoutRequestsIdRoute
  '/supervisor/_layout/team_/$id': typeof SupervisorLayoutTeamIdRoute
  '/user/_layout/attendance/adjustments': typeof UserLayoutAttendanceAdjustmentsRoute
  '/user/_layout/attendance/shifts': typeof UserLayoutAttendanceShiftsRoute
  '/user/_layout/attendance/timesheet': typeof UserLayoutAttendanceTimesheetRoute
  '/user/_layout/crm/accounts': typeof UserLayoutCrmAccountsRoute
  '/user/_layout/crm/calendar': typeof UserLayoutCrmCalendarRoute
  '/user/_layout/crm/calls': typeof UserLayoutCrmCallsRoute
  '/user/_layout/crm/cases': typeof UserLayoutCrmCasesRoute
  '/user/_layout/crm/contacts': typeof UserLayoutCrmContactsRoute
  '/user/_layout/crm/emails': typeof UserLayoutCrmEmailsRoute
  '/user/_layout/crm/leads': typeof UserLayoutCrmLeadsRoute
  '/user/_layout/crm/meetings': typeof UserLayoutCrmMeetingsRoute
  '/user/_layout/crm/no-access': typeof UserLayoutCrmNoAccessRoute
  '/user/_layout/crm/opportunities': typeof UserLayoutCrmOpportunitiesRoute
  '/user/_layout/crm/reports': typeof UserLayoutCrmReportsRoute
  '/user/_layout/crm/tasks': typeof UserLayoutCrmTasksRoute
  '/user/_layout/crm/teams': typeof UserLayoutCrmTeamsRoute
  '/user/_layout/expense_/$id': typeof UserLayoutExpenseIdRoute
  '/user/_layout/inventory/deployment-manifests': typeof UserLayoutInventoryDeploymentManifestsRoute
  '/user/_layout/inventory/requisitions': typeof UserLayoutInventoryRequisitionsRoute
  '/user/_layout/leave_/$id': typeof UserLayoutLeaveIdRoute
  '/user/_layout/my-projects_/$id': typeof UserLayoutMyProjectsIdRoute
  '/user/_layout/my-tasks_/$id': typeof UserLayoutMyTasksIdRoute
  '/user/_layout/organization/documents': typeof UserLayoutOrganizationDocumentsRoute
  '/user/_layout/overtime_/$id': typeof UserLayoutOvertimeIdRoute
  '/admin/_layout/attendance/': typeof AdminLayoutAttendanceIndexRoute
  '/admin/_layout/crm/': typeof AdminLayoutCrmIndexRoute
  '/admin/_layout/documents/': typeof AdminLayoutDocumentsIndexRoute
  '/admin/_layout/expense/': typeof AdminLayoutExpenseIndexRoute
  '/admin/_layout/inventory/': typeof AdminLayoutInventoryIndexRoute
  '/admin/_layout/leave/': typeof AdminLayoutLeaveIndexRoute
  '/admin/_layout/payroll/': typeof AdminLayoutPayrollIndexRoute
  '/user/_layout/attendance/': typeof UserLayoutAttendanceIndexRoute
  '/admin/_layout/attendance/timesheets_/$userId': typeof AdminLayoutAttendanceTimesheetsUserIdRoute
  '/admin/_layout/crm/accounts_/$id': typeof AdminLayoutCrmAccountsIdRoute
  '/admin/_layout/crm/cases_/$id': typeof AdminLayoutCrmCasesIdRoute
  '/admin/_layout/crm/contacts_/$id': typeof AdminLayoutCrmContactsIdRoute
  '/admin/_layout/crm/leads_/$id': typeof AdminLayoutCrmLeadsIdRoute
  '/admin/_layout/crm/opportunities_/$id': typeof AdminLayoutCrmOpportunitiesIdRoute
  '/admin/_layout/crm/tasks_/$id': typeof AdminLayoutCrmTasksIdRoute
  '/admin/_layout/expense/reports_/$id': typeof AdminLayoutExpenseReportsIdRoute
  '/admin/_layout/inventory/adjustments_/$id': typeof AdminLayoutInventoryAdjustmentsIdRoute
  '/admin/_layout/inventory/asset-items_/$id': typeof AdminLayoutInventoryAssetItemsIdRoute
  '/admin/_layout/inventory/bills_/$id': typeof AdminLayoutInventoryBillsIdRoute
  '/admin/_layout/inventory/challans_/$id': typeof AdminLayoutInventoryChallansIdRoute
  '/admin/_layout/inventory/damages_/$id': typeof AdminLayoutInventoryDamagesIdRoute
  '/admin/_layout/inventory/delivery-orders_/$id': typeof AdminLayoutInventoryDeliveryOrdersIdRoute
  '/admin/_layout/inventory/deployment-manifests_/$id': typeof AdminLayoutInventoryDeploymentManifestsIdRoute
  '/admin/_layout/inventory/inbound-rental-agreements_/$id': typeof AdminLayoutInventoryInboundRentalAgreementsIdRoute
  '/admin/_layout/inventory/inspection-checklists_/$id': typeof AdminLayoutInventoryInspectionChecklistsIdRoute
  '/admin/_layout/inventory/inspections_/$id': typeof AdminLayoutInventoryInspectionsIdRoute
  '/admin/_layout/inventory/invoices_/$id': typeof AdminLayoutInventoryInvoicesIdRoute
  '/admin/_layout/inventory/items_/$id': typeof AdminLayoutInventoryItemsIdRoute
  '/admin/_layout/inventory/price-books_/$id': typeof AdminLayoutInventoryPriceBooksIdRoute
  '/admin/_layout/inventory/purchase-orders_/$id': typeof AdminLayoutInventoryPurchaseOrdersIdRoute
  '/admin/_layout/inventory/quotes_/$id': typeof AdminLayoutInventoryQuotesIdRoute
  '/admin/_layout/inventory/rental-contracts_/$id': typeof AdminLayoutInventoryRentalContractsIdRoute
  '/admin/_layout/inventory/requisitions_/$id': typeof AdminLayoutInventoryRequisitionsIdRoute
  '/admin/_layout/inventory/returns_/$id': typeof AdminLayoutInventoryReturnsIdRoute
  '/admin/_layout/inventory/sales-orders_/$id': typeof AdminLayoutInventorySalesOrdersIdRoute
  '/admin/_layout/inventory/transfers_/$id': typeof AdminLayoutInventoryTransfersIdRoute
  '/admin/_layout/inventory/vendors_/$id': typeof AdminLayoutInventoryVendorsIdRoute
  '/admin/_layout/inventory/warehouses_/$id': typeof AdminLayoutInventoryWarehousesIdRoute
  '/admin/_layout/leave/balances_/$userId': typeof AdminLayoutLeaveBalancesUserIdRoute
  '/admin/_layout/leave/requests_/$userId': typeof AdminLayoutLeaveRequestsUserIdRoute
  '/admin/_layout/overtime/monitoring_/$id': typeof AdminLayoutOvertimeMonitoringIdRoute
  '/admin/_layout/payroll/advances_/$userId': typeof AdminLayoutPayrollAdvancesUserIdRoute
  '/admin/_layout/payroll/payslips_/$userId': typeof AdminLayoutPayrollPayslipsUserIdRoute
  '/user/_layout/crm/accounts_/$id': typeof UserLayoutCrmAccountsIdRoute
  '/user/_layout/crm/cases_/$id': typeof UserLayoutCrmCasesIdRoute
  '/user/_layout/crm/contacts_/$id': typeof UserLayoutCrmContactsIdRoute
  '/user/_layout/crm/leads_/$id': typeof UserLayoutCrmLeadsIdRoute
  '/user/_layout/crm/opportunities_/$id': typeof UserLayoutCrmOpportunitiesIdRoute
  '/user/_layout/crm/tasks_/$id': typeof UserLayoutCrmTasksIdRoute
  '/user/_layout/inventory/requisitions_/$id': typeof UserLayoutInventoryRequisitionsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unauthorized'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/password-change'
    | '/verify-otp'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/admin'
    | '/supervisor'
    | '/user'
    | '/reset-password/$token'
    | '/admin/attendance'
    | '/admin/audit-log'
    | '/admin/calendar'
    | '/admin/crm'
    | '/admin/documents'
    | '/admin/expense'
    | '/admin/inventory'
    | '/admin/leave'
    | '/admin/notification-settings'
    | '/admin/notifications'
    | '/admin/payroll'
    | '/admin/profile-management'
    | '/admin/projects'
    | '/admin/reports'
    | '/admin/tasks'
    | '/admin/users'
    | '/supervisor/approvals'
    | '/supervisor/notifications'
    | '/supervisor/overtime-approvals'
    | '/supervisor/overtime-requests'
    | '/supervisor/requests'
    | '/supervisor/team'
    | '/supervisor/team-timesheet'
    | '/user/attendance'
    | '/user/calendar'
    | '/user/change-password'
    | '/user/crm'
    | '/user/expense'
    | '/user/leave'
    | '/user/my-activity'
    | '/user/my-projects'
    | '/user/my-tasks'
    | '/user/notifications'
    | '/user/overtime'
    | '/user/profile-management'
    | '/user/team-leave'
    | '/admin/'
    | '/supervisor/'
    | '/user/'
    | '/admin/attendance/adjustments'
    | '/admin/attendance/assignments'
    | '/admin/attendance/shift-policy'
    | '/admin/attendance/shifts'
    | '/admin/attendance/timesheets'
    | '/admin/crm/accounts'
    | '/admin/crm/calendar'
    | '/admin/crm/calls'
    | '/admin/crm/cases'
    | '/admin/crm/contacts'
    | '/admin/crm/emails'
    | '/admin/crm/leads'
    | '/admin/crm/meetings'
    | '/admin/crm/opportunities'
    | '/admin/crm/reports'
    | '/admin/crm/tasks'
    | '/admin/crm/teams'
    | '/admin/documents/company'
    | '/admin/documents/employee'
    | '/admin/expense/categories'
    | '/admin/expense/reports'
    | '/admin/expense/settings'
    | '/admin/inventory/adjustments'
    | '/admin/inventory/asset-incidents'
    | '/admin/inventory/asset-items'
    | '/admin/inventory/asset-safety-inspections'
    | '/admin/inventory/bills'
    | '/admin/inventory/categories'
    | '/admin/inventory/challans'
    | '/admin/inventory/collections'
    | '/admin/inventory/customer-returns'
    | '/admin/inventory/damages'
    | '/admin/inventory/delivery-orders'
    | '/admin/inventory/deployment-manifests'
    | '/admin/inventory/inbound-rental-agreements'
    | '/admin/inventory/inspection-checklists'
    | '/admin/inventory/inspection-frequencies'
    | '/admin/inventory/inspections'
    | '/admin/inventory/invoices'
    | '/admin/inventory/item-prices'
    | '/admin/inventory/items'
    | '/admin/inventory/labels'
    | '/admin/inventory/price-books'
    | '/admin/inventory/purchase-orders'
    | '/admin/inventory/quotes'
    | '/admin/inventory/rental-contracts'
    | '/admin/inventory/reports'
    | '/admin/inventory/requisitions'
    | '/admin/inventory/returns'
    | '/admin/inventory/sales-orders'
    | '/admin/inventory/settings'
    | '/admin/inventory/stock-levels'
    | '/admin/inventory/supplier-prices'
    | '/admin/inventory/transactions'
    | '/admin/inventory/transfers'
    | '/admin/inventory/unit-conversions'
    | '/admin/inventory/units'
    | '/admin/inventory/vendors'
    | '/admin/inventory/warehouses'
    | '/admin/leave/accrual-logs'
    | '/admin/leave/accrual-rules'
    | '/admin/leave/balances'
    | '/admin/leave/policy'
    | '/admin/leave/requests'
    | '/admin/leave/types'
    | '/admin/organization/branches'
    | '/admin/organization/departments'
    | '/admin/organization/device-employees'
    | '/admin/organization/devices'
    | '/admin/organization/fiscal-years'
    | '/admin/organization/roles'
    | '/admin/overtime/monitoring'
    | '/admin/payroll/advances'
    | '/admin/payroll/payslips'
    | '/admin/payroll/salaries'
    | '/admin/payroll/settings'
    | '/admin/payroll/tax-brackets'
    | '/admin/projects/$id'
    | '/admin/reports/$userId'
    | '/admin/tasks/$id'
    | '/admin/users/$id'
    | '/supervisor/approvals/$id'
    | '/supervisor/overtime-approvals/$id'
    | '/supervisor/overtime-requests/$id'
    | '/supervisor/requests/$id'
    | '/supervisor/team/$id'
    | '/user/attendance/adjustments'
    | '/user/attendance/shifts'
    | '/user/attendance/timesheet'
    | '/user/crm/accounts'
    | '/user/crm/calendar'
    | '/user/crm/calls'
    | '/user/crm/cases'
    | '/user/crm/contacts'
    | '/user/crm/emails'
    | '/user/crm/leads'
    | '/user/crm/meetings'
    | '/user/crm/no-access'
    | '/user/crm/opportunities'
    | '/user/crm/reports'
    | '/user/crm/tasks'
    | '/user/crm/teams'
    | '/user/expense/$id'
    | '/user/inventory/deployment-manifests'
    | '/user/inventory/requisitions'
    | '/user/leave/$id'
    | '/user/my-projects/$id'
    | '/user/my-tasks/$id'
    | '/user/organization/documents'
    | '/user/overtime/$id'
    | '/admin/attendance/'
    | '/admin/crm/'
    | '/admin/documents/'
    | '/admin/expense/'
    | '/admin/inventory/'
    | '/admin/leave/'
    | '/admin/payroll/'
    | '/user/attendance/'
    | '/admin/attendance/timesheets/$userId'
    | '/admin/crm/accounts/$id'
    | '/admin/crm/cases/$id'
    | '/admin/crm/contacts/$id'
    | '/admin/crm/leads/$id'
    | '/admin/crm/opportunities/$id'
    | '/admin/crm/tasks/$id'
    | '/admin/expense/reports/$id'
    | '/admin/inventory/adjustments/$id'
    | '/admin/inventory/asset-items/$id'
    | '/admin/inventory/bills/$id'
    | '/admin/inventory/challans/$id'
    | '/admin/inventory/damages/$id'
    | '/admin/inventory/delivery-orders/$id'
    | '/admin/inventory/deployment-manifests/$id'
    | '/admin/inventory/inbound-rental-agreements/$id'
    | '/admin/inventory/inspection-checklists/$id'
    | '/admin/inventory/inspections/$id'
    | '/admin/inventory/invoices/$id'
    | '/admin/inventory/items/$id'
    | '/admin/inventory/price-books/$id'
    | '/admin/inventory/purchase-orders/$id'
    | '/admin/inventory/quotes/$id'
    | '/admin/inventory/rental-contracts/$id'
    | '/admin/inventory/requisitions/$id'
    | '/admin/inventory/returns/$id'
    | '/admin/inventory/sales-orders/$id'
    | '/admin/inventory/transfers/$id'
    | '/admin/inventory/vendors/$id'
    | '/admin/inventory/warehouses/$id'
    | '/admin/leave/balances/$userId'
    | '/admin/leave/requests/$userId'
    | '/admin/overtime/monitoring/$id'
    | '/admin/payroll/advances/$userId'
    | '/admin/payroll/payslips/$userId'
    | '/user/crm/accounts/$id'
    | '/user/crm/cases/$id'
    | '/user/crm/contacts/$id'
    | '/user/crm/leads/$id'
    | '/user/crm/opportunities/$id'
    | '/user/crm/tasks/$id'
    | '/user/inventory/requisitions/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unauthorized'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/password-change'
    | '/verify-otp'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/reset-password/$token'
    | '/admin/audit-log'
    | '/admin/calendar'
    | '/admin/notification-settings'
    | '/admin/notifications'
    | '/admin/profile-management'
    | '/admin/projects'
    | '/admin/reports'
    | '/admin/tasks'
    | '/admin/users'
    | '/supervisor/approvals'
    | '/supervisor/notifications'
    | '/supervisor/overtime-approvals'
    | '/supervisor/overtime-requests'
    | '/supervisor/requests'
    | '/supervisor/team'
    | '/supervisor/team-timesheet'
    | '/user/calendar'
    | '/user/change-password'
    | '/user/crm'
    | '/user/expense'
    | '/user/leave'
    | '/user/my-activity'
    | '/user/my-projects'
    | '/user/my-tasks'
    | '/user/notifications'
    | '/user/overtime'
    | '/user/profile-management'
    | '/user/team-leave'
    | '/admin'
    | '/supervisor'
    | '/user'
    | '/admin/attendance/adjustments'
    | '/admin/attendance/assignments'
    | '/admin/attendance/shift-policy'
    | '/admin/attendance/shifts'
    | '/admin/attendance/timesheets'
    | '/admin/crm/accounts'
    | '/admin/crm/calendar'
    | '/admin/crm/calls'
    | '/admin/crm/cases'
    | '/admin/crm/contacts'
    | '/admin/crm/emails'
    | '/admin/crm/leads'
    | '/admin/crm/meetings'
    | '/admin/crm/opportunities'
    | '/admin/crm/reports'
    | '/admin/crm/tasks'
    | '/admin/crm/teams'
    | '/admin/documents/company'
    | '/admin/documents/employee'
    | '/admin/expense/categories'
    | '/admin/expense/reports'
    | '/admin/expense/settings'
    | '/admin/inventory/adjustments'
    | '/admin/inventory/asset-incidents'
    | '/admin/inventory/asset-items'
    | '/admin/inventory/asset-safety-inspections'
    | '/admin/inventory/bills'
    | '/admin/inventory/categories'
    | '/admin/inventory/challans'
    | '/admin/inventory/collections'
    | '/admin/inventory/customer-returns'
    | '/admin/inventory/damages'
    | '/admin/inventory/delivery-orders'
    | '/admin/inventory/deployment-manifests'
    | '/admin/inventory/inbound-rental-agreements'
    | '/admin/inventory/inspection-checklists'
    | '/admin/inventory/inspection-frequencies'
    | '/admin/inventory/inspections'
    | '/admin/inventory/invoices'
    | '/admin/inventory/item-prices'
    | '/admin/inventory/items'
    | '/admin/inventory/labels'
    | '/admin/inventory/price-books'
    | '/admin/inventory/purchase-orders'
    | '/admin/inventory/quotes'
    | '/admin/inventory/rental-contracts'
    | '/admin/inventory/reports'
    | '/admin/inventory/requisitions'
    | '/admin/inventory/returns'
    | '/admin/inventory/sales-orders'
    | '/admin/inventory/settings'
    | '/admin/inventory/stock-levels'
    | '/admin/inventory/supplier-prices'
    | '/admin/inventory/transactions'
    | '/admin/inventory/transfers'
    | '/admin/inventory/unit-conversions'
    | '/admin/inventory/units'
    | '/admin/inventory/vendors'
    | '/admin/inventory/warehouses'
    | '/admin/leave/accrual-logs'
    | '/admin/leave/accrual-rules'
    | '/admin/leave/balances'
    | '/admin/leave/policy'
    | '/admin/leave/requests'
    | '/admin/leave/types'
    | '/admin/organization/branches'
    | '/admin/organization/departments'
    | '/admin/organization/device-employees'
    | '/admin/organization/devices'
    | '/admin/organization/fiscal-years'
    | '/admin/organization/roles'
    | '/admin/overtime/monitoring'
    | '/admin/payroll/advances'
    | '/admin/payroll/payslips'
    | '/admin/payroll/salaries'
    | '/admin/payroll/settings'
    | '/admin/payroll/tax-brackets'
    | '/admin/projects/$id'
    | '/admin/reports/$userId'
    | '/admin/tasks/$id'
    | '/admin/users/$id'
    | '/supervisor/approvals/$id'
    | '/supervisor/overtime-approvals/$id'
    | '/supervisor/overtime-requests/$id'
    | '/supervisor/requests/$id'
    | '/supervisor/team/$id'
    | '/user/attendance/adjustments'
    | '/user/attendance/shifts'
    | '/user/attendance/timesheet'
    | '/user/crm/accounts'
    | '/user/crm/calendar'
    | '/user/crm/calls'
    | '/user/crm/cases'
    | '/user/crm/contacts'
    | '/user/crm/emails'
    | '/user/crm/leads'
    | '/user/crm/meetings'
    | '/user/crm/no-access'
    | '/user/crm/opportunities'
    | '/user/crm/reports'
    | '/user/crm/tasks'
    | '/user/crm/teams'
    | '/user/expense/$id'
    | '/user/inventory/deployment-manifests'
    | '/user/inventory/requisitions'
    | '/user/leave/$id'
    | '/user/my-projects/$id'
    | '/user/my-tasks/$id'
    | '/user/organization/documents'
    | '/user/overtime/$id'
    | '/admin/attendance'
    | '/admin/crm'
    | '/admin/documents'
    | '/admin/expense'
    | '/admin/inventory'
    | '/admin/leave'
    | '/admin/payroll'
    | '/user/attendance'
    | '/admin/attendance/timesheets/$userId'
    | '/admin/crm/accounts/$id'
    | '/admin/crm/cases/$id'
    | '/admin/crm/contacts/$id'
    | '/admin/crm/leads/$id'
    | '/admin/crm/opportunities/$id'
    | '/admin/crm/tasks/$id'
    | '/admin/expense/reports/$id'
    | '/admin/inventory/adjustments/$id'
    | '/admin/inventory/asset-items/$id'
    | '/admin/inventory/bills/$id'
    | '/admin/inventory/challans/$id'
    | '/admin/inventory/damages/$id'
    | '/admin/inventory/delivery-orders/$id'
    | '/admin/inventory/deployment-manifests/$id'
    | '/admin/inventory/inbound-rental-agreements/$id'
    | '/admin/inventory/inspection-checklists/$id'
    | '/admin/inventory/inspections/$id'
    | '/admin/inventory/invoices/$id'
    | '/admin/inventory/items/$id'
    | '/admin/inventory/price-books/$id'
    | '/admin/inventory/purchase-orders/$id'
    | '/admin/inventory/quotes/$id'
    | '/admin/inventory/rental-contracts/$id'
    | '/admin/inventory/requisitions/$id'
    | '/admin/inventory/returns/$id'
    | '/admin/inventory/sales-orders/$id'
    | '/admin/inventory/transfers/$id'
    | '/admin/inventory/vendors/$id'
    | '/admin/inventory/warehouses/$id'
    | '/admin/leave/balances/$userId'
    | '/admin/leave/requests/$userId'
    | '/admin/overtime/monitoring/$id'
    | '/admin/payroll/advances/$userId'
    | '/admin/payroll/payslips/$userId'
    | '/user/crm/accounts/$id'
    | '/user/crm/cases/$id'
    | '/user/crm/contacts/$id'
    | '/user/crm/leads/$id'
    | '/user/crm/opportunities/$id'
    | '/user/crm/tasks/$id'
    | '/user/inventory/requisitions/$id'
  id:
    | '__root__'
    | '/'
    | '/unauthorized'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/logout'
    | '/(auth)/password-change'
    | '/(auth)/verify-otp'
    | '/(legal)/privacy-policy'
    | '/(legal)/terms-of-service'
    | '/admin/_layout'
    | '/supervisor/_layout'
    | '/user/_layout'
    | '/(auth)/reset-password/$token'
    | '/admin/_layout/attendance'
    | '/admin/_layout/audit-log'
    | '/admin/_layout/calendar'
    | '/admin/_layout/crm'
    | '/admin/_layout/documents'
    | '/admin/_layout/expense'
    | '/admin/_layout/inventory'
    | '/admin/_layout/leave'
    | '/admin/_layout/notification-settings'
    | '/admin/_layout/notifications'
    | '/admin/_layout/payroll'
    | '/admin/_layout/profile-management'
    | '/admin/_layout/projects'
    | '/admin/_layout/reports'
    | '/admin/_layout/tasks'
    | '/admin/_layout/users'
    | '/supervisor/_layout/approvals'
    | '/supervisor/_layout/notifications'
    | '/supervisor/_layout/overtime-approvals'
    | '/supervisor/_layout/overtime-requests'
    | '/supervisor/_layout/requests'
    | '/supervisor/_layout/team'
    | '/supervisor/_layout/team-timesheet'
    | '/user/_layout/attendance'
    | '/user/_layout/calendar'
    | '/user/_layout/change-password'
    | '/user/_layout/crm'
    | '/user/_layout/expense'
    | '/user/_layout/leave'
    | '/user/_layout/my-activity'
    | '/user/_layout/my-projects'
    | '/user/_layout/my-tasks'
    | '/user/_layout/notifications'
    | '/user/_layout/overtime'
    | '/user/_layout/profile-management'
    | '/user/_layout/team-leave'
    | '/admin/_layout/'
    | '/supervisor/_layout/'
    | '/user/_layout/'
    | '/admin/_layout/attendance/adjustments'
    | '/admin/_layout/attendance/assignments'
    | '/admin/_layout/attendance/shift-policy'
    | '/admin/_layout/attendance/shifts'
    | '/admin/_layout/attendance/timesheets'
    | '/admin/_layout/crm/accounts'
    | '/admin/_layout/crm/calendar'
    | '/admin/_layout/crm/calls'
    | '/admin/_layout/crm/cases'
    | '/admin/_layout/crm/contacts'
    | '/admin/_layout/crm/emails'
    | '/admin/_layout/crm/leads'
    | '/admin/_layout/crm/meetings'
    | '/admin/_layout/crm/opportunities'
    | '/admin/_layout/crm/reports'
    | '/admin/_layout/crm/tasks'
    | '/admin/_layout/crm/teams'
    | '/admin/_layout/documents/company'
    | '/admin/_layout/documents/employee'
    | '/admin/_layout/expense/categories'
    | '/admin/_layout/expense/reports'
    | '/admin/_layout/expense/settings'
    | '/admin/_layout/inventory/adjustments'
    | '/admin/_layout/inventory/asset-incidents'
    | '/admin/_layout/inventory/asset-items'
    | '/admin/_layout/inventory/asset-safety-inspections'
    | '/admin/_layout/inventory/bills'
    | '/admin/_layout/inventory/categories'
    | '/admin/_layout/inventory/challans'
    | '/admin/_layout/inventory/collections'
    | '/admin/_layout/inventory/customer-returns'
    | '/admin/_layout/inventory/damages'
    | '/admin/_layout/inventory/delivery-orders'
    | '/admin/_layout/inventory/deployment-manifests'
    | '/admin/_layout/inventory/inbound-rental-agreements'
    | '/admin/_layout/inventory/inspection-checklists'
    | '/admin/_layout/inventory/inspection-frequencies'
    | '/admin/_layout/inventory/inspections'
    | '/admin/_layout/inventory/invoices'
    | '/admin/_layout/inventory/item-prices'
    | '/admin/_layout/inventory/items'
    | '/admin/_layout/inventory/labels'
    | '/admin/_layout/inventory/price-books'
    | '/admin/_layout/inventory/purchase-orders'
    | '/admin/_layout/inventory/quotes'
    | '/admin/_layout/inventory/rental-contracts'
    | '/admin/_layout/inventory/reports'
    | '/admin/_layout/inventory/requisitions'
    | '/admin/_layout/inventory/returns'
    | '/admin/_layout/inventory/sales-orders'
    | '/admin/_layout/inventory/settings'
    | '/admin/_layout/inventory/stock-levels'
    | '/admin/_layout/inventory/supplier-prices'
    | '/admin/_layout/inventory/transactions'
    | '/admin/_layout/inventory/transfers'
    | '/admin/_layout/inventory/unit-conversions'
    | '/admin/_layout/inventory/units'
    | '/admin/_layout/inventory/vendors'
    | '/admin/_layout/inventory/warehouses'
    | '/admin/_layout/leave/accrual-logs'
    | '/admin/_layout/leave/accrual-rules'
    | '/admin/_layout/leave/balances'
    | '/admin/_layout/leave/policy'
    | '/admin/_layout/leave/requests'
    | '/admin/_layout/leave/types'
    | '/admin/_layout/organization/branches'
    | '/admin/_layout/organization/departments'
    | '/admin/_layout/organization/device-employees'
    | '/admin/_layout/organization/devices'
    | '/admin/_layout/organization/fiscal-years'
    | '/admin/_layout/organization/roles'
    | '/admin/_layout/overtime/monitoring'
    | '/admin/_layout/payroll/advances'
    | '/admin/_layout/payroll/payslips'
    | '/admin/_layout/payroll/salaries'
    | '/admin/_layout/payroll/settings'
    | '/admin/_layout/payroll/tax-brackets'
    | '/admin/_layout/projects_/$id'
    | '/admin/_layout/reports_/$userId'
    | '/admin/_layout/tasks_/$id'
    | '/admin/_layout/users_/$id'
    | '/supervisor/_layout/approvals_/$id'
    | '/supervisor/_layout/overtime-approvals_/$id'
    | '/supervisor/_layout/overtime-requests_/$id'
    | '/supervisor/_layout/requests_/$id'
    | '/supervisor/_layout/team_/$id'
    | '/user/_layout/attendance/adjustments'
    | '/user/_layout/attendance/shifts'
    | '/user/_layout/attendance/timesheet'
    | '/user/_layout/crm/accounts'
    | '/user/_layout/crm/calendar'
    | '/user/_layout/crm/calls'
    | '/user/_layout/crm/cases'
    | '/user/_layout/crm/contacts'
    | '/user/_layout/crm/emails'
    | '/user/_layout/crm/leads'
    | '/user/_layout/crm/meetings'
    | '/user/_layout/crm/no-access'
    | '/user/_layout/crm/opportunities'
    | '/user/_layout/crm/reports'
    | '/user/_layout/crm/tasks'
    | '/user/_layout/crm/teams'
    | '/user/_layout/expense_/$id'
    | '/user/_layout/inventory/deployment-manifests'
    | '/user/_layout/inventory/requisitions'
    | '/user/_layout/leave_/$id'
    | '/user/_layout/my-projects_/$id'
    | '/user/_layout/my-tasks_/$id'
    | '/user/_layout/organization/documents'
    | '/user/_layout/overtime_/$id'
    | '/admin/_layout/attendance/'
    | '/admin/_layout/crm/'
    | '/admin/_layout/documents/'
    | '/admin/_layout/expense/'
    | '/admin/_layout/inventory/'
    | '/admin/_layout/leave/'
    | '/admin/_layout/payroll/'
    | '/user/_layout/attendance/'
    | '/admin/_layout/attendance/timesheets_/$userId'
    | '/admin/_layout/crm/accounts_/$id'
    | '/admin/_layout/crm/cases_/$id'
    | '/admin/_layout/crm/contacts_/$id'
    | '/admin/_layout/crm/leads_/$id'
    | '/admin/_layout/crm/opportunities_/$id'
    | '/admin/_layout/crm/tasks_/$id'
    | '/admin/_layout/expense/reports_/$id'
    | '/admin/_layout/inventory/adjustments_/$id'
    | '/admin/_layout/inventory/asset-items_/$id'
    | '/admin/_layout/inventory/bills_/$id'
    | '/admin/_layout/inventory/challans_/$id'
    | '/admin/_layout/inventory/damages_/$id'
    | '/admin/_layout/inventory/delivery-orders_/$id'
    | '/admin/_layout/inventory/deployment-manifests_/$id'
    | '/admin/_layout/inventory/inbound-rental-agreements_/$id'
    | '/admin/_layout/inventory/inspection-checklists_/$id'
    | '/admin/_layout/inventory/inspections_/$id'
    | '/admin/_layout/inventory/invoices_/$id'
    | '/admin/_layout/inventory/items_/$id'
    | '/admin/_layout/inventory/price-books_/$id'
    | '/admin/_layout/inventory/purchase-orders_/$id'
    | '/admin/_layout/inventory/quotes_/$id'
    | '/admin/_layout/inventory/rental-contracts_/$id'
    | '/admin/_layout/inventory/requisitions_/$id'
    | '/admin/_layout/inventory/returns_/$id'
    | '/admin/_layout/inventory/sales-orders_/$id'
    | '/admin/_layout/inventory/transfers_/$id'
    | '/admin/_layout/inventory/vendors_/$id'
    | '/admin/_layout/inventory/warehouses_/$id'
    | '/admin/_layout/leave/balances_/$userId'
    | '/admin/_layout/leave/requests_/$userId'
    | '/admin/_layout/overtime/monitoring_/$id'
    | '/admin/_layout/payroll/advances_/$userId'
    | '/admin/_layout/payroll/payslips_/$userId'
    | '/user/_layout/crm/accounts_/$id'
    | '/user/_layout/crm/cases_/$id'
    | '/user/_layout/crm/contacts_/$id'
    | '/user/_layout/crm/leads_/$id'
    | '/user/_layout/crm/opportunities_/$id'
    | '/user/_layout/crm/tasks_/$id'
    | '/user/_layout/inventory/requisitions_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authLogoutRoute: typeof authLogoutRoute
  authPasswordChangeRoute: typeof authPasswordChangeRoute
  authVerifyOtpRoute: typeof authVerifyOtpRoute
  legalPrivacyPolicyRoute: typeof legalPrivacyPolicyRoute
  legalTermsOfServiceRoute: typeof legalTermsOfServiceRoute
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
  SupervisorLayoutRoute: typeof SupervisorLayoutRouteWithChildren
  UserLayoutRoute: typeof UserLayoutRouteWithChildren
  authResetPasswordTokenRoute: typeof authResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/logout': {
      id: '/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof authLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/password-change': {
      id: '/(auth)/password-change'
      path: '/password-change'
      fullPath: '/password-change'
      preLoaderRoute: typeof authPasswordChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-otp': {
      id: '/(auth)/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof authVerifyOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legal)/privacy-policy': {
      id: '/(legal)/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof legalPrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legal)/terms-of-service': {
      id: '/(legal)/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof legalTermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_layout': {
      id: '/admin/_layout'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervisor/_layout': {
      id: '/supervisor/_layout'
      path: '/supervisor'
      fullPath: '/supervisor'
      preLoaderRoute: typeof SupervisorLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/_layout': {
      id: '/user/_layout'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password/$token': {
      id: '/(auth)/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof authResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_layout/': {
      id: '/admin/_layout/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminLayoutIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/attendance': {
      id: '/admin/_layout/attendance'
      path: '/attendance'
      fullPath: '/admin/attendance'
      preLoaderRoute: typeof AdminLayoutAttendanceRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/audit-log': {
      id: '/admin/_layout/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminLayoutAuditLogRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/calendar': {
      id: '/admin/_layout/calendar'
      path: '/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof AdminLayoutCalendarRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/crm': {
      id: '/admin/_layout/crm'
      path: '/crm'
      fullPath: '/admin/crm'
      preLoaderRoute: typeof AdminLayoutCrmRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/documents': {
      id: '/admin/_layout/documents'
      path: '/documents'
      fullPath: '/admin/documents'
      preLoaderRoute: typeof AdminLayoutDocumentsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/expense': {
      id: '/admin/_layout/expense'
      path: '/expense'
      fullPath: '/admin/expense'
      preLoaderRoute: typeof AdminLayoutExpenseRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/inventory': {
      id: '/admin/_layout/inventory'
      path: '/inventory'
      fullPath: '/admin/inventory'
      preLoaderRoute: typeof AdminLayoutInventoryRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/leave': {
      id: '/admin/_layout/leave'
      path: '/leave'
      fullPath: '/admin/leave'
      preLoaderRoute: typeof AdminLayoutLeaveRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/notification-settings': {
      id: '/admin/_layout/notification-settings'
      path: '/notification-settings'
      fullPath: '/admin/notification-settings'
      preLoaderRoute: typeof AdminLayoutNotificationSettingsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/notifications': {
      id: '/admin/_layout/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminLayoutNotificationsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/payroll': {
      id: '/admin/_layout/payroll'
      path: '/payroll'
      fullPath: '/admin/payroll'
      preLoaderRoute: typeof AdminLayoutPayrollRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/profile-management': {
      id: '/admin/_layout/profile-management'
      path: '/profile-management'
      fullPath: '/admin/profile-management'
      preLoaderRoute: typeof AdminLayoutProfileManagementRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/projects': {
      id: '/admin/_layout/projects'
      path: '/projects'
      fullPath: '/admin/projects'
      preLoaderRoute: typeof AdminLayoutProjectsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/reports': {
      id: '/admin/_layout/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminLayoutReportsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/tasks': {
      id: '/admin/_layout/tasks'
      path: '/tasks'
      fullPath: '/admin/tasks'
      preLoaderRoute: typeof AdminLayoutTasksRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/users': {
      id: '/admin/_layout/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminLayoutUsersRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/supervisor/_layout/': {
      id: '/supervisor/_layout/'
      path: '/'
      fullPath: '/supervisor/'
      preLoaderRoute: typeof SupervisorLayoutIndexRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/approvals': {
      id: '/supervisor/_layout/approvals'
      path: '/approvals'
      fullPath: '/supervisor/approvals'
      preLoaderRoute: typeof SupervisorLayoutApprovalsRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/notifications': {
      id: '/supervisor/_layout/notifications'
      path: '/notifications'
      fullPath: '/supervisor/notifications'
      preLoaderRoute: typeof SupervisorLayoutNotificationsRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/overtime-approvals': {
      id: '/supervisor/_layout/overtime-approvals'
      path: '/overtime-approvals'
      fullPath: '/supervisor/overtime-approvals'
      preLoaderRoute: typeof SupervisorLayoutOvertimeApprovalsRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/overtime-requests': {
      id: '/supervisor/_layout/overtime-requests'
      path: '/overtime-requests'
      fullPath: '/supervisor/overtime-requests'
      preLoaderRoute: typeof SupervisorLayoutOvertimeRequestsRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/requests': {
      id: '/supervisor/_layout/requests'
      path: '/requests'
      fullPath: '/supervisor/requests'
      preLoaderRoute: typeof SupervisorLayoutRequestsRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/team': {
      id: '/supervisor/_layout/team'
      path: '/team'
      fullPath: '/supervisor/team'
      preLoaderRoute: typeof SupervisorLayoutTeamRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/team-timesheet': {
      id: '/supervisor/_layout/team-timesheet'
      path: '/team-timesheet'
      fullPath: '/supervisor/team-timesheet'
      preLoaderRoute: typeof SupervisorLayoutTeamTimesheetRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/user/_layout/': {
      id: '/user/_layout/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof UserLayoutIndexRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/attendance': {
      id: '/user/_layout/attendance'
      path: '/attendance'
      fullPath: '/user/attendance'
      preLoaderRoute: typeof UserLayoutAttendanceRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/calendar': {
      id: '/user/_layout/calendar'
      path: '/calendar'
      fullPath: '/user/calendar'
      preLoaderRoute: typeof UserLayoutCalendarRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/change-password': {
      id: '/user/_layout/change-password'
      path: '/change-password'
      fullPath: '/user/change-password'
      preLoaderRoute: typeof UserLayoutChangePasswordRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/crm': {
      id: '/user/_layout/crm'
      path: '/crm'
      fullPath: '/user/crm'
      preLoaderRoute: typeof UserLayoutCrmRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/expense': {
      id: '/user/_layout/expense'
      path: '/expense'
      fullPath: '/user/expense'
      preLoaderRoute: typeof UserLayoutExpenseRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/leave': {
      id: '/user/_layout/leave'
      path: '/leave'
      fullPath: '/user/leave'
      preLoaderRoute: typeof UserLayoutLeaveRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/my-activity': {
      id: '/user/_layout/my-activity'
      path: '/my-activity'
      fullPath: '/user/my-activity'
      preLoaderRoute: typeof UserLayoutMyActivityRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/my-projects': {
      id: '/user/_layout/my-projects'
      path: '/my-projects'
      fullPath: '/user/my-projects'
      preLoaderRoute: typeof UserLayoutMyProjectsRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/my-tasks': {
      id: '/user/_layout/my-tasks'
      path: '/my-tasks'
      fullPath: '/user/my-tasks'
      preLoaderRoute: typeof UserLayoutMyTasksRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/notifications': {
      id: '/user/_layout/notifications'
      path: '/notifications'
      fullPath: '/user/notifications'
      preLoaderRoute: typeof UserLayoutNotificationsRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/overtime': {
      id: '/user/_layout/overtime'
      path: '/overtime'
      fullPath: '/user/overtime'
      preLoaderRoute: typeof UserLayoutOvertimeRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/profile-management': {
      id: '/user/_layout/profile-management'
      path: '/profile-management'
      fullPath: '/user/profile-management'
      preLoaderRoute: typeof UserLayoutProfileManagementRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/team-leave': {
      id: '/user/_layout/team-leave'
      path: '/team-leave'
      fullPath: '/user/team-leave'
      preLoaderRoute: typeof UserLayoutTeamLeaveRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/admin/_layout/attendance/': {
      id: '/admin/_layout/attendance/'
      path: '/'
      fullPath: '/admin/attendance/'
      preLoaderRoute: typeof AdminLayoutAttendanceIndexRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/attendance/adjustments': {
      id: '/admin/_layout/attendance/adjustments'
      path: '/adjustments'
      fullPath: '/admin/attendance/adjustments'
      preLoaderRoute: typeof AdminLayoutAttendanceAdjustmentsRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/attendance/assignments': {
      id: '/admin/_layout/attendance/assignments'
      path: '/assignments'
      fullPath: '/admin/attendance/assignments'
      preLoaderRoute: typeof AdminLayoutAttendanceAssignmentsRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/attendance/shift-policy': {
      id: '/admin/_layout/attendance/shift-policy'
      path: '/shift-policy'
      fullPath: '/admin/attendance/shift-policy'
      preLoaderRoute: typeof AdminLayoutAttendanceShiftPolicyRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/attendance/shifts': {
      id: '/admin/_layout/attendance/shifts'
      path: '/shifts'
      fullPath: '/admin/attendance/shifts'
      preLoaderRoute: typeof AdminLayoutAttendanceShiftsRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/attendance/timesheets': {
      id: '/admin/_layout/attendance/timesheets'
      path: '/timesheets'
      fullPath: '/admin/attendance/timesheets'
      preLoaderRoute: typeof AdminLayoutAttendanceTimesheetsRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/crm/': {
      id: '/admin/_layout/crm/'
      path: '/'
      fullPath: '/admin/crm/'
      preLoaderRoute: typeof AdminLayoutCrmIndexRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/accounts': {
      id: '/admin/_layout/crm/accounts'
      path: '/accounts'
      fullPath: '/admin/crm/accounts'
      preLoaderRoute: typeof AdminLayoutCrmAccountsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/calendar': {
      id: '/admin/_layout/crm/calendar'
      path: '/calendar'
      fullPath: '/admin/crm/calendar'
      preLoaderRoute: typeof AdminLayoutCrmCalendarRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/calls': {
      id: '/admin/_layout/crm/calls'
      path: '/calls'
      fullPath: '/admin/crm/calls'
      preLoaderRoute: typeof AdminLayoutCrmCallsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/cases': {
      id: '/admin/_layout/crm/cases'
      path: '/cases'
      fullPath: '/admin/crm/cases'
      preLoaderRoute: typeof AdminLayoutCrmCasesRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/contacts': {
      id: '/admin/_layout/crm/contacts'
      path: '/contacts'
      fullPath: '/admin/crm/contacts'
      preLoaderRoute: typeof AdminLayoutCrmContactsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/emails': {
      id: '/admin/_layout/crm/emails'
      path: '/emails'
      fullPath: '/admin/crm/emails'
      preLoaderRoute: typeof AdminLayoutCrmEmailsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/leads': {
      id: '/admin/_layout/crm/leads'
      path: '/leads'
      fullPath: '/admin/crm/leads'
      preLoaderRoute: typeof AdminLayoutCrmLeadsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/meetings': {
      id: '/admin/_layout/crm/meetings'
      path: '/meetings'
      fullPath: '/admin/crm/meetings'
      preLoaderRoute: typeof AdminLayoutCrmMeetingsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/opportunities': {
      id: '/admin/_layout/crm/opportunities'
      path: '/opportunities'
      fullPath: '/admin/crm/opportunities'
      preLoaderRoute: typeof AdminLayoutCrmOpportunitiesRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/reports': {
      id: '/admin/_layout/crm/reports'
      path: '/reports'
      fullPath: '/admin/crm/reports'
      preLoaderRoute: typeof AdminLayoutCrmReportsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/tasks': {
      id: '/admin/_layout/crm/tasks'
      path: '/tasks'
      fullPath: '/admin/crm/tasks'
      preLoaderRoute: typeof AdminLayoutCrmTasksRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/teams': {
      id: '/admin/_layout/crm/teams'
      path: '/teams'
      fullPath: '/admin/crm/teams'
      preLoaderRoute: typeof AdminLayoutCrmTeamsRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/documents/': {
      id: '/admin/_layout/documents/'
      path: '/'
      fullPath: '/admin/documents/'
      preLoaderRoute: typeof AdminLayoutDocumentsIndexRouteImport
      parentRoute: typeof AdminLayoutDocumentsRoute
    }
    '/admin/_layout/documents/company': {
      id: '/admin/_layout/documents/company'
      path: '/company'
      fullPath: '/admin/documents/company'
      preLoaderRoute: typeof AdminLayoutDocumentsCompanyRouteImport
      parentRoute: typeof AdminLayoutDocumentsRoute
    }
    '/admin/_layout/documents/employee': {
      id: '/admin/_layout/documents/employee'
      path: '/employee'
      fullPath: '/admin/documents/employee'
      preLoaderRoute: typeof AdminLayoutDocumentsEmployeeRouteImport
      parentRoute: typeof AdminLayoutDocumentsRoute
    }
    '/admin/_layout/expense/': {
      id: '/admin/_layout/expense/'
      path: '/'
      fullPath: '/admin/expense/'
      preLoaderRoute: typeof AdminLayoutExpenseIndexRouteImport
      parentRoute: typeof AdminLayoutExpenseRoute
    }
    '/admin/_layout/expense/categories': {
      id: '/admin/_layout/expense/categories'
      path: '/categories'
      fullPath: '/admin/expense/categories'
      preLoaderRoute: typeof AdminLayoutExpenseCategoriesRouteImport
      parentRoute: typeof AdminLayoutExpenseRoute
    }
    '/admin/_layout/expense/reports': {
      id: '/admin/_layout/expense/reports'
      path: '/reports'
      fullPath: '/admin/expense/reports'
      preLoaderRoute: typeof AdminLayoutExpenseReportsRouteImport
      parentRoute: typeof AdminLayoutExpenseRoute
    }
    '/admin/_layout/expense/settings': {
      id: '/admin/_layout/expense/settings'
      path: '/settings'
      fullPath: '/admin/expense/settings'
      preLoaderRoute: typeof AdminLayoutExpenseSettingsRouteImport
      parentRoute: typeof AdminLayoutExpenseRoute
    }
    '/admin/_layout/inventory/': {
      id: '/admin/_layout/inventory/'
      path: '/'
      fullPath: '/admin/inventory/'
      preLoaderRoute: typeof AdminLayoutInventoryIndexRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/adjustments': {
      id: '/admin/_layout/inventory/adjustments'
      path: '/adjustments'
      fullPath: '/admin/inventory/adjustments'
      preLoaderRoute: typeof AdminLayoutInventoryAdjustmentsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/asset-incidents': {
      id: '/admin/_layout/inventory/asset-incidents'
      path: '/asset-incidents'
      fullPath: '/admin/inventory/asset-incidents'
      preLoaderRoute: typeof AdminLayoutInventoryAssetIncidentsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/asset-items': {
      id: '/admin/_layout/inventory/asset-items'
      path: '/asset-items'
      fullPath: '/admin/inventory/asset-items'
      preLoaderRoute: typeof AdminLayoutInventoryAssetItemsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/asset-safety-inspections': {
      id: '/admin/_layout/inventory/asset-safety-inspections'
      path: '/asset-safety-inspections'
      fullPath: '/admin/inventory/asset-safety-inspections'
      preLoaderRoute: typeof AdminLayoutInventoryAssetSafetyInspectionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/bills': {
      id: '/admin/_layout/inventory/bills'
      path: '/bills'
      fullPath: '/admin/inventory/bills'
      preLoaderRoute: typeof AdminLayoutInventoryBillsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/categories': {
      id: '/admin/_layout/inventory/categories'
      path: '/categories'
      fullPath: '/admin/inventory/categories'
      preLoaderRoute: typeof AdminLayoutInventoryCategoriesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/challans': {
      id: '/admin/_layout/inventory/challans'
      path: '/challans'
      fullPath: '/admin/inventory/challans'
      preLoaderRoute: typeof AdminLayoutInventoryChallansRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/collections': {
      id: '/admin/_layout/inventory/collections'
      path: '/collections'
      fullPath: '/admin/inventory/collections'
      preLoaderRoute: typeof AdminLayoutInventoryCollectionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/customer-returns': {
      id: '/admin/_layout/inventory/customer-returns'
      path: '/customer-returns'
      fullPath: '/admin/inventory/customer-returns'
      preLoaderRoute: typeof AdminLayoutInventoryCustomerReturnsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/damages': {
      id: '/admin/_layout/inventory/damages'
      path: '/damages'
      fullPath: '/admin/inventory/damages'
      preLoaderRoute: typeof AdminLayoutInventoryDamagesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/delivery-orders': {
      id: '/admin/_layout/inventory/delivery-orders'
      path: '/delivery-orders'
      fullPath: '/admin/inventory/delivery-orders'
      preLoaderRoute: typeof AdminLayoutInventoryDeliveryOrdersRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/deployment-manifests': {
      id: '/admin/_layout/inventory/deployment-manifests'
      path: '/deployment-manifests'
      fullPath: '/admin/inventory/deployment-manifests'
      preLoaderRoute: typeof AdminLayoutInventoryDeploymentManifestsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inbound-rental-agreements': {
      id: '/admin/_layout/inventory/inbound-rental-agreements'
      path: '/inbound-rental-agreements'
      fullPath: '/admin/inventory/inbound-rental-agreements'
      preLoaderRoute: typeof AdminLayoutInventoryInboundRentalAgreementsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inspection-checklists': {
      id: '/admin/_layout/inventory/inspection-checklists'
      path: '/inspection-checklists'
      fullPath: '/admin/inventory/inspection-checklists'
      preLoaderRoute: typeof AdminLayoutInventoryInspectionChecklistsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inspection-frequencies': {
      id: '/admin/_layout/inventory/inspection-frequencies'
      path: '/inspection-frequencies'
      fullPath: '/admin/inventory/inspection-frequencies'
      preLoaderRoute: typeof AdminLayoutInventoryInspectionFrequenciesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inspections': {
      id: '/admin/_layout/inventory/inspections'
      path: '/inspections'
      fullPath: '/admin/inventory/inspections'
      preLoaderRoute: typeof AdminLayoutInventoryInspectionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/invoices': {
      id: '/admin/_layout/inventory/invoices'
      path: '/invoices'
      fullPath: '/admin/inventory/invoices'
      preLoaderRoute: typeof AdminLayoutInventoryInvoicesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/item-prices': {
      id: '/admin/_layout/inventory/item-prices'
      path: '/item-prices'
      fullPath: '/admin/inventory/item-prices'
      preLoaderRoute: typeof AdminLayoutInventoryItemPricesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/items': {
      id: '/admin/_layout/inventory/items'
      path: '/items'
      fullPath: '/admin/inventory/items'
      preLoaderRoute: typeof AdminLayoutInventoryItemsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/labels': {
      id: '/admin/_layout/inventory/labels'
      path: '/labels'
      fullPath: '/admin/inventory/labels'
      preLoaderRoute: typeof AdminLayoutInventoryLabelsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/price-books': {
      id: '/admin/_layout/inventory/price-books'
      path: '/price-books'
      fullPath: '/admin/inventory/price-books'
      preLoaderRoute: typeof AdminLayoutInventoryPriceBooksRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/purchase-orders': {
      id: '/admin/_layout/inventory/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/admin/inventory/purchase-orders'
      preLoaderRoute: typeof AdminLayoutInventoryPurchaseOrdersRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/quotes': {
      id: '/admin/_layout/inventory/quotes'
      path: '/quotes'
      fullPath: '/admin/inventory/quotes'
      preLoaderRoute: typeof AdminLayoutInventoryQuotesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/rental-contracts': {
      id: '/admin/_layout/inventory/rental-contracts'
      path: '/rental-contracts'
      fullPath: '/admin/inventory/rental-contracts'
      preLoaderRoute: typeof AdminLayoutInventoryRentalContractsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/reports': {
      id: '/admin/_layout/inventory/reports'
      path: '/reports'
      fullPath: '/admin/inventory/reports'
      preLoaderRoute: typeof AdminLayoutInventoryReportsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/requisitions': {
      id: '/admin/_layout/inventory/requisitions'
      path: '/requisitions'
      fullPath: '/admin/inventory/requisitions'
      preLoaderRoute: typeof AdminLayoutInventoryRequisitionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/returns': {
      id: '/admin/_layout/inventory/returns'
      path: '/returns'
      fullPath: '/admin/inventory/returns'
      preLoaderRoute: typeof AdminLayoutInventoryReturnsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/sales-orders': {
      id: '/admin/_layout/inventory/sales-orders'
      path: '/sales-orders'
      fullPath: '/admin/inventory/sales-orders'
      preLoaderRoute: typeof AdminLayoutInventorySalesOrdersRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/settings': {
      id: '/admin/_layout/inventory/settings'
      path: '/settings'
      fullPath: '/admin/inventory/settings'
      preLoaderRoute: typeof AdminLayoutInventorySettingsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/stock-levels': {
      id: '/admin/_layout/inventory/stock-levels'
      path: '/stock-levels'
      fullPath: '/admin/inventory/stock-levels'
      preLoaderRoute: typeof AdminLayoutInventoryStockLevelsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/supplier-prices': {
      id: '/admin/_layout/inventory/supplier-prices'
      path: '/supplier-prices'
      fullPath: '/admin/inventory/supplier-prices'
      preLoaderRoute: typeof AdminLayoutInventorySupplierPricesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/transactions': {
      id: '/admin/_layout/inventory/transactions'
      path: '/transactions'
      fullPath: '/admin/inventory/transactions'
      preLoaderRoute: typeof AdminLayoutInventoryTransactionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/transfers': {
      id: '/admin/_layout/inventory/transfers'
      path: '/transfers'
      fullPath: '/admin/inventory/transfers'
      preLoaderRoute: typeof AdminLayoutInventoryTransfersRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/unit-conversions': {
      id: '/admin/_layout/inventory/unit-conversions'
      path: '/unit-conversions'
      fullPath: '/admin/inventory/unit-conversions'
      preLoaderRoute: typeof AdminLayoutInventoryUnitConversionsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/units': {
      id: '/admin/_layout/inventory/units'
      path: '/units'
      fullPath: '/admin/inventory/units'
      preLoaderRoute: typeof AdminLayoutInventoryUnitsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/vendors': {
      id: '/admin/_layout/inventory/vendors'
      path: '/vendors'
      fullPath: '/admin/inventory/vendors'
      preLoaderRoute: typeof AdminLayoutInventoryVendorsRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/warehouses': {
      id: '/admin/_layout/inventory/warehouses'
      path: '/warehouses'
      fullPath: '/admin/inventory/warehouses'
      preLoaderRoute: typeof AdminLayoutInventoryWarehousesRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/leave/': {
      id: '/admin/_layout/leave/'
      path: '/'
      fullPath: '/admin/leave/'
      preLoaderRoute: typeof AdminLayoutLeaveIndexRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/accrual-logs': {
      id: '/admin/_layout/leave/accrual-logs'
      path: '/accrual-logs'
      fullPath: '/admin/leave/accrual-logs'
      preLoaderRoute: typeof AdminLayoutLeaveAccrualLogsRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/accrual-rules': {
      id: '/admin/_layout/leave/accrual-rules'
      path: '/accrual-rules'
      fullPath: '/admin/leave/accrual-rules'
      preLoaderRoute: typeof AdminLayoutLeaveAccrualRulesRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/balances': {
      id: '/admin/_layout/leave/balances'
      path: '/balances'
      fullPath: '/admin/leave/balances'
      preLoaderRoute: typeof AdminLayoutLeaveBalancesRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/policy': {
      id: '/admin/_layout/leave/policy'
      path: '/policy'
      fullPath: '/admin/leave/policy'
      preLoaderRoute: typeof AdminLayoutLeavePolicyRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/requests': {
      id: '/admin/_layout/leave/requests'
      path: '/requests'
      fullPath: '/admin/leave/requests'
      preLoaderRoute: typeof AdminLayoutLeaveRequestsRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/types': {
      id: '/admin/_layout/leave/types'
      path: '/types'
      fullPath: '/admin/leave/types'
      preLoaderRoute: typeof AdminLayoutLeaveTypesRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/organization/branches': {
      id: '/admin/_layout/organization/branches'
      path: '/organization/branches'
      fullPath: '/admin/organization/branches'
      preLoaderRoute: typeof AdminLayoutOrganizationBranchesRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/organization/departments': {
      id: '/admin/_layout/organization/departments'
      path: '/organization/departments'
      fullPath: '/admin/organization/departments'
      preLoaderRoute: typeof AdminLayoutOrganizationDepartmentsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/organization/device-employees': {
      id: '/admin/_layout/organization/device-employees'
      path: '/organization/device-employees'
      fullPath: '/admin/organization/device-employees'
      preLoaderRoute: typeof AdminLayoutOrganizationDeviceEmployeesRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/organization/devices': {
      id: '/admin/_layout/organization/devices'
      path: '/organization/devices'
      fullPath: '/admin/organization/devices'
      preLoaderRoute: typeof AdminLayoutOrganizationDevicesRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/organization/fiscal-years': {
      id: '/admin/_layout/organization/fiscal-years'
      path: '/organization/fiscal-years'
      fullPath: '/admin/organization/fiscal-years'
      preLoaderRoute: typeof AdminLayoutOrganizationFiscalYearsRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/organization/roles': {
      id: '/admin/_layout/organization/roles'
      path: '/organization/roles'
      fullPath: '/admin/organization/roles'
      preLoaderRoute: typeof AdminLayoutOrganizationRolesRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/overtime/monitoring': {
      id: '/admin/_layout/overtime/monitoring'
      path: '/overtime/monitoring'
      fullPath: '/admin/overtime/monitoring'
      preLoaderRoute: typeof AdminLayoutOvertimeMonitoringRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/payroll/': {
      id: '/admin/_layout/payroll/'
      path: '/'
      fullPath: '/admin/payroll/'
      preLoaderRoute: typeof AdminLayoutPayrollIndexRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/advances': {
      id: '/admin/_layout/payroll/advances'
      path: '/advances'
      fullPath: '/admin/payroll/advances'
      preLoaderRoute: typeof AdminLayoutPayrollAdvancesRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/payslips': {
      id: '/admin/_layout/payroll/payslips'
      path: '/payslips'
      fullPath: '/admin/payroll/payslips'
      preLoaderRoute: typeof AdminLayoutPayrollPayslipsRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/salaries': {
      id: '/admin/_layout/payroll/salaries'
      path: '/salaries'
      fullPath: '/admin/payroll/salaries'
      preLoaderRoute: typeof AdminLayoutPayrollSalariesRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/settings': {
      id: '/admin/_layout/payroll/settings'
      path: '/settings'
      fullPath: '/admin/payroll/settings'
      preLoaderRoute: typeof AdminLayoutPayrollSettingsRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/tax-brackets': {
      id: '/admin/_layout/payroll/tax-brackets'
      path: '/tax-brackets'
      fullPath: '/admin/payroll/tax-brackets'
      preLoaderRoute: typeof AdminLayoutPayrollTaxBracketsRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/projects_/$id': {
      id: '/admin/_layout/projects_/$id'
      path: '/projects/$id'
      fullPath: '/admin/projects/$id'
      preLoaderRoute: typeof AdminLayoutProjectsIdRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/reports_/$userId': {
      id: '/admin/_layout/reports_/$userId'
      path: '/reports/$userId'
      fullPath: '/admin/reports/$userId'
      preLoaderRoute: typeof AdminLayoutReportsUserIdRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/tasks_/$id': {
      id: '/admin/_layout/tasks_/$id'
      path: '/tasks/$id'
      fullPath: '/admin/tasks/$id'
      preLoaderRoute: typeof AdminLayoutTasksIdRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/users_/$id': {
      id: '/admin/_layout/users_/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminLayoutUsersIdRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/supervisor/_layout/approvals_/$id': {
      id: '/supervisor/_layout/approvals_/$id'
      path: '/approvals/$id'
      fullPath: '/supervisor/approvals/$id'
      preLoaderRoute: typeof SupervisorLayoutApprovalsIdRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/overtime-approvals_/$id': {
      id: '/supervisor/_layout/overtime-approvals_/$id'
      path: '/overtime-approvals/$id'
      fullPath: '/supervisor/overtime-approvals/$id'
      preLoaderRoute: typeof SupervisorLayoutOvertimeApprovalsIdRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/overtime-requests_/$id': {
      id: '/supervisor/_layout/overtime-requests_/$id'
      path: '/overtime-requests/$id'
      fullPath: '/supervisor/overtime-requests/$id'
      preLoaderRoute: typeof SupervisorLayoutOvertimeRequestsIdRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/requests_/$id': {
      id: '/supervisor/_layout/requests_/$id'
      path: '/requests/$id'
      fullPath: '/supervisor/requests/$id'
      preLoaderRoute: typeof SupervisorLayoutRequestsIdRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/supervisor/_layout/team_/$id': {
      id: '/supervisor/_layout/team_/$id'
      path: '/team/$id'
      fullPath: '/supervisor/team/$id'
      preLoaderRoute: typeof SupervisorLayoutTeamIdRouteImport
      parentRoute: typeof SupervisorLayoutRoute
    }
    '/user/_layout/attendance/': {
      id: '/user/_layout/attendance/'
      path: '/'
      fullPath: '/user/attendance/'
      preLoaderRoute: typeof UserLayoutAttendanceIndexRouteImport
      parentRoute: typeof UserLayoutAttendanceRoute
    }
    '/user/_layout/attendance/adjustments': {
      id: '/user/_layout/attendance/adjustments'
      path: '/adjustments'
      fullPath: '/user/attendance/adjustments'
      preLoaderRoute: typeof UserLayoutAttendanceAdjustmentsRouteImport
      parentRoute: typeof UserLayoutAttendanceRoute
    }
    '/user/_layout/attendance/shifts': {
      id: '/user/_layout/attendance/shifts'
      path: '/shifts'
      fullPath: '/user/attendance/shifts'
      preLoaderRoute: typeof UserLayoutAttendanceShiftsRouteImport
      parentRoute: typeof UserLayoutAttendanceRoute
    }
    '/user/_layout/attendance/timesheet': {
      id: '/user/_layout/attendance/timesheet'
      path: '/timesheet'
      fullPath: '/user/attendance/timesheet'
      preLoaderRoute: typeof UserLayoutAttendanceTimesheetRouteImport
      parentRoute: typeof UserLayoutAttendanceRoute
    }
    '/user/_layout/crm/accounts': {
      id: '/user/_layout/crm/accounts'
      path: '/accounts'
      fullPath: '/user/crm/accounts'
      preLoaderRoute: typeof UserLayoutCrmAccountsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/calendar': {
      id: '/user/_layout/crm/calendar'
      path: '/calendar'
      fullPath: '/user/crm/calendar'
      preLoaderRoute: typeof UserLayoutCrmCalendarRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/calls': {
      id: '/user/_layout/crm/calls'
      path: '/calls'
      fullPath: '/user/crm/calls'
      preLoaderRoute: typeof UserLayoutCrmCallsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/cases': {
      id: '/user/_layout/crm/cases'
      path: '/cases'
      fullPath: '/user/crm/cases'
      preLoaderRoute: typeof UserLayoutCrmCasesRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/contacts': {
      id: '/user/_layout/crm/contacts'
      path: '/contacts'
      fullPath: '/user/crm/contacts'
      preLoaderRoute: typeof UserLayoutCrmContactsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/emails': {
      id: '/user/_layout/crm/emails'
      path: '/emails'
      fullPath: '/user/crm/emails'
      preLoaderRoute: typeof UserLayoutCrmEmailsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/leads': {
      id: '/user/_layout/crm/leads'
      path: '/leads'
      fullPath: '/user/crm/leads'
      preLoaderRoute: typeof UserLayoutCrmLeadsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/meetings': {
      id: '/user/_layout/crm/meetings'
      path: '/meetings'
      fullPath: '/user/crm/meetings'
      preLoaderRoute: typeof UserLayoutCrmMeetingsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/no-access': {
      id: '/user/_layout/crm/no-access'
      path: '/no-access'
      fullPath: '/user/crm/no-access'
      preLoaderRoute: typeof UserLayoutCrmNoAccessRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/opportunities': {
      id: '/user/_layout/crm/opportunities'
      path: '/opportunities'
      fullPath: '/user/crm/opportunities'
      preLoaderRoute: typeof UserLayoutCrmOpportunitiesRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/reports': {
      id: '/user/_layout/crm/reports'
      path: '/reports'
      fullPath: '/user/crm/reports'
      preLoaderRoute: typeof UserLayoutCrmReportsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/tasks': {
      id: '/user/_layout/crm/tasks'
      path: '/tasks'
      fullPath: '/user/crm/tasks'
      preLoaderRoute: typeof UserLayoutCrmTasksRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/teams': {
      id: '/user/_layout/crm/teams'
      path: '/teams'
      fullPath: '/user/crm/teams'
      preLoaderRoute: typeof UserLayoutCrmTeamsRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/expense_/$id': {
      id: '/user/_layout/expense_/$id'
      path: '/expense/$id'
      fullPath: '/user/expense/$id'
      preLoaderRoute: typeof UserLayoutExpenseIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/inventory/deployment-manifests': {
      id: '/user/_layout/inventory/deployment-manifests'
      path: '/inventory/deployment-manifests'
      fullPath: '/user/inventory/deployment-manifests'
      preLoaderRoute: typeof UserLayoutInventoryDeploymentManifestsRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/inventory/requisitions': {
      id: '/user/_layout/inventory/requisitions'
      path: '/inventory/requisitions'
      fullPath: '/user/inventory/requisitions'
      preLoaderRoute: typeof UserLayoutInventoryRequisitionsRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/leave_/$id': {
      id: '/user/_layout/leave_/$id'
      path: '/leave/$id'
      fullPath: '/user/leave/$id'
      preLoaderRoute: typeof UserLayoutLeaveIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/my-projects_/$id': {
      id: '/user/_layout/my-projects_/$id'
      path: '/my-projects/$id'
      fullPath: '/user/my-projects/$id'
      preLoaderRoute: typeof UserLayoutMyProjectsIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/my-tasks_/$id': {
      id: '/user/_layout/my-tasks_/$id'
      path: '/my-tasks/$id'
      fullPath: '/user/my-tasks/$id'
      preLoaderRoute: typeof UserLayoutMyTasksIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/organization/documents': {
      id: '/user/_layout/organization/documents'
      path: '/organization/documents'
      fullPath: '/user/organization/documents'
      preLoaderRoute: typeof UserLayoutOrganizationDocumentsRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/user/_layout/overtime_/$id': {
      id: '/user/_layout/overtime_/$id'
      path: '/overtime/$id'
      fullPath: '/user/overtime/$id'
      preLoaderRoute: typeof UserLayoutOvertimeIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/admin/_layout/attendance/timesheets_/$userId': {
      id: '/admin/_layout/attendance/timesheets_/$userId'
      path: '/timesheets/$userId'
      fullPath: '/admin/attendance/timesheets/$userId'
      preLoaderRoute: typeof AdminLayoutAttendanceTimesheetsUserIdRouteImport
      parentRoute: typeof AdminLayoutAttendanceRoute
    }
    '/admin/_layout/crm/accounts_/$id': {
      id: '/admin/_layout/crm/accounts_/$id'
      path: '/accounts/$id'
      fullPath: '/admin/crm/accounts/$id'
      preLoaderRoute: typeof AdminLayoutCrmAccountsIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/cases_/$id': {
      id: '/admin/_layout/crm/cases_/$id'
      path: '/cases/$id'
      fullPath: '/admin/crm/cases/$id'
      preLoaderRoute: typeof AdminLayoutCrmCasesIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/contacts_/$id': {
      id: '/admin/_layout/crm/contacts_/$id'
      path: '/contacts/$id'
      fullPath: '/admin/crm/contacts/$id'
      preLoaderRoute: typeof AdminLayoutCrmContactsIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/leads_/$id': {
      id: '/admin/_layout/crm/leads_/$id'
      path: '/leads/$id'
      fullPath: '/admin/crm/leads/$id'
      preLoaderRoute: typeof AdminLayoutCrmLeadsIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/opportunities_/$id': {
      id: '/admin/_layout/crm/opportunities_/$id'
      path: '/opportunities/$id'
      fullPath: '/admin/crm/opportunities/$id'
      preLoaderRoute: typeof AdminLayoutCrmOpportunitiesIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/crm/tasks_/$id': {
      id: '/admin/_layout/crm/tasks_/$id'
      path: '/tasks/$id'
      fullPath: '/admin/crm/tasks/$id'
      preLoaderRoute: typeof AdminLayoutCrmTasksIdRouteImport
      parentRoute: typeof AdminLayoutCrmRoute
    }
    '/admin/_layout/expense/reports_/$id': {
      id: '/admin/_layout/expense/reports_/$id'
      path: '/reports/$id'
      fullPath: '/admin/expense/reports/$id'
      preLoaderRoute: typeof AdminLayoutExpenseReportsIdRouteImport
      parentRoute: typeof AdminLayoutExpenseRoute
    }
    '/admin/_layout/inventory/adjustments_/$id': {
      id: '/admin/_layout/inventory/adjustments_/$id'
      path: '/adjustments/$id'
      fullPath: '/admin/inventory/adjustments/$id'
      preLoaderRoute: typeof AdminLayoutInventoryAdjustmentsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/asset-items_/$id': {
      id: '/admin/_layout/inventory/asset-items_/$id'
      path: '/asset-items/$id'
      fullPath: '/admin/inventory/asset-items/$id'
      preLoaderRoute: typeof AdminLayoutInventoryAssetItemsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/bills_/$id': {
      id: '/admin/_layout/inventory/bills_/$id'
      path: '/bills/$id'
      fullPath: '/admin/inventory/bills/$id'
      preLoaderRoute: typeof AdminLayoutInventoryBillsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/challans_/$id': {
      id: '/admin/_layout/inventory/challans_/$id'
      path: '/challans/$id'
      fullPath: '/admin/inventory/challans/$id'
      preLoaderRoute: typeof AdminLayoutInventoryChallansIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/damages_/$id': {
      id: '/admin/_layout/inventory/damages_/$id'
      path: '/damages/$id'
      fullPath: '/admin/inventory/damages/$id'
      preLoaderRoute: typeof AdminLayoutInventoryDamagesIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/delivery-orders_/$id': {
      id: '/admin/_layout/inventory/delivery-orders_/$id'
      path: '/delivery-orders/$id'
      fullPath: '/admin/inventory/delivery-orders/$id'
      preLoaderRoute: typeof AdminLayoutInventoryDeliveryOrdersIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/deployment-manifests_/$id': {
      id: '/admin/_layout/inventory/deployment-manifests_/$id'
      path: '/deployment-manifests/$id'
      fullPath: '/admin/inventory/deployment-manifests/$id'
      preLoaderRoute: typeof AdminLayoutInventoryDeploymentManifestsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inbound-rental-agreements_/$id': {
      id: '/admin/_layout/inventory/inbound-rental-agreements_/$id'
      path: '/inbound-rental-agreements/$id'
      fullPath: '/admin/inventory/inbound-rental-agreements/$id'
      preLoaderRoute: typeof AdminLayoutInventoryInboundRentalAgreementsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inspection-checklists_/$id': {
      id: '/admin/_layout/inventory/inspection-checklists_/$id'
      path: '/inspection-checklists/$id'
      fullPath: '/admin/inventory/inspection-checklists/$id'
      preLoaderRoute: typeof AdminLayoutInventoryInspectionChecklistsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/inspections_/$id': {
      id: '/admin/_layout/inventory/inspections_/$id'
      path: '/inspections/$id'
      fullPath: '/admin/inventory/inspections/$id'
      preLoaderRoute: typeof AdminLayoutInventoryInspectionsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/invoices_/$id': {
      id: '/admin/_layout/inventory/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/admin/inventory/invoices/$id'
      preLoaderRoute: typeof AdminLayoutInventoryInvoicesIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/items_/$id': {
      id: '/admin/_layout/inventory/items_/$id'
      path: '/items/$id'
      fullPath: '/admin/inventory/items/$id'
      preLoaderRoute: typeof AdminLayoutInventoryItemsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/price-books_/$id': {
      id: '/admin/_layout/inventory/price-books_/$id'
      path: '/price-books/$id'
      fullPath: '/admin/inventory/price-books/$id'
      preLoaderRoute: typeof AdminLayoutInventoryPriceBooksIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/purchase-orders_/$id': {
      id: '/admin/_layout/inventory/purchase-orders_/$id'
      path: '/purchase-orders/$id'
      fullPath: '/admin/inventory/purchase-orders/$id'
      preLoaderRoute: typeof AdminLayoutInventoryPurchaseOrdersIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/quotes_/$id': {
      id: '/admin/_layout/inventory/quotes_/$id'
      path: '/quotes/$id'
      fullPath: '/admin/inventory/quotes/$id'
      preLoaderRoute: typeof AdminLayoutInventoryQuotesIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/rental-contracts_/$id': {
      id: '/admin/_layout/inventory/rental-contracts_/$id'
      path: '/rental-contracts/$id'
      fullPath: '/admin/inventory/rental-contracts/$id'
      preLoaderRoute: typeof AdminLayoutInventoryRentalContractsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/requisitions_/$id': {
      id: '/admin/_layout/inventory/requisitions_/$id'
      path: '/requisitions/$id'
      fullPath: '/admin/inventory/requisitions/$id'
      preLoaderRoute: typeof AdminLayoutInventoryRequisitionsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/returns_/$id': {
      id: '/admin/_layout/inventory/returns_/$id'
      path: '/returns/$id'
      fullPath: '/admin/inventory/returns/$id'
      preLoaderRoute: typeof AdminLayoutInventoryReturnsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/sales-orders_/$id': {
      id: '/admin/_layout/inventory/sales-orders_/$id'
      path: '/sales-orders/$id'
      fullPath: '/admin/inventory/sales-orders/$id'
      preLoaderRoute: typeof AdminLayoutInventorySalesOrdersIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/transfers_/$id': {
      id: '/admin/_layout/inventory/transfers_/$id'
      path: '/transfers/$id'
      fullPath: '/admin/inventory/transfers/$id'
      preLoaderRoute: typeof AdminLayoutInventoryTransfersIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/vendors_/$id': {
      id: '/admin/_layout/inventory/vendors_/$id'
      path: '/vendors/$id'
      fullPath: '/admin/inventory/vendors/$id'
      preLoaderRoute: typeof AdminLayoutInventoryVendorsIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/inventory/warehouses_/$id': {
      id: '/admin/_layout/inventory/warehouses_/$id'
      path: '/warehouses/$id'
      fullPath: '/admin/inventory/warehouses/$id'
      preLoaderRoute: typeof AdminLayoutInventoryWarehousesIdRouteImport
      parentRoute: typeof AdminLayoutInventoryRoute
    }
    '/admin/_layout/leave/balances_/$userId': {
      id: '/admin/_layout/leave/balances_/$userId'
      path: '/balances/$userId'
      fullPath: '/admin/leave/balances/$userId'
      preLoaderRoute: typeof AdminLayoutLeaveBalancesUserIdRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/leave/requests_/$userId': {
      id: '/admin/_layout/leave/requests_/$userId'
      path: '/requests/$userId'
      fullPath: '/admin/leave/requests/$userId'
      preLoaderRoute: typeof AdminLayoutLeaveRequestsUserIdRouteImport
      parentRoute: typeof AdminLayoutLeaveRoute
    }
    '/admin/_layout/overtime/monitoring_/$id': {
      id: '/admin/_layout/overtime/monitoring_/$id'
      path: '/overtime/monitoring/$id'
      fullPath: '/admin/overtime/monitoring/$id'
      preLoaderRoute: typeof AdminLayoutOvertimeMonitoringIdRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/_layout/payroll/advances_/$userId': {
      id: '/admin/_layout/payroll/advances_/$userId'
      path: '/advances/$userId'
      fullPath: '/admin/payroll/advances/$userId'
      preLoaderRoute: typeof AdminLayoutPayrollAdvancesUserIdRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/admin/_layout/payroll/payslips_/$userId': {
      id: '/admin/_layout/payroll/payslips_/$userId'
      path: '/payslips/$userId'
      fullPath: '/admin/payroll/payslips/$userId'
      preLoaderRoute: typeof AdminLayoutPayrollPayslipsUserIdRouteImport
      parentRoute: typeof AdminLayoutPayrollRoute
    }
    '/user/_layout/crm/accounts_/$id': {
      id: '/user/_layout/crm/accounts_/$id'
      path: '/accounts/$id'
      fullPath: '/user/crm/accounts/$id'
      preLoaderRoute: typeof UserLayoutCrmAccountsIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/cases_/$id': {
      id: '/user/_layout/crm/cases_/$id'
      path: '/cases/$id'
      fullPath: '/user/crm/cases/$id'
      preLoaderRoute: typeof UserLayoutCrmCasesIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/contacts_/$id': {
      id: '/user/_layout/crm/contacts_/$id'
      path: '/contacts/$id'
      fullPath: '/user/crm/contacts/$id'
      preLoaderRoute: typeof UserLayoutCrmContactsIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/leads_/$id': {
      id: '/user/_layout/crm/leads_/$id'
      path: '/leads/$id'
      fullPath: '/user/crm/leads/$id'
      preLoaderRoute: typeof UserLayoutCrmLeadsIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/opportunities_/$id': {
      id: '/user/_layout/crm/opportunities_/$id'
      path: '/opportunities/$id'
      fullPath: '/user/crm/opportunities/$id'
      preLoaderRoute: typeof UserLayoutCrmOpportunitiesIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/crm/tasks_/$id': {
      id: '/user/_layout/crm/tasks_/$id'
      path: '/tasks/$id'
      fullPath: '/user/crm/tasks/$id'
      preLoaderRoute: typeof UserLayoutCrmTasksIdRouteImport
      parentRoute: typeof UserLayoutCrmRoute
    }
    '/user/_layout/inventory/requisitions_/$id': {
      id: '/user/_layout/inventory/requisitions_/$id'
      path: '/inventory/requisitions/$id'
      fullPath: '/user/inventory/requisitions/$id'
      preLoaderRoute: typeof UserLayoutInventoryRequisitionsIdRouteImport
      parentRoute: typeof UserLayoutRoute
    }
  }
}

interface AdminLayoutAttendanceRouteChildren {
  AdminLayoutAttendanceAdjustmentsRoute: typeof AdminLayoutAttendanceAdjustmentsRoute
  AdminLayoutAttendanceAssignmentsRoute: typeof AdminLayoutAttendanceAssignmentsRoute
  AdminLayoutAttendanceShiftPolicyRoute: typeof AdminLayoutAttendanceShiftPolicyRoute
  AdminLayoutAttendanceShiftsRoute: typeof AdminLayoutAttendanceShiftsRoute
  AdminLayoutAttendanceTimesheetsRoute: typeof AdminLayoutAttendanceTimesheetsRoute
  AdminLayoutAttendanceIndexRoute: typeof AdminLayoutAttendanceIndexRoute
  AdminLayoutAttendanceTimesheetsUserIdRoute: typeof AdminLayoutAttendanceTimesheetsUserIdRoute
}

const AdminLayoutAttendanceRouteChildren: AdminLayoutAttendanceRouteChildren = {
  AdminLayoutAttendanceAdjustmentsRoute: AdminLayoutAttendanceAdjustmentsRoute,
  AdminLayoutAttendanceAssignmentsRoute: AdminLayoutAttendanceAssignmentsRoute,
  AdminLayoutAttendanceShiftPolicyRoute: AdminLayoutAttendanceShiftPolicyRoute,
  AdminLayoutAttendanceShiftsRoute: AdminLayoutAttendanceShiftsRoute,
  AdminLayoutAttendanceTimesheetsRoute: AdminLayoutAttendanceTimesheetsRoute,
  AdminLayoutAttendanceIndexRoute: AdminLayoutAttendanceIndexRoute,
  AdminLayoutAttendanceTimesheetsUserIdRoute:
    AdminLayoutAttendanceTimesheetsUserIdRoute,
}

const AdminLayoutAttendanceRouteWithChildren =
  AdminLayoutAttendanceRoute._addFileChildren(
    AdminLayoutAttendanceRouteChildren,
  )

interface AdminLayoutCrmRouteChildren {
  AdminLayoutCrmAccountsRoute: typeof AdminLayoutCrmAccountsRoute
  AdminLayoutCrmCalendarRoute: typeof AdminLayoutCrmCalendarRoute
  AdminLayoutCrmCallsRoute: typeof AdminLayoutCrmCallsRoute
  AdminLayoutCrmCasesRoute: typeof AdminLayoutCrmCasesRoute
  AdminLayoutCrmContactsRoute: typeof AdminLayoutCrmContactsRoute
  AdminLayoutCrmEmailsRoute: typeof AdminLayoutCrmEmailsRoute
  AdminLayoutCrmLeadsRoute: typeof AdminLayoutCrmLeadsRoute
  AdminLayoutCrmMeetingsRoute: typeof AdminLayoutCrmMeetingsRoute
  AdminLayoutCrmOpportunitiesRoute: typeof AdminLayoutCrmOpportunitiesRoute
  AdminLayoutCrmReportsRoute: typeof AdminLayoutCrmReportsRoute
  AdminLayoutCrmTasksRoute: typeof AdminLayoutCrmTasksRoute
  AdminLayoutCrmTeamsRoute: typeof AdminLayoutCrmTeamsRoute
  AdminLayoutCrmIndexRoute: typeof AdminLayoutCrmIndexRoute
  AdminLayoutCrmAccountsIdRoute: typeof AdminLayoutCrmAccountsIdRoute
  AdminLayoutCrmCasesIdRoute: typeof AdminLayoutCrmCasesIdRoute
  AdminLayoutCrmContactsIdRoute: typeof AdminLayoutCrmContactsIdRoute
  AdminLayoutCrmLeadsIdRoute: typeof AdminLayoutCrmLeadsIdRoute
  AdminLayoutCrmOpportunitiesIdRoute: typeof AdminLayoutCrmOpportunitiesIdRoute
  AdminLayoutCrmTasksIdRoute: typeof AdminLayoutCrmTasksIdRoute
}

const AdminLayoutCrmRouteChildren: AdminLayoutCrmRouteChildren = {
  AdminLayoutCrmAccountsRoute: AdminLayoutCrmAccountsRoute,
  AdminLayoutCrmCalendarRoute: AdminLayoutCrmCalendarRoute,
  AdminLayoutCrmCallsRoute: AdminLayoutCrmCallsRoute,
  AdminLayoutCrmCasesRoute: AdminLayoutCrmCasesRoute,
  AdminLayoutCrmContactsRoute: AdminLayoutCrmContactsRoute,
  AdminLayoutCrmEmailsRoute: AdminLayoutCrmEmailsRoute,
  AdminLayoutCrmLeadsRoute: AdminLayoutCrmLeadsRoute,
  AdminLayoutCrmMeetingsRoute: AdminLayoutCrmMeetingsRoute,
  AdminLayoutCrmOpportunitiesRoute: AdminLayoutCrmOpportunitiesRoute,
  AdminLayoutCrmReportsRoute: AdminLayoutCrmReportsRoute,
  AdminLayoutCrmTasksRoute: AdminLayoutCrmTasksRoute,
  AdminLayoutCrmTeamsRoute: AdminLayoutCrmTeamsRoute,
  AdminLayoutCrmIndexRoute: AdminLayoutCrmIndexRoute,
  AdminLayoutCrmAccountsIdRoute: AdminLayoutCrmAccountsIdRoute,
  AdminLayoutCrmCasesIdRoute: AdminLayoutCrmCasesIdRoute,
  AdminLayoutCrmContactsIdRoute: AdminLayoutCrmContactsIdRoute,
  AdminLayoutCrmLeadsIdRoute: AdminLayoutCrmLeadsIdRoute,
  AdminLayoutCrmOpportunitiesIdRoute: AdminLayoutCrmOpportunitiesIdRoute,
  AdminLayoutCrmTasksIdRoute: AdminLayoutCrmTasksIdRoute,
}

const AdminLayoutCrmRouteWithChildren = AdminLayoutCrmRoute._addFileChildren(
  AdminLayoutCrmRouteChildren,
)

interface AdminLayoutDocumentsRouteChildren {
  AdminLayoutDocumentsCompanyRoute: typeof AdminLayoutDocumentsCompanyRoute
  AdminLayoutDocumentsEmployeeRoute: typeof AdminLayoutDocumentsEmployeeRoute
  AdminLayoutDocumentsIndexRoute: typeof AdminLayoutDocumentsIndexRoute
}

const AdminLayoutDocumentsRouteChildren: AdminLayoutDocumentsRouteChildren = {
  AdminLayoutDocumentsCompanyRoute: AdminLayoutDocumentsCompanyRoute,
  AdminLayoutDocumentsEmployeeRoute: AdminLayoutDocumentsEmployeeRoute,
  AdminLayoutDocumentsIndexRoute: AdminLayoutDocumentsIndexRoute,
}

const AdminLayoutDocumentsRouteWithChildren =
  AdminLayoutDocumentsRoute._addFileChildren(AdminLayoutDocumentsRouteChildren)

interface AdminLayoutExpenseRouteChildren {
  AdminLayoutExpenseCategoriesRoute: typeof AdminLayoutExpenseCategoriesRoute
  AdminLayoutExpenseReportsRoute: typeof AdminLayoutExpenseReportsRoute
  AdminLayoutExpenseSettingsRoute: typeof AdminLayoutExpenseSettingsRoute
  AdminLayoutExpenseIndexRoute: typeof AdminLayoutExpenseIndexRoute
  AdminLayoutExpenseReportsIdRoute: typeof AdminLayoutExpenseReportsIdRoute
}

const AdminLayoutExpenseRouteChildren: AdminLayoutExpenseRouteChildren = {
  AdminLayoutExpenseCategoriesRoute: AdminLayoutExpenseCategoriesRoute,
  AdminLayoutExpenseReportsRoute: AdminLayoutExpenseReportsRoute,
  AdminLayoutExpenseSettingsRoute: AdminLayoutExpenseSettingsRoute,
  AdminLayoutExpenseIndexRoute: AdminLayoutExpenseIndexRoute,
  AdminLayoutExpenseReportsIdRoute: AdminLayoutExpenseReportsIdRoute,
}

const AdminLayoutExpenseRouteWithChildren =
  AdminLayoutExpenseRoute._addFileChildren(AdminLayoutExpenseRouteChildren)

interface AdminLayoutInventoryRouteChildren {
  AdminLayoutInventoryAdjustmentsRoute: typeof AdminLayoutInventoryAdjustmentsRoute
  AdminLayoutInventoryAssetIncidentsRoute: typeof AdminLayoutInventoryAssetIncidentsRoute
  AdminLayoutInventoryAssetItemsRoute: typeof AdminLayoutInventoryAssetItemsRoute
  AdminLayoutInventoryAssetSafetyInspectionsRoute: typeof AdminLayoutInventoryAssetSafetyInspectionsRoute
  AdminLayoutInventoryBillsRoute: typeof AdminLayoutInventoryBillsRoute
  AdminLayoutInventoryCategoriesRoute: typeof AdminLayoutInventoryCategoriesRoute
  AdminLayoutInventoryChallansRoute: typeof AdminLayoutInventoryChallansRoute
  AdminLayoutInventoryCollectionsRoute: typeof AdminLayoutInventoryCollectionsRoute
  AdminLayoutInventoryCustomerReturnsRoute: typeof AdminLayoutInventoryCustomerReturnsRoute
  AdminLayoutInventoryDamagesRoute: typeof AdminLayoutInventoryDamagesRoute
  AdminLayoutInventoryDeliveryOrdersRoute: typeof AdminLayoutInventoryDeliveryOrdersRoute
  AdminLayoutInventoryDeploymentManifestsRoute: typeof AdminLayoutInventoryDeploymentManifestsRoute
  AdminLayoutInventoryInboundRentalAgreementsRoute: typeof AdminLayoutInventoryInboundRentalAgreementsRoute
  AdminLayoutInventoryInspectionChecklistsRoute: typeof AdminLayoutInventoryInspectionChecklistsRoute
  AdminLayoutInventoryInspectionFrequenciesRoute: typeof AdminLayoutInventoryInspectionFrequenciesRoute
  AdminLayoutInventoryInspectionsRoute: typeof AdminLayoutInventoryInspectionsRoute
  AdminLayoutInventoryInvoicesRoute: typeof AdminLayoutInventoryInvoicesRoute
  AdminLayoutInventoryItemPricesRoute: typeof AdminLayoutInventoryItemPricesRoute
  AdminLayoutInventoryItemsRoute: typeof AdminLayoutInventoryItemsRoute
  AdminLayoutInventoryLabelsRoute: typeof AdminLayoutInventoryLabelsRoute
  AdminLayoutInventoryPriceBooksRoute: typeof AdminLayoutInventoryPriceBooksRoute
  AdminLayoutInventoryPurchaseOrdersRoute: typeof AdminLayoutInventoryPurchaseOrdersRoute
  AdminLayoutInventoryQuotesRoute: typeof AdminLayoutInventoryQuotesRoute
  AdminLayoutInventoryRentalContractsRoute: typeof AdminLayoutInventoryRentalContractsRoute
  AdminLayoutInventoryReportsRoute: typeof AdminLayoutInventoryReportsRoute
  AdminLayoutInventoryRequisitionsRoute: typeof AdminLayoutInventoryRequisitionsRoute
  AdminLayoutInventoryReturnsRoute: typeof AdminLayoutInventoryReturnsRoute
  AdminLayoutInventorySalesOrdersRoute: typeof AdminLayoutInventorySalesOrdersRoute
  AdminLayoutInventorySettingsRoute: typeof AdminLayoutInventorySettingsRoute
  AdminLayoutInventoryStockLevelsRoute: typeof AdminLayoutInventoryStockLevelsRoute
  AdminLayoutInventorySupplierPricesRoute: typeof AdminLayoutInventorySupplierPricesRoute
  AdminLayoutInventoryTransactionsRoute: typeof AdminLayoutInventoryTransactionsRoute
  AdminLayoutInventoryTransfersRoute: typeof AdminLayoutInventoryTransfersRoute
  AdminLayoutInventoryUnitConversionsRoute: typeof AdminLayoutInventoryUnitConversionsRoute
  AdminLayoutInventoryUnitsRoute: typeof AdminLayoutInventoryUnitsRoute
  AdminLayoutInventoryVendorsRoute: typeof AdminLayoutInventoryVendorsRoute
  AdminLayoutInventoryWarehousesRoute: typeof AdminLayoutInventoryWarehousesRoute
  AdminLayoutInventoryIndexRoute: typeof AdminLayoutInventoryIndexRoute
  AdminLayoutInventoryAdjustmentsIdRoute: typeof AdminLayoutInventoryAdjustmentsIdRoute
  AdminLayoutInventoryAssetItemsIdRoute: typeof AdminLayoutInventoryAssetItemsIdRoute
  AdminLayoutInventoryBillsIdRoute: typeof AdminLayoutInventoryBillsIdRoute
  AdminLayoutInventoryChallansIdRoute: typeof AdminLayoutInventoryChallansIdRoute
  AdminLayoutInventoryDamagesIdRoute: typeof AdminLayoutInventoryDamagesIdRoute
  AdminLayoutInventoryDeliveryOrdersIdRoute: typeof AdminLayoutInventoryDeliveryOrdersIdRoute
  AdminLayoutInventoryDeploymentManifestsIdRoute: typeof AdminLayoutInventoryDeploymentManifestsIdRoute
  AdminLayoutInventoryInboundRentalAgreementsIdRoute: typeof AdminLayoutInventoryInboundRentalAgreementsIdRoute
  AdminLayoutInventoryInspectionChecklistsIdRoute: typeof AdminLayoutInventoryInspectionChecklistsIdRoute
  AdminLayoutInventoryInspectionsIdRoute: typeof AdminLayoutInventoryInspectionsIdRoute
  AdminLayoutInventoryInvoicesIdRoute: typeof AdminLayoutInventoryInvoicesIdRoute
  AdminLayoutInventoryItemsIdRoute: typeof AdminLayoutInventoryItemsIdRoute
  AdminLayoutInventoryPriceBooksIdRoute: typeof AdminLayoutInventoryPriceBooksIdRoute
  AdminLayoutInventoryPurchaseOrdersIdRoute: typeof AdminLayoutInventoryPurchaseOrdersIdRoute
  AdminLayoutInventoryQuotesIdRoute: typeof AdminLayoutInventoryQuotesIdRoute
  AdminLayoutInventoryRentalContractsIdRoute: typeof AdminLayoutInventoryRentalContractsIdRoute
  AdminLayoutInventoryRequisitionsIdRoute: typeof AdminLayoutInventoryRequisitionsIdRoute
  AdminLayoutInventoryReturnsIdRoute: typeof AdminLayoutInventoryReturnsIdRoute
  AdminLayoutInventorySalesOrdersIdRoute: typeof AdminLayoutInventorySalesOrdersIdRoute
  AdminLayoutInventoryTransfersIdRoute: typeof AdminLayoutInventoryTransfersIdRoute
  AdminLayoutInventoryVendorsIdRoute: typeof AdminLayoutInventoryVendorsIdRoute
  AdminLayoutInventoryWarehousesIdRoute: typeof AdminLayoutInventoryWarehousesIdRoute
}

const AdminLayoutInventoryRouteChildren: AdminLayoutInventoryRouteChildren = {
  AdminLayoutInventoryAdjustmentsRoute: AdminLayoutInventoryAdjustmentsRoute,
  AdminLayoutInventoryAssetIncidentsRoute:
    AdminLayoutInventoryAssetIncidentsRoute,
  AdminLayoutInventoryAssetItemsRoute: AdminLayoutInventoryAssetItemsRoute,
  AdminLayoutInventoryAssetSafetyInspectionsRoute:
    AdminLayoutInventoryAssetSafetyInspectionsRoute,
  AdminLayoutInventoryBillsRoute: AdminLayoutInventoryBillsRoute,
  AdminLayoutInventoryCategoriesRoute: AdminLayoutInventoryCategoriesRoute,
  AdminLayoutInventoryChallansRoute: AdminLayoutInventoryChallansRoute,
  AdminLayoutInventoryCollectionsRoute: AdminLayoutInventoryCollectionsRoute,
  AdminLayoutInventoryCustomerReturnsRoute:
    AdminLayoutInventoryCustomerReturnsRoute,
  AdminLayoutInventoryDamagesRoute: AdminLayoutInventoryDamagesRoute,
  AdminLayoutInventoryDeliveryOrdersRoute:
    AdminLayoutInventoryDeliveryOrdersRoute,
  AdminLayoutInventoryDeploymentManifestsRoute:
    AdminLayoutInventoryDeploymentManifestsRoute,
  AdminLayoutInventoryInboundRentalAgreementsRoute:
    AdminLayoutInventoryInboundRentalAgreementsRoute,
  AdminLayoutInventoryInspectionChecklistsRoute:
    AdminLayoutInventoryInspectionChecklistsRoute,
  AdminLayoutInventoryInspectionFrequenciesRoute:
    AdminLayoutInventoryInspectionFrequenciesRoute,
  AdminLayoutInventoryInspectionsRoute: AdminLayoutInventoryInspectionsRoute,
  AdminLayoutInventoryInvoicesRoute: AdminLayoutInventoryInvoicesRoute,
  AdminLayoutInventoryItemPricesRoute: AdminLayoutInventoryItemPricesRoute,
  AdminLayoutInventoryItemsRoute: AdminLayoutInventoryItemsRoute,
  AdminLayoutInventoryLabelsRoute: AdminLayoutInventoryLabelsRoute,
  AdminLayoutInventoryPriceBooksRoute: AdminLayoutInventoryPriceBooksRoute,
  AdminLayoutInventoryPurchaseOrdersRoute:
    AdminLayoutInventoryPurchaseOrdersRoute,
  AdminLayoutInventoryQuotesRoute: AdminLayoutInventoryQuotesRoute,
  AdminLayoutInventoryRentalContractsRoute:
    AdminLayoutInventoryRentalContractsRoute,
  AdminLayoutInventoryReportsRoute: AdminLayoutInventoryReportsRoute,
  AdminLayoutInventoryRequisitionsRoute: AdminLayoutInventoryRequisitionsRoute,
  AdminLayoutInventoryReturnsRoute: AdminLayoutInventoryReturnsRoute,
  AdminLayoutInventorySalesOrdersRoute: AdminLayoutInventorySalesOrdersRoute,
  AdminLayoutInventorySettingsRoute: AdminLayoutInventorySettingsRoute,
  AdminLayoutInventoryStockLevelsRoute: AdminLayoutInventoryStockLevelsRoute,
  AdminLayoutInventorySupplierPricesRoute:
    AdminLayoutInventorySupplierPricesRoute,
  AdminLayoutInventoryTransactionsRoute: AdminLayoutInventoryTransactionsRoute,
  AdminLayoutInventoryTransfersRoute: AdminLayoutInventoryTransfersRoute,
  AdminLayoutInventoryUnitConversionsRoute:
    AdminLayoutInventoryUnitConversionsRoute,
  AdminLayoutInventoryUnitsRoute: AdminLayoutInventoryUnitsRoute,
  AdminLayoutInventoryVendorsRoute: AdminLayoutInventoryVendorsRoute,
  AdminLayoutInventoryWarehousesRoute: AdminLayoutInventoryWarehousesRoute,
  AdminLayoutInventoryIndexRoute: AdminLayoutInventoryIndexRoute,
  AdminLayoutInventoryAdjustmentsIdRoute:
    AdminLayoutInventoryAdjustmentsIdRoute,
  AdminLayoutInventoryAssetItemsIdRoute: AdminLayoutInventoryAssetItemsIdRoute,
  AdminLayoutInventoryBillsIdRoute: AdminLayoutInventoryBillsIdRoute,
  AdminLayoutInventoryChallansIdRoute: AdminLayoutInventoryChallansIdRoute,
  AdminLayoutInventoryDamagesIdRoute: AdminLayoutInventoryDamagesIdRoute,
  AdminLayoutInventoryDeliveryOrdersIdRoute:
    AdminLayoutInventoryDeliveryOrdersIdRoute,
  AdminLayoutInventoryDeploymentManifestsIdRoute:
    AdminLayoutInventoryDeploymentManifestsIdRoute,
  AdminLayoutInventoryInboundRentalAgreementsIdRoute:
    AdminLayoutInventoryInboundRentalAgreementsIdRoute,
  AdminLayoutInventoryInspectionChecklistsIdRoute:
    AdminLayoutInventoryInspectionChecklistsIdRoute,
  AdminLayoutInventoryInspectionsIdRoute:
    AdminLayoutInventoryInspectionsIdRoute,
  AdminLayoutInventoryInvoicesIdRoute: AdminLayoutInventoryInvoicesIdRoute,
  AdminLayoutInventoryItemsIdRoute: AdminLayoutInventoryItemsIdRoute,
  AdminLayoutInventoryPriceBooksIdRoute: AdminLayoutInventoryPriceBooksIdRoute,
  AdminLayoutInventoryPurchaseOrdersIdRoute:
    AdminLayoutInventoryPurchaseOrdersIdRoute,
  AdminLayoutInventoryQuotesIdRoute: AdminLayoutInventoryQuotesIdRoute,
  AdminLayoutInventoryRentalContractsIdRoute:
    AdminLayoutInventoryRentalContractsIdRoute,
  AdminLayoutInventoryRequisitionsIdRoute:
    AdminLayoutInventoryRequisitionsIdRoute,
  AdminLayoutInventoryReturnsIdRoute: AdminLayoutInventoryReturnsIdRoute,
  AdminLayoutInventorySalesOrdersIdRoute:
    AdminLayoutInventorySalesOrdersIdRoute,
  AdminLayoutInventoryTransfersIdRoute: AdminLayoutInventoryTransfersIdRoute,
  AdminLayoutInventoryVendorsIdRoute: AdminLayoutInventoryVendorsIdRoute,
  AdminLayoutInventoryWarehousesIdRoute: AdminLayoutInventoryWarehousesIdRoute,
}

const AdminLayoutInventoryRouteWithChildren =
  AdminLayoutInventoryRoute._addFileChildren(AdminLayoutInventoryRouteChildren)

interface AdminLayoutLeaveRouteChildren {
  AdminLayoutLeaveAccrualLogsRoute: typeof AdminLayoutLeaveAccrualLogsRoute
  AdminLayoutLeaveAccrualRulesRoute: typeof AdminLayoutLeaveAccrualRulesRoute
  AdminLayoutLeaveBalancesRoute: typeof AdminLayoutLeaveBalancesRoute
  AdminLayoutLeavePolicyRoute: typeof AdminLayoutLeavePolicyRoute
  AdminLayoutLeaveRequestsRoute: typeof AdminLayoutLeaveRequestsRoute
  AdminLayoutLeaveTypesRoute: typeof AdminLayoutLeaveTypesRoute
  AdminLayoutLeaveIndexRoute: typeof AdminLayoutLeaveIndexRoute
  AdminLayoutLeaveBalancesUserIdRoute: typeof AdminLayoutLeaveBalancesUserIdRoute
  AdminLayoutLeaveRequestsUserIdRoute: typeof AdminLayoutLeaveRequestsUserIdRoute
}

const AdminLayoutLeaveRouteChildren: AdminLayoutLeaveRouteChildren = {
  AdminLayoutLeaveAccrualLogsRoute: AdminLayoutLeaveAccrualLogsRoute,
  AdminLayoutLeaveAccrualRulesRoute: AdminLayoutLeaveAccrualRulesRoute,
  AdminLayoutLeaveBalancesRoute: AdminLayoutLeaveBalancesRoute,
  AdminLayoutLeavePolicyRoute: AdminLayoutLeavePolicyRoute,
  AdminLayoutLeaveRequestsRoute: AdminLayoutLeaveRequestsRoute,
  AdminLayoutLeaveTypesRoute: AdminLayoutLeaveTypesRoute,
  AdminLayoutLeaveIndexRoute: AdminLayoutLeaveIndexRoute,
  AdminLayoutLeaveBalancesUserIdRoute: AdminLayoutLeaveBalancesUserIdRoute,
  AdminLayoutLeaveRequestsUserIdRoute: AdminLayoutLeaveRequestsUserIdRoute,
}

const AdminLayoutLeaveRouteWithChildren =
  AdminLayoutLeaveRoute._addFileChildren(AdminLayoutLeaveRouteChildren)

interface AdminLayoutPayrollRouteChildren {
  AdminLayoutPayrollAdvancesRoute: typeof AdminLayoutPayrollAdvancesRoute
  AdminLayoutPayrollPayslipsRoute: typeof AdminLayoutPayrollPayslipsRoute
  AdminLayoutPayrollSalariesRoute: typeof AdminLayoutPayrollSalariesRoute
  AdminLayoutPayrollSettingsRoute: typeof AdminLayoutPayrollSettingsRoute
  AdminLayoutPayrollTaxBracketsRoute: typeof AdminLayoutPayrollTaxBracketsRoute
  AdminLayoutPayrollIndexRoute: typeof AdminLayoutPayrollIndexRoute
  AdminLayoutPayrollAdvancesUserIdRoute: typeof AdminLayoutPayrollAdvancesUserIdRoute
  AdminLayoutPayrollPayslipsUserIdRoute: typeof AdminLayoutPayrollPayslipsUserIdRoute
}

const AdminLayoutPayrollRouteChildren: AdminLayoutPayrollRouteChildren = {
  AdminLayoutPayrollAdvancesRoute: AdminLayoutPayrollAdvancesRoute,
  AdminLayoutPayrollPayslipsRoute: AdminLayoutPayrollPayslipsRoute,
  AdminLayoutPayrollSalariesRoute: AdminLayoutPayrollSalariesRoute,
  AdminLayoutPayrollSettingsRoute: AdminLayoutPayrollSettingsRoute,
  AdminLayoutPayrollTaxBracketsRoute: AdminLayoutPayrollTaxBracketsRoute,
  AdminLayoutPayrollIndexRoute: AdminLayoutPayrollIndexRoute,
  AdminLayoutPayrollAdvancesUserIdRoute: AdminLayoutPayrollAdvancesUserIdRoute,
  AdminLayoutPayrollPayslipsUserIdRoute: AdminLayoutPayrollPayslipsUserIdRoute,
}

const AdminLayoutPayrollRouteWithChildren =
  AdminLayoutPayrollRoute._addFileChildren(AdminLayoutPayrollRouteChildren)

interface AdminLayoutRouteChildren {
  AdminLayoutAttendanceRoute: typeof AdminLayoutAttendanceRouteWithChildren
  AdminLayoutAuditLogRoute: typeof AdminLayoutAuditLogRoute
  AdminLayoutCalendarRoute: typeof AdminLayoutCalendarRoute
  AdminLayoutCrmRoute: typeof AdminLayoutCrmRouteWithChildren
  AdminLayoutDocumentsRoute: typeof AdminLayoutDocumentsRouteWithChildren
  AdminLayoutExpenseRoute: typeof AdminLayoutExpenseRouteWithChildren
  AdminLayoutInventoryRoute: typeof AdminLayoutInventoryRouteWithChildren
  AdminLayoutLeaveRoute: typeof AdminLayoutLeaveRouteWithChildren
  AdminLayoutNotificationSettingsRoute: typeof AdminLayoutNotificationSettingsRoute
  AdminLayoutNotificationsRoute: typeof AdminLayoutNotificationsRoute
  AdminLayoutPayrollRoute: typeof AdminLayoutPayrollRouteWithChildren
  AdminLayoutProfileManagementRoute: typeof AdminLayoutProfileManagementRoute
  AdminLayoutProjectsRoute: typeof AdminLayoutProjectsRoute
  AdminLayoutReportsRoute: typeof AdminLayoutReportsRoute
  AdminLayoutTasksRoute: typeof AdminLayoutTasksRoute
  AdminLayoutUsersRoute: typeof AdminLayoutUsersRoute
  AdminLayoutIndexRoute: typeof AdminLayoutIndexRoute
  AdminLayoutOrganizationBranchesRoute: typeof AdminLayoutOrganizationBranchesRoute
  AdminLayoutOrganizationDepartmentsRoute: typeof AdminLayoutOrganizationDepartmentsRoute
  AdminLayoutOrganizationDeviceEmployeesRoute: typeof AdminLayoutOrganizationDeviceEmployeesRoute
  AdminLayoutOrganizationDevicesRoute: typeof AdminLayoutOrganizationDevicesRoute
  AdminLayoutOrganizationFiscalYearsRoute: typeof AdminLayoutOrganizationFiscalYearsRoute
  AdminLayoutOrganizationRolesRoute: typeof AdminLayoutOrganizationRolesRoute
  AdminLayoutOvertimeMonitoringRoute: typeof AdminLayoutOvertimeMonitoringRoute
  AdminLayoutProjectsIdRoute: typeof AdminLayoutProjectsIdRoute
  AdminLayoutReportsUserIdRoute: typeof AdminLayoutReportsUserIdRoute
  AdminLayoutTasksIdRoute: typeof AdminLayoutTasksIdRoute
  AdminLayoutUsersIdRoute: typeof AdminLayoutUsersIdRoute
  AdminLayoutOvertimeMonitoringIdRoute: typeof AdminLayoutOvertimeMonitoringIdRoute
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminLayoutAttendanceRoute: AdminLayoutAttendanceRouteWithChildren,
  AdminLayoutAuditLogRoute: AdminLayoutAuditLogRoute,
  AdminLayoutCalendarRoute: AdminLayoutCalendarRoute,
  AdminLayoutCrmRoute: AdminLayoutCrmRouteWithChildren,
  AdminLayoutDocumentsRoute: AdminLayoutDocumentsRouteWithChildren,
  AdminLayoutExpenseRoute: AdminLayoutExpenseRouteWithChildren,
  AdminLayoutInventoryRoute: AdminLayoutInventoryRouteWithChildren,
  AdminLayoutLeaveRoute: AdminLayoutLeaveRouteWithChildren,
  AdminLayoutNotificationSettingsRoute: AdminLayoutNotificationSettingsRoute,
  AdminLayoutNotificationsRoute: AdminLayoutNotificationsRoute,
  AdminLayoutPayrollRoute: AdminLayoutPayrollRouteWithChildren,
  AdminLayoutProfileManagementRoute: AdminLayoutProfileManagementRoute,
  AdminLayoutProjectsRoute: AdminLayoutProjectsRoute,
  AdminLayoutReportsRoute: AdminLayoutReportsRoute,
  AdminLayoutTasksRoute: AdminLayoutTasksRoute,
  AdminLayoutUsersRoute: AdminLayoutUsersRoute,
  AdminLayoutIndexRoute: AdminLayoutIndexRoute,
  AdminLayoutOrganizationBranchesRoute: AdminLayoutOrganizationBranchesRoute,
  AdminLayoutOrganizationDepartmentsRoute:
    AdminLayoutOrganizationDepartmentsRoute,
  AdminLayoutOrganizationDeviceEmployeesRoute:
    AdminLayoutOrganizationDeviceEmployeesRoute,
  AdminLayoutOrganizationDevicesRoute: AdminLayoutOrganizationDevicesRoute,
  AdminLayoutOrganizationFiscalYearsRoute:
    AdminLayoutOrganizationFiscalYearsRoute,
  AdminLayoutOrganizationRolesRoute: AdminLayoutOrganizationRolesRoute,
  AdminLayoutOvertimeMonitoringRoute: AdminLayoutOvertimeMonitoringRoute,
  AdminLayoutProjectsIdRoute: AdminLayoutProjectsIdRoute,
  AdminLayoutReportsUserIdRoute: AdminLayoutReportsUserIdRoute,
  AdminLayoutTasksIdRoute: AdminLayoutTasksIdRoute,
  AdminLayoutUsersIdRoute: AdminLayoutUsersIdRoute,
  AdminLayoutOvertimeMonitoringIdRoute: AdminLayoutOvertimeMonitoringIdRoute,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface SupervisorLayoutRouteChildren {
  SupervisorLayoutApprovalsRoute: typeof SupervisorLayoutApprovalsRoute
  SupervisorLayoutNotificationsRoute: typeof SupervisorLayoutNotificationsRoute
  SupervisorLayoutOvertimeApprovalsRoute: typeof SupervisorLayoutOvertimeApprovalsRoute
  SupervisorLayoutOvertimeRequestsRoute: typeof SupervisorLayoutOvertimeRequestsRoute
  SupervisorLayoutRequestsRoute: typeof SupervisorLayoutRequestsRoute
  SupervisorLayoutTeamRoute: typeof SupervisorLayoutTeamRoute
  SupervisorLayoutTeamTimesheetRoute: typeof SupervisorLayoutTeamTimesheetRoute
  SupervisorLayoutIndexRoute: typeof SupervisorLayoutIndexRoute
  SupervisorLayoutApprovalsIdRoute: typeof SupervisorLayoutApprovalsIdRoute
  SupervisorLayoutOvertimeApprovalsIdRoute: typeof SupervisorLayoutOvertimeApprovalsIdRoute
  SupervisorLayoutOvertimeRequestsIdRoute: typeof SupervisorLayoutOvertimeRequestsIdRoute
  SupervisorLayoutRequestsIdRoute: typeof SupervisorLayoutRequestsIdRoute
  SupervisorLayoutTeamIdRoute: typeof SupervisorLayoutTeamIdRoute
}

const SupervisorLayoutRouteChildren: SupervisorLayoutRouteChildren = {
  SupervisorLayoutApprovalsRoute: SupervisorLayoutApprovalsRoute,
  SupervisorLayoutNotificationsRoute: SupervisorLayoutNotificationsRoute,
  SupervisorLayoutOvertimeApprovalsRoute:
    SupervisorLayoutOvertimeApprovalsRoute,
  SupervisorLayoutOvertimeRequestsRoute: SupervisorLayoutOvertimeRequestsRoute,
  SupervisorLayoutRequestsRoute: SupervisorLayoutRequestsRoute,
  SupervisorLayoutTeamRoute: SupervisorLayoutTeamRoute,
  SupervisorLayoutTeamTimesheetRoute: SupervisorLayoutTeamTimesheetRoute,
  SupervisorLayoutIndexRoute: SupervisorLayoutIndexRoute,
  SupervisorLayoutApprovalsIdRoute: SupervisorLayoutApprovalsIdRoute,
  SupervisorLayoutOvertimeApprovalsIdRoute:
    SupervisorLayoutOvertimeApprovalsIdRoute,
  SupervisorLayoutOvertimeRequestsIdRoute:
    SupervisorLayoutOvertimeRequestsIdRoute,
  SupervisorLayoutRequestsIdRoute: SupervisorLayoutRequestsIdRoute,
  SupervisorLayoutTeamIdRoute: SupervisorLayoutTeamIdRoute,
}

const SupervisorLayoutRouteWithChildren =
  SupervisorLayoutRoute._addFileChildren(SupervisorLayoutRouteChildren)

interface UserLayoutAttendanceRouteChildren {
  UserLayoutAttendanceAdjustmentsRoute: typeof UserLayoutAttendanceAdjustmentsRoute
  UserLayoutAttendanceShiftsRoute: typeof UserLayoutAttendanceShiftsRoute
  UserLayoutAttendanceTimesheetRoute: typeof UserLayoutAttendanceTimesheetRoute
  UserLayoutAttendanceIndexRoute: typeof UserLayoutAttendanceIndexRoute
}

const UserLayoutAttendanceRouteChildren: UserLayoutAttendanceRouteChildren = {
  UserLayoutAttendanceAdjustmentsRoute: UserLayoutAttendanceAdjustmentsRoute,
  UserLayoutAttendanceShiftsRoute: UserLayoutAttendanceShiftsRoute,
  UserLayoutAttendanceTimesheetRoute: UserLayoutAttendanceTimesheetRoute,
  UserLayoutAttendanceIndexRoute: UserLayoutAttendanceIndexRoute,
}

const UserLayoutAttendanceRouteWithChildren =
  UserLayoutAttendanceRoute._addFileChildren(UserLayoutAttendanceRouteChildren)

interface UserLayoutCrmRouteChildren {
  UserLayoutCrmAccountsRoute: typeof UserLayoutCrmAccountsRoute
  UserLayoutCrmCalendarRoute: typeof UserLayoutCrmCalendarRoute
  UserLayoutCrmCallsRoute: typeof UserLayoutCrmCallsRoute
  UserLayoutCrmCasesRoute: typeof UserLayoutCrmCasesRoute
  UserLayoutCrmContactsRoute: typeof UserLayoutCrmContactsRoute
  UserLayoutCrmEmailsRoute: typeof UserLayoutCrmEmailsRoute
  UserLayoutCrmLeadsRoute: typeof UserLayoutCrmLeadsRoute
  UserLayoutCrmMeetingsRoute: typeof UserLayoutCrmMeetingsRoute
  UserLayoutCrmNoAccessRoute: typeof UserLayoutCrmNoAccessRoute
  UserLayoutCrmOpportunitiesRoute: typeof UserLayoutCrmOpportunitiesRoute
  UserLayoutCrmReportsRoute: typeof UserLayoutCrmReportsRoute
  UserLayoutCrmTasksRoute: typeof UserLayoutCrmTasksRoute
  UserLayoutCrmTeamsRoute: typeof UserLayoutCrmTeamsRoute
  UserLayoutCrmAccountsIdRoute: typeof UserLayoutCrmAccountsIdRoute
  UserLayoutCrmCasesIdRoute: typeof UserLayoutCrmCasesIdRoute
  UserLayoutCrmContactsIdRoute: typeof UserLayoutCrmContactsIdRoute
  UserLayoutCrmLeadsIdRoute: typeof UserLayoutCrmLeadsIdRoute
  UserLayoutCrmOpportunitiesIdRoute: typeof UserLayoutCrmOpportunitiesIdRoute
  UserLayoutCrmTasksIdRoute: typeof UserLayoutCrmTasksIdRoute
}

const UserLayoutCrmRouteChildren: UserLayoutCrmRouteChildren = {
  UserLayoutCrmAccountsRoute: UserLayoutCrmAccountsRoute,
  UserLayoutCrmCalendarRoute: UserLayoutCrmCalendarRoute,
  UserLayoutCrmCallsRoute: UserLayoutCrmCallsRoute,
  UserLayoutCrmCasesRoute: UserLayoutCrmCasesRoute,
  UserLayoutCrmContactsRoute: UserLayoutCrmContactsRoute,
  UserLayoutCrmEmailsRoute: UserLayoutCrmEmailsRoute,
  UserLayoutCrmLeadsRoute: UserLayoutCrmLeadsRoute,
  UserLayoutCrmMeetingsRoute: UserLayoutCrmMeetingsRoute,
  UserLayoutCrmNoAccessRoute: UserLayoutCrmNoAccessRoute,
  UserLayoutCrmOpportunitiesRoute: UserLayoutCrmOpportunitiesRoute,
  UserLayoutCrmReportsRoute: UserLayoutCrmReportsRoute,
  UserLayoutCrmTasksRoute: UserLayoutCrmTasksRoute,
  UserLayoutCrmTeamsRoute: UserLayoutCrmTeamsRoute,
  UserLayoutCrmAccountsIdRoute: UserLayoutCrmAccountsIdRoute,
  UserLayoutCrmCasesIdRoute: UserLayoutCrmCasesIdRoute,
  UserLayoutCrmContactsIdRoute: UserLayoutCrmContactsIdRoute,
  UserLayoutCrmLeadsIdRoute: UserLayoutCrmLeadsIdRoute,
  UserLayoutCrmOpportunitiesIdRoute: UserLayoutCrmOpportunitiesIdRoute,
  UserLayoutCrmTasksIdRoute: UserLayoutCrmTasksIdRoute,
}

const UserLayoutCrmRouteWithChildren = UserLayoutCrmRoute._addFileChildren(
  UserLayoutCrmRouteChildren,
)

interface UserLayoutRouteChildren {
  UserLayoutAttendanceRoute: typeof UserLayoutAttendanceRouteWithChildren
  UserLayoutCalendarRoute: typeof UserLayoutCalendarRoute
  UserLayoutChangePasswordRoute: typeof UserLayoutChangePasswordRoute
  UserLayoutCrmRoute: typeof UserLayoutCrmRouteWithChildren
  UserLayoutExpenseRoute: typeof UserLayoutExpenseRoute
  UserLayoutLeaveRoute: typeof UserLayoutLeaveRoute
  UserLayoutMyActivityRoute: typeof UserLayoutMyActivityRoute
  UserLayoutMyProjectsRoute: typeof UserLayoutMyProjectsRoute
  UserLayoutMyTasksRoute: typeof UserLayoutMyTasksRoute
  UserLayoutNotificationsRoute: typeof UserLayoutNotificationsRoute
  UserLayoutOvertimeRoute: typeof UserLayoutOvertimeRoute
  UserLayoutProfileManagementRoute: typeof UserLayoutProfileManagementRoute
  UserLayoutTeamLeaveRoute: typeof UserLayoutTeamLeaveRoute
  UserLayoutIndexRoute: typeof UserLayoutIndexRoute
  UserLayoutExpenseIdRoute: typeof UserLayoutExpenseIdRoute
  UserLayoutInventoryDeploymentManifestsRoute: typeof UserLayoutInventoryDeploymentManifestsRoute
  UserLayoutInventoryRequisitionsRoute: typeof UserLayoutInventoryRequisitionsRoute
  UserLayoutLeaveIdRoute: typeof UserLayoutLeaveIdRoute
  UserLayoutMyProjectsIdRoute: typeof UserLayoutMyProjectsIdRoute
  UserLayoutMyTasksIdRoute: typeof UserLayoutMyTasksIdRoute
  UserLayoutOrganizationDocumentsRoute: typeof UserLayoutOrganizationDocumentsRoute
  UserLayoutOvertimeIdRoute: typeof UserLayoutOvertimeIdRoute
  UserLayoutInventoryRequisitionsIdRoute: typeof UserLayoutInventoryRequisitionsIdRoute
}

const UserLayoutRouteChildren: UserLayoutRouteChildren = {
  UserLayoutAttendanceRoute: UserLayoutAttendanceRouteWithChildren,
  UserLayoutCalendarRoute: UserLayoutCalendarRoute,
  UserLayoutChangePasswordRoute: UserLayoutChangePasswordRoute,
  UserLayoutCrmRoute: UserLayoutCrmRouteWithChildren,
  UserLayoutExpenseRoute: UserLayoutExpenseRoute,
  UserLayoutLeaveRoute: UserLayoutLeaveRoute,
  UserLayoutMyActivityRoute: UserLayoutMyActivityRoute,
  UserLayoutMyProjectsRoute: UserLayoutMyProjectsRoute,
  UserLayoutMyTasksRoute: UserLayoutMyTasksRoute,
  UserLayoutNotificationsRoute: UserLayoutNotificationsRoute,
  UserLayoutOvertimeRoute: UserLayoutOvertimeRoute,
  UserLayoutProfileManagementRoute: UserLayoutProfileManagementRoute,
  UserLayoutTeamLeaveRoute: UserLayoutTeamLeaveRoute,
  UserLayoutIndexRoute: UserLayoutIndexRoute,
  UserLayoutExpenseIdRoute: UserLayoutExpenseIdRoute,
  UserLayoutInventoryDeploymentManifestsRoute:
    UserLayoutInventoryDeploymentManifestsRoute,
  UserLayoutInventoryRequisitionsRoute: UserLayoutInventoryRequisitionsRoute,
  UserLayoutLeaveIdRoute: UserLayoutLeaveIdRoute,
  UserLayoutMyProjectsIdRoute: UserLayoutMyProjectsIdRoute,
  UserLayoutMyTasksIdRoute: UserLayoutMyTasksIdRoute,
  UserLayoutOrganizationDocumentsRoute: UserLayoutOrganizationDocumentsRoute,
  UserLayoutOvertimeIdRoute: UserLayoutOvertimeIdRoute,
  UserLayoutInventoryRequisitionsIdRoute:
    UserLayoutInventoryRequisitionsIdRoute,
}

const UserLayoutRouteWithChildren = UserLayoutRoute._addFileChildren(
  UserLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authLogoutRoute: authLogoutRoute,
  authPasswordChangeRoute: authPasswordChangeRoute,
  authVerifyOtpRoute: authVerifyOtpRoute,
  legalPrivacyPolicyRoute: legalPrivacyPolicyRoute,
  legalTermsOfServiceRoute: legalTermsOfServiceRoute,
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
  SupervisorLayoutRoute: SupervisorLayoutRouteWithChildren,
  UserLayoutRoute: UserLayoutRouteWithChildren,
  authResetPasswordTokenRoute: authResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
